import React, { useEffect, useState, ChangeEvent, useRef, HtmlHTMLAttributes, useMemo } from "react";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
    TextField,
    Grid,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Button,
    InputAdornment,
    IconButton,
    Typography,
    Box,
    Stack,
    Modal,
    Divider,
    SvgIcon,
    Autocomplete,
    Switch,
    CircularProgress,
    TextareaAutosize,
    Tooltip,
    Collapse,
    Paper,
    FormControlLabel,
    Checkbox,
    LinearProgress,
    RadioGroup,
    Radio,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    Menu,
    Chip,
    Avatar,
    Skeleton
} from "@mui/material";
import { AudioItem, VideoItem, DocumentItem, CourseDetails, GetCourseDetailsResponse } from "redux/api/types";
import MicIcon from "@mui/icons-material/Mic";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import Header from "../../../components/headers/Header";
import Ocesha_header from "pages/ocesha_landing/ocesha_header";
import AddIcon from '@mui/icons-material/Add';
import '../generated_blogs.css';
import './CreateCourse.module.css';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { ReactComponent as CardIcon } from '../../../assets/card_ico.svg';
import { ReactComponent as TwitterIcon } from '../../../assets/traffic_monster/icon_twitter.svg';
// import { ReactComponent as XIcon } from '../../../assets/traffic_monster/x_ico.svg';
import { ReactComponent as PinterestIcon } from '../../../assets/traffic_monster/pinterest_ico.svg';
import { ReactComponent as FacebookIcon } from '../../../assets/traffic_monster/fb_ico.svg';
import { ReactComponent as LinkedinIcon } from '../../../assets/traffic_monster/linkedIn_ico.svg';
import { ReactComponent as StepArrowIcon } from '../../../assets/img/vector-5-2.svg';
import bulletChecked from "../../../assets/img/vector-8.svg"; // hollow bullet
import { CheckBox, FormatColorFill, Height, Widgets } from "@mui/icons-material";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { ReactComponent as VerifiedIcon } from '../../../assets/verified_ico.svg';
import { isBrowser, isMobile } from "react-device-detect";
import { useCreateCampaignMutation } from "../../../redux/api/promptApi";
import { toast } from "react-toastify";
import { useLazyCreateCheckoutSessionQuery } from "../../../redux/api/subscriptionApi";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { usePlanDetailsMutation, useCampaignDetailsMutation } from "../../../redux/api/productApi";
import { useGetUserDetailsMutation } from "../../../redux/api/authApi";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetpagefrocampaignMutation, useGetCnameEntriesMutation, useUpdateAutoPublishFlagMutation, useGetverifyscriptMutation, useCheckverifiedMutation } from "../../../redux/api/promptApi";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { id } from "date-fns/locale";
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { IPlanDetail } from "../../../redux/api/types";
import { useLazyGetProductQuery } from '../../../redux/api/productApi';
import { useAppSelector } from '../../../redux/store';
import { ReactComponent as Twitterico } from '../../../assets/traffic_monster/twitter__ico.svg';
import { ReactComponent as Pinterestico } from '../../../assets/traffic_monster/pinterest__ico.svg';
import { ReactComponent as Fbico } from '../../../assets/traffic_monster/fb__ico.svg';
import { ReactComponent as Linkedinico } from '../../../assets/traffic_monster/linkedin__ico.svg';
import axios from 'axios';
import { useCampaignListMutation } from "../../../redux/api/promptApi";
import InfoIcon from '@mui/icons-material/Info';
import YouTubeIcon from '@mui/icons-material/YouTube';
import youtubeIco1 from '../../../assets/traffic_monster/youtubeIco_1.png'
import { upload } from "@testing-library/user-event/dist/upload";
import ProgressBar from "@ramonak/react-progress-bar";
import { setCookie, getCookie, removeCookie } from '../../../utils/storageUtils';
import { urPK } from "@mui/x-date-pickers";
import { useAppDispatch } from "../../../redux/store";
import { logout } from "redux/features/userSlice";
import ocesha_logo from '../../../assets/ocesha_images/ocesha_logo.png';
import { ReactComponent as BlogsIco } from '../../../assets/ocesha_images/blogs_ico.svg';
import { ReactComponent as VideoIco } from '../../../assets/ocesha_images/video_ico.svg';
import { ReactComponent as AudioIco } from '../../../assets/ocesha_images/audio_ico.svg';
import { ReactComponent as ImagesIco } from '../../../assets/ocesha_images/images_ico.svg';
import { ReactComponent as ClipIco } from '../../../assets/ocesha_images/clip_ico.svg';
import { ReactComponent as TeamIco } from '../../../assets/ocesha_images/team_ico.svg';
import { ReactComponent as IntegrationIco } from '../../../assets/ocesha_images/integration_ico.svg';
import { ReactComponent as UpgradeIco } from '../../../assets/ocesha_images/upgrade_ico.svg';
import { ReactComponent as BillingIco } from '../../../assets/ocesha_images/billing_ico.svg';
import { ReactComponent as SettingsIco } from '../../../assets/ocesha_images/settings_ico.svg';
import { ReactComponent as HelpIco } from '../../../assets/ocesha_images/help_ico.svg';
import { ReactComponent as LogoutIco } from '../../../assets/ocesha_images/logout_ico.svg';
import { ReactComponent as DashboardIco } from '../../../assets/ocesha_images/dashboard_ico.svg';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
// import uploadIcon from "../../../assets/img/upload-cloud.svg";
import checkGreen from "../../../assets/podcast_monster/vector-7.svg"; // green check
import audioIcon from "../../../assets/img/icon-audio.svg";
import videoIcon from "../../../assets/img/icon-video.svg";
import docIcon from "../../../assets/img/icon-doc.svg";
import youtubeIcon from "../../../assets/img/icon-youtube.svg";
import linkIcon from "../../../assets/img/icon-link.svg";
import textIcon from "../../../assets/img/icon-text.svg";
import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined';
import VolumeOffOutlinedIcon from '@mui/icons-material/VolumeOffOutlined';
import VolumeUpOutlinedIcon from "@mui/icons-material/VolumeUpOutlined";
import SendIcon from "@mui/icons-material/Send";
import { ReactComponent as EditIco } from '../../../assets/podcast_monster/edit_ico.svg';
import RohanImg from '../../../assets/podcast_monster/rohan_png.png';
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { ReactComponent as CloudIcon } from '../../../assets/podcast_monster/cloud.svg';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import { TTSButton } from "../../../components/TTSPlayer";
import { speakText, stopTTS } from "../../../redux/features/ttsSlice";
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import profileimage from '../../../assets/newimg/sampleprofile.avif';
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { useTTSQueue } from "hooks/useTTSQueue";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ImportContactsOutlinedIcon from '@mui/icons-material/ImportContactsOutlined';
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import uploadIcon from '../../../assets/ocesha_images/cloud_upload.svg';
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import TitleIcon from '@mui/icons-material/Title';
import SmartDisplayOutlinedIcon from "@mui/icons-material/SmartDisplayOutlined";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { getGreetingUrl, localizedClipUrl } from "../../../utils/voiceClips";
import { redirectAfterLogout } from "../../../utils/logoutRedirect";
// intro clip in the site language (falls back to the English WAV)
const localizedIntro = { current: "" };


<StepArrowIcon
    style={{
        width: 20,
        height: 20,
        margin: '0 12px',
        opacity: 0.6,
    }}
/>

const ONBOARDING_QUESTIONS = [
    {
        id: 1,
        text: "Tell me your name and a bit about who you are.",
        isCompleted: true,
    },
    {
        id: 2,
        text: "What topics do you speak or teach about?",
        isCompleted: true,
    },
    {
        id: 3,
        text: "Who do you help or who is your audience?",
        isCompleted: false,
    },
    {
        id: 4,
        text: "What results do you help people achieve?",
        isCompleted: false,
    },
    {
        id: 5,
        text: "What type of courses would you love to create if it were easy?",
        isCompleted: false,
    },
];

const COURSE_STEPS = [
    {
        number: "01",
        title: "Share your\nExpertise",
        isActive: true,
    },
    {
        number: "02",
        title: "Upload Content\nto Train",
        isActive: false,
    },
    {
        number: "03",
        title: "Choose your\nCourse Topic",
        isActive: false,
    },
    {
        number: "04",
        title: "Generate your\nCourse",
        isActive: false,
    },
];

interface ErrorResponse {
    error: {
        status: number;
        data: {
            detail: string;
        };
    };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        // backgroundColor: '#D0D5DD',
        color: 'lightblack',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const getUploadContentType = (filePath: string) => {
    const ext = filePath.split(".").pop()?.toLowerCase();

    const audioExts = ["mp3", "wav", "aac", "ogg", "flac", "m4a"];
    const videoExts = ["mp4", "mov", "avi", "mkv", "webm"];

    if (audioExts.includes(ext || "")) return "audio";
    if (videoExts.includes(ext || "")) return "video";

    return null;
};


const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: 'white', // Set background color for odd rows to white
        color: 'black', // Set text color for odd rows to black
    },
    '&:nth-of-type(even)': {
        backgroundColor: '#F2F6FA', // Set background color for even rows to gray
        color: 'darkslategray',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const HeaderCell = styled('div')(({ theme }) => ({
    color: '#626F86',
    fontWeight: 'bold',
    fontSize: '14px',
    padding: '12px',
    textAlign: 'center',
    '&:nth-child(odd)': {
        backgroundColor: '#EAECF0',
    },
    '&:nth-child(even)': {
        backgroundColor: '#F5F5F5',
    }
}));

const DataCell = styled('div')(({ theme }) => ({
    color: '#344054',
    fontSize: '14px',
    padding: '12px',
    textAlign: 'center',
    '&:nth-child(odd)': {
        backgroundColor: '#EAECF0',
    },
    '&:nth-child(even)': {
        backgroundColor: '#F5F5F5',
    }
}));

let newErrors = {
    name: ''
};

const customInputStyle = {
    color: 'black',
    border: newErrors.name ? '1px solid red' : '1px solid gray',
};

type UploadedItem =
    | string
    | {
        label: string;
        deletable: boolean;
        index?: number;
        isTranscribing?: boolean;
        clipPending?: boolean;
        serverProcessing?: boolean;
    };

interface UploadedGroupProps {
    icon: string;
    title: string;
    items: UploadedItem[];
    onDelete?: (index: number) => void;
}


type ProcessingStatus = "pending" | "in_progress" | "complete" | "failed";
type ProcessingContentType = "audio" | "video" | "youtube_urls" | "web_urls";

export const updateProcessingStatus = async (params: {
    content_type: ProcessingContentType;
    identifier: string;
    progress: number;
    status: ProcessingStatus;
}) => {
    const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";
    const courseId = localStorage.getItem("course_id");

    if (!courseId) throw new Error("Course ID missing");

    return axios.post(`${apiUrl}/api/prompts/update_course_progress`, {
        course_id: courseId,
        ...params,
    });
};


const updateAllProcessingStatuses = async (course: any) => {
    try {
        // ---- AUDIO ----
        // alert('test.....3');
        // if (Array.isArray(course.audio)) {
        //     for (const audio of course.audio) {            
        //         await updateProcessingStatus({
        //             content_type: "audio",
        //             identifier: audio.path,
        //             progress: 0,
        //             status: "pending",
        //         });
        //     }
        // }

        // ---- VIDEO ----
        // if (Array.isArray(course.video)) {
        //     for (const video of course.video) {
        //         //alert(video.status+"---"+video.progress+"---"+video.path);
        //         await updateProcessingStatus({
        //             content_type: "video",
        //             identifier: video.path,
        //             progress: 0,
        //             status: "pending",
        //         });
        //     }
        // }

        //alert('test.....4');

        // ---- YOUTUBE URLS ----
        if (Array.isArray(course.youtube_urls)) {
            for (const item of course.youtube_urls) {
                await updateProcessingStatus({
                    content_type: "youtube_urls",
                    identifier: item.url,
                    progress: 0,
                    status: "pending",
                });
            }
        }

        // ---- WEB URLS ----
        if (Array.isArray(course.web_urls)) {
            for (const item of course.web_urls) {
                await updateProcessingStatus({
                    content_type: "web_urls",
                    identifier: item.url,
                    progress: 0,
                    status: "pending",
                });
            }
        }

        console.log("All processing statuses initialized");
    } catch (err) {
        console.error("Failed to update processing status", err);
    }
};



const UploadedGroup = ({ icon, title, items, onDelete }: UploadedGroupProps) => (
    <Box mb={2.5}>
        <Stack direction="row" spacing={1.5} alignItems="center" mb={1}>
            <Box component="img" src={icon} sx={{ width: 18 }} />
            <Typography color="white" fontWeight={'normal'}>
                {title}
            </Typography>
        </Stack>

        {items.map((item, i) => {
            const label = typeof item === "string" ? item : item.label;
            const deletable = typeof item !== "string" && item.deletable;
            const index = typeof item !== "string" ? item.index : undefined;
            const isTranscribing = typeof item !== "string" && (item as any).isTranscribing;
            const clipPending = typeof item !== "string" && (item as any).clipPending;
            const serverProcessing = typeof item !== "string" && (item as any).serverProcessing;

            return (
                <Stack key={i} direction="row" spacing={1.5} alignItems="center" ml={4} mb={0.5}>
                    <Box
                        sx={{
                            width: 8,
                            height: 8,
                            borderRadius: "50%",
                            background: isTranscribing
                                ? "#4BA5EB"
                                : clipPending
                                    ? "#F59E0B"   // amber while clip is generating
                                    : "#22C55E",
                        }}
                    />

                    <Typography
                        color="#D9D9D9"
                        fontSize="14px"
                        sx={{
                            flex: 1,
                            maxHeight: "300px",
                            overflowY: "auto",
                            whiteSpace: "pre-wrap",
                            pr: 1,
                            "&::-webkit-scrollbar": {
                                width: "6px",
                            },
                            "&::-webkit-scrollbar-thumb": {
                                background: "rgba(255,255,255,0.2)",
                                borderRadius: "3px",
                            },
                            "&::-webkit-scrollbar-track": {
                                background: "transparent",
                            },
                        }}
                    >
                        {label}
                    </Typography>

                    {/* transcribing spinner */}
                    {serverProcessing && !isTranscribing && (
                        <Stack direction="row" spacing={0.7} alignItems="center">
                            <CircularProgress size={14} sx={{ color: "#4BA5EB" }} />
                            <Typography fontSize="12px" color="#4BA5EB">
                                Transcription is in process…
                            </Typography>
                        </Stack>
                    )}

                    {/* NEW: clip-generation in progress */}
                    {clipPending && !isTranscribing && (
                        <Stack direction="row" spacing={0.7} alignItems="center">
                            <CircularProgress size={14} sx={{ color: "#F59E0B" }} />
                            <Typography fontSize="12px" color="#F59E0B">
                                Generating video clip…
                            </Typography>
                        </Stack>
                    )}

                    {deletable && onDelete && typeof index === "number" && !isTranscribing && (
                        <IconButton size="small" onClick={() => onDelete(index)}>
                            <DeleteOutlineIcon sx={{ color: "#EF4444" }} />
                        </IconButton>
                    )}
                </Stack>
            );
        })}
    </Box>
);


// ============== Transcription / scraping types (ported from New_Course_2) ==============
type MediaItem = { path: string; name: string; duration: string; progress: number; status: string; transcription?: string; clip_generated?: boolean; };
type ProcessingItemInternal = { identifier: string; name: string; progress: number; status: "pending" | "in_progress" | "complete" | "failed"; };
type ContentProcessingStatusInternal = { progress: number; status: "pending" | "in_progress" | "complete"; items: ProcessingItemInternal[]; };
type ProcessingStatusInternal = {
    overall_progress: number;
    overall_status: "pending" | "in_progress" | "complete";
    content: {
        audio: ContentProcessingStatusInternal;
        video: ContentProcessingStatusInternal;
        youtube_urls: ContentProcessingStatusInternal;
        web_urls: ContentProcessingStatusInternal;
        documents: ContentProcessingStatusInternal;
        text_documents: ContentProcessingStatusInternal;
    };
};
type ContentTypeKey = "audio" | "video" | "youtube_urls" | "web_urls";
type UpdateProcessingStatusParams = { courseId: string; contentType: ContentTypeKey; index: number; status: ProcessingItemInternal["status"]; progress: number; transcription?: string; identifier?: string; };
type TranscribeMediaParams = { courseId: string; media_file_path: string; original_filename: string; contentType: ContentTypeKey; auto_publish: any };
type ProcessMediaListParams = { courseId: string; mediaList: MediaItem[]; contentType: ContentTypeKey; };
type CourseMedia = { _id: string; audio?: { identifier: string }[]; video?: { identifier: string }[]; };

type ProcessingStage =
    | "idle"
    | "transcribing"
    | "combining_text"
    | "migrating"
    | "updating_skillset"
    | "done";

const audioBufferToWav = (buffer: AudioBuffer) => {
    const numOfChan = buffer.numberOfChannels;
    const length = buffer.length * numOfChan * 2 + 44;
    const bufferArray = new ArrayBuffer(length);
    const view = new DataView(bufferArray);

    let offset = 0;
    let pos = 0;

    const writeString = (str: string) => {
        for (let i = 0; i < str.length; i++) {
            view.setUint8(pos + i, str.charCodeAt(i));
        }
        pos += str.length;
    };

    // RIFF identifier
    writeString("RIFF");

    // file length
    view.setUint32(pos, length - 8, true);
    pos += 4;

    // RIFF type
    writeString("WAVE");

    // format chunk identifier
    writeString("fmt ");

    // format chunk length
    view.setUint32(pos, 16, true);
    pos += 4;

    // sample format (raw)
    view.setUint16(pos, 1, true);
    pos += 2;

    // channel count
    view.setUint16(pos, numOfChan, true);
    pos += 2;

    // sample rate
    view.setUint32(pos, buffer.sampleRate, true);
    pos += 4;

    // byte rate
    view.setUint32(
        pos,
        buffer.sampleRate * 2 * numOfChan,
        true
    );
    pos += 4;

    // block align
    view.setUint16(pos, numOfChan * 2, true);
    pos += 2;

    // bits per sample
    view.setUint16(pos, 16, true);
    pos += 2;

    // data chunk identifier
    writeString("data");

    // data chunk length
    view.setUint32(pos, length - pos - 4, true);
    pos += 4;

    const channels = [];

    for (let i = 0; i < numOfChan; i++) {
        channels.push(buffer.getChannelData(i));
    }

    offset = 0;

    while (pos < length) {
        for (let i = 0; i < numOfChan; i++) {
            const sample = Math.max(
                -1,
                Math.min(1, channels[i][offset])
            );

            view.setInt16(
                pos,
                sample < 0 ? sample * 0x8000 : sample * 0x7fff,
                true
            );

            pos += 2;
        }

        offset++;
    }

    return new Blob([bufferArray], {
        type: "audio/wav",
    });
};

interface DigitalTwinScreenProps {
    // Lets the parent (sidebar) know whether an upload is currently running here,
    // so it can warn the user before switching menus and killing the upload.
    onUploadStatusChange?: (isUploading: boolean) => void;
    cancelUploadRef?: React.MutableRefObject<(() => void) | undefined>;
}

const DigitalTwinScreen: React.FC<DigitalTwinScreenProps> = ({ onUploadStatusChange, cancelUploadRef }) => {

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();


    const { FromEdit } = location.state || {};
    const { campIdFrEdit } = location.state || {};
    const { subscriptionFromCampList } = location.state || {};
    const { subscriptionTH } = location.state || {};
    const { mode } = location.state || {};
    const FromSignUp = location.state?.FromSignUp || '';

    //console.log(subscriptionTH);
    //console.log(mode);
    const [sourceUrl, setSourceUrl] = useState<string>((localStorage.getItem('ErrorAlert') === 'true' && localStorage.getItem('UrlfromLanding')) ? localStorage.getItem('UrlfromLanding') || '' : '');
    const [blogcount, setBlogCount] = useState<any>(1);
    const [sourceYoutubeUrl, setSourceYoutubeUrl] = useState<any>((localStorage.getItem('ErrorAlert') === 'true' && localStorage.getItem('YoutubeUrlfromLanding')) ? localStorage.getItem('YoutubeUrlfromLanding') || '' : '');
    const [sourceText, setSourceText] = useState<string>('');
    const [videoTag, setVideoTag] = useState<string>(sourceYoutubeUrl || '');
    const [twitterUrl, settwitterUrl] = useState<string>('');
    const [fbUrl, setfbUrl] = useState<string>('');
    const [pintrestUrl, setPintrestUrl] = useState<string>('');
    const [linkedinUrl, setLinkedinUrl] = useState<string>('');
    const [ctaLabel, setCtaLabel] = useState<string>('');
    const [ctaLink, setCtaLink] = useState<string>('');
    const [isEditing, setIsEditing] = useState(false);
    const [userInput, setUserInput] = useState(
        "My name is Sarah Jackson and i am a professional speech therapy trainer...",
    );
    const [introInput, setIntroInput] = useState(
        "Do you have any questions ask me...",
    );
    const [expertise, setExpertise] = useState(
        'My name is Sarah Jackson and I am a professional speech therapy trainer...'
    );
    const [isRecording, setIsRecording] = useState(false);
    const mediaRecorderRef = useRef<MediaRecorder | null>(null);
    const audioChunksRef = useRef<BlobPart[]>([]);

    const [isRecording1, setIsRecording1] = useState(false);
    const [mediaRecorder1, setMediaRecorder1] = useState<MediaRecorder | null>(null);

    // Chat + Audio state
    const [questionText, setQuestionText] = useState("");
    const [chatMessages, setChatMessages] = useState<any[]>([]);
    const [isChatLoading, setIsChatLoading] = useState(false);
    const [lastBotText, setLastBotText] = useState<string>("");
    const prevTextRef = useRef("");

    // const audioRef = useRef<HTMLAudioElement | null>(null);
    const [isMuted, setIsMuted] = useState(false);
    const hasFetched = useRef(false);
    const hasFetchedUD = useRef(false);

    const [isListening, setIsListening] = useState(false);
    const [isListening1, setIsListening1] = useState(false);
    const textareaRef = useRef<HTMLTextAreaElement | null>(null);
    const recognitionRef = useRef<any>(null);
    const recognitionRef1 = useRef<any>(null);
    const recognitionRef2 = useRef<any>(null);
    const [isListening2, setIsListening2] = useState(false);
    const [DTConcernVal, setDTConcernVal] = useState<any>();

    const [campaignName, setCampaignName] = useState<string>('');
    const [urlPrefix, setUrlPrefix] = useState<string>((localStorage.getItem('ErrorAlert') === 'true' && localStorage.getItem('YoutubeUrlfromLanding')) ? 'youtubeid' : (localStorage.getItem('ErrorAlert') === 'true' && localStorage.getItem('UrlfromLanding')) ? 'https://' : 'word');
    const [expanded, setExpanded] = useState(true);
    const [expanded1, setExpanded1] = useState(true);
    const [expanded2, setExpanded2] = useState(false);
    const [expanded3, setExpanded3] = useState(false);
    const [expanded4, setExpanded4] = useState(false);
    const [expanded5, setExpanded5] = useState(false);
    const [expanded6, setExpanded6] = useState(false);
    const [expanded7, setExpanded7] = useState(false);
    const [expanded8, setExpanded8] = useState(false);
    const [expanded9, setExpanded9] = useState(false);
    const [expanded10, setExpanded10] = useState(false);
    const [expanded11, setExpanded11] = useState(false);
    const [expanded12, setExpanded12] = useState(false);
    const [expanded14, setExpanded14] = useState(false);
    const [expanded15, setExpanded15] = useState(false);
    const [expanded13, setExpanded13] = useState(false);
    const [planDetails, setPlanDetails] = useState<any>();
    const [campDetails, setCampDetails] = useState<any>();
    const [defaultPlanDetails, setDefaultPlanDetails] = useState<any>();
    const [campaignId, setCampaignId] = useState<any>();
    const [userDetails, setUserDetails] = useState<any>();
    const [openpaymentInstructModal, setOpenPaymentInstructModal] = useState<boolean>(false);
    const [paymentOption, setPaymentOption] = useState<any>();
    const [paymentOptYearlyCal, setPaymentOptYearlyCal] = useState<any>();
    const paymentSectionRef = useRef<HTMLDivElement>(null);
    const getcnameEntriesRef = useRef<HTMLDivElement>(null);
    const getVerifyScript = useRef<HTMLDivElement>(null);
    const [autoPublish, setAutopublish] = useState<any>(false);
    const [publishToOcesha, setPublishToOcesha] = useState<any>(false);
    const [publishToCodegenie, setPublishToCodegenie] = useState<any>(false);
    const [competitorSearch, setCompetitorSearch] = useState<any>(false);
    const [limitPublish, setLimitPublish] = useState<any>(true);
    const [socialMediaUrlPublish, setSocialMediaUrlPublish] = useState<any>();
    const [addtags, setAddTags] = useState<any>(true);
    const [externalLinks, setExternalLinks] = useState<any>(true);
    const [toc, setToc] = useState<any>(true);
    const [capturleads, setCapturLeads] = useState<any>(!!planDetails?.embed_contact_form_newsletters_social_media_share);
    const [newsletter, setNewsLetter] = useState<any>(!!planDetails?.embed_contact_form_newsletters_social_media_share);
    const [twitternbutton, setTwitternButton] = useState<any>(!!planDetails?.embed_contact_form_newsletters_social_media_share);
    const [fbbutton, setFbButton] = useState<any>(!!planDetails?.embed_contact_form_newsletters_social_media_share);
    const [pintrestbutton, setPintrestButton] = useState<any>(true);
    const [linkedinbutton, setLinkedinButton] = useState<any>(!!planDetails?.embed_contact_form_newsletters_social_media_share);
    const [video, setVideo] = useState<any>(!!planDetails?.embed_youtube_video);
    const [useOwnDomain, setUseOwnDomain] = useState<any>(false);
    const [isloadingGetPage, setIsLoadingGetPage] = useState<boolean>(false);
    const [openGetPagesuccessModal, setOpenGetPageSuccessModal] = useState<boolean>(false);
    const [confirmCancelSubscription, setConfirmCancelSubscription] = useState<boolean>(false);
    const [cnameRecords, setCnameRecords] = useState<any>();
    const [cnameDomainName, setCnameDomainName] = useState<any>();
    const [isLoadingCnameRec, setIsLoadingCnameRec] = useState<boolean>(false);
    const getpageRunref = useRef(false);
    const [script, setScript] = useState<any>();
    const [verifyCheck, setVerifyCheck] = useState<any>();
    const [period, getPeriodState] = useState("monthly");
    const [createCampaignMutation] = useCreateCampaignMutation();
    const user_email = localStorage.getItem('user_email') || getCookie('user_email') || '';
    const [isUpdateLoader, setIsUpdateLoader] = useState<boolean>(false);
    const [selectedSubscriptionLevel, setSelectedSubscriptionLevel] = useState<string>('');
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const fileInputRef1 = useRef<HTMLInputElement | null>(null);
    const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
    const emptyText = (label: string) => [`${label} not uploaded`];
    const [DTinstruction, setDTinstruction] = useState<any>();

    const [uploadedDuration, setUploadedDuration] = useState<string>("00:00");
    const [uploadedSize, setUploadedSize] = useState<string>("");
    const [loadingVoices, setLoadingVoices] = useState(false);

    const [autoPublishDialogOpen, setAutoPublishDialogOpen] = useState(false);
    const [selectedAutoPublish, setSelectedAutoPublish] = useState<number | null>(null);

    const [getProduct, getState] = useState<any>(); //useLazyGetProductQuery();
    const [plans, setPlans] = useState<IPlanDetail[]>([
        {
            user: 1,
            plan_name: "",
            total_wishes: 0,
            price: "",
            period: "",
            product_id: "",
            price_id: "",
            subscription_level: "",
            feature: [],
            contracts: 0,
            type: "",
            button_text: "",
            save: ''
        },
    ]);
    const [productModule, setProductModule] = useState("");
    const genieSelector = useAppSelector((state) => state.genieState);

    const [createCheckoutSession, checkoutState] = useLazyCreateCheckoutSessionQuery();
    const [getUserDetailsMutation] = useGetUserDetailsMutation();

    // console.log('is this from edit=>', FromEdit);
    const [getuserPlanDetails] = usePlanDetailsMutation();
    const [getuserCampDetails] = useCampaignDetailsMutation();
    const [getPageforCampaign] = useGetpagefrocampaignMutation();
    const [getCnameEntriesMutation] = useGetCnameEntriesMutation();
    const [getverifyscript] = useGetverifyscriptMutation();
    const [getcheckverified] = useCheckverifiedMutation();
    const [updateAutoPublishCheckMutation] = useUpdateAutoPublishFlagMutation();


    const [isAddContentDisabled, setIsAddContentDisabled] = useState(true);
    const [userImage, setUserImage] = useState<File | null>(null);
    const [userImageUrl, setUserImageUrl] = useState('');
    const [socialUrl, setSocialUrl] = useState('');
    const [name, setName] = useState('');
    const [useAsDefault, setUseAsDefault] = useState(false);
    const [cancellingLoader, setCancellingLoader] = useState<boolean>(false);
    const [campaignListMutation] = useCampaignListMutation();
    const [campaignDatas, setCampaignDatas] = useState<any>();
    const [couponCode, setCouponCode] = useState<string>('');
    const [successCancelSubscription, setSuccessCancelSubscription] = useState(false);
    const [podcastoryoutubeurl, setPodcastOrYoutubeUrl] = useState('');
    const [selectedSection, setSelectedSection] = useState('websiteSection');
    const [uploadVideo, setUploadVideo] = useState('');
    const [isUploadLoading, setIsUploadLoading] = useState(false);
    const [uploadedvideopath, setUploadedvideopath] = useState('');
    const [fileDuaration, setfileDuaration] = useState<any>();
    const [getPageError, setGetPageError] = useState(false);
    const [loaderProgress, setLoaderProgress] = useState<any>(4);
    const [userBusinessText, setUserBusinessText] = useState('');
    const [upgradeModal, setUpgradeModal] = useState<boolean>(false);
    const [course, setCourse] = useState<CourseDetails | null>(null);
    const [loading, setLoading] = useState(false);
    const [isupdating, setIsUpdating] = useState<boolean>(false);
    const [processingStage, setProcessingStage] = useState<ProcessingStage>("idle");
    const [voiceTrainProgress, setVoiceTrainProgress] = useState(0);
    const [lastUpdated, setLastUpdated] = useState("");
    const [imageVersion, setImageVersion] = useState(Date.now());

    const stageLabel = (() => {
        switch (processingStage) {
            case "transcribing": return "Transcribing your content…";
            case "combining_text": return "Organizing your content…";
            case "migrating": return "Building your podcast library…";
            case "updating_skillset": return "Updating your skillset & bio…";
            case "done": return "All set! Your Digital Twin is ready.";
            default: return "Uploading…";
        }
    })();

    // Prevents handleCreateCourseStep2 from being entered more than once concurrently
    // even if multiple uploads trigger autoTriggerCourseFlow in quick succession.
    const pipelineRunningRef = useRef(false);

    const [loadingText, setLoadingText] = useState<any>(
        <Typography fontSize="18px">
            <b>Analyzing Your Content...</b>
            <br />
            We’re using AI Agents to read through your content, analyze your content, and will suggest some ideas that we can write about
        </Typography>
    );

    const [deleteArgs, setDeleteArgs] = useState<{
        contentType: "audio" | "video" | "document" | "youtube" | "web" | "text";
        index: number;
    } | null>(null);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [deletePayload, setDeletePayload] = useState<{
        contentType: string;
        index: number;
    } | null>(null);
    const [intervaltime, setIntervalTime] = useState(4000);
    const handleCouponTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCouponCode(event.target.value);
    };
    const [helpervideosrc, setHelperVideoSrc] = useState<any>();
    const [helperPopup, setHelperPopup] = useState<boolean>(false);
    const [isScrapcheckloading, setIsScrapcheckloading] = useState<boolean>(false);
    const [activeItem, setActiveItem] = useState(localStorage.getItem('activeItem') || 'dashboard');
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [topics, setTopics] = useState<any>();
    const [topicsList, setTopicsList] = useState<boolean>(false);
    const [selectedTopic, setSelectedTopic] = useState<any>();
    const [keywords, setKeywords] = useState<any>();
    const [keywordsList, setKeywordsList] = useState<boolean>(false);
    const [selectedKeyword, setSelectedKeyword] = useState<any>();
    const [isKeywordLoader, setIsKeywordLoader] = useState<boolean>(false);
    const [voiceFiles, setVoiceFiles] = useState<File[]>([]);
    const [recordingTime, setRecordingTime] = useState(0);
    const timerRef = useRef<NodeJS.Timeout | null>(null);
    const [voiceName, setVoiceName] = useState('');
    const [uploadAnchorEl, setUploadAnchorEl] =
        React.useState<null | HTMLElement>(null);
    const autoAddRef = React.useRef(false);
    // Only allow auto transcription/pipeline after a user-initiated upload this session.
    // Page load / initial fetch must NOT trigger processing.
    const userUploadedRef = useRef(false);
    const abortControllerRef = useRef<AbortController | null>(null);
    const {
        playText,
        pause,
        resume,
        stop,
        isPlaying,
        audioRef,
    } = useTTSQueue();

    const openUploadMenu = Boolean(uploadAnchorEl);

    const handleUploadMenuOpen = (e: React.MouseEvent<HTMLElement>) => {
        setUploadAnchorEl(e.currentTarget);
    };
    const [isUploadingPhoto, setIsUploadingPhoto] = useState(false);
    const handleUploadMenuClose = () => {
        setUploadAnchorEl(null);
    };

    const isUploadOrProcessingActive = isloadingGetPage || isUploadingPhoto || isupdating;

    // 1) Tell the parent (sidebar) so it can confirm before switching menus.
    useEffect(() => {
        onUploadStatusChange?.(isUploadOrProcessingActive);
    }, [isUploadOrProcessingActive]);

    // 2) Warn on browser refresh / tab close / back-button while uploading.
    useEffect(() => {
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (isUploadOrProcessingActive) {
                e.preventDefault();
                e.returnValue = ""; // required for Chrome to show the native prompt
            }
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    }, [isUploadOrProcessingActive]);
    //console.log("localStorage......");
    //console.log(localStorage)
    useEffect(() => {
        if (cancelUploadRef) {
            cancelUploadRef.current = () => {
                abortControllerRef.current?.abort();
            };
        }
    }, []);

    const hasAnyContent = () => {
        return Boolean(
            course?.audio?.length ||
            course?.video?.length ||
            course?.documents?.length ||
            course?.youtube_urls?.length ||
            course?.web_urls?.length ||
            course?.text_documents?.length
        );
    };

    const requestDelete = (
        contentType: "audio" | "video" | "document" | "youtube" | "web" | "text",
        index: number
    ) => {
        setDeleteArgs({ contentType, index });
        setConfirmOpen(true);
    };

    const handleFilesUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files?.length) return;

        const file = e.target.files[0];
        setUploadedFiles([file]);

        const media = document.createElement(
            file.type.startsWith("audio") ? "audio" : "video"
        );

        media.preload = "metadata";
        media.src = URL.createObjectURL(file);

        media.onloadedmetadata = () => {
            URL.revokeObjectURL(media.src);

            const duration = media.duration;
            const minutes = Math.floor(duration / 60);
            const seconds = Math.floor(duration % 60);

            setUploadedDuration(
                `${minutes}:${seconds.toString().padStart(2, "0")}`
            );
        };
    };


    const startRecording = async (mode: string) => {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            console.error("mediaDevices not supported");
            return;
        }

        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

        const mediaRecorder = new MediaRecorder(stream, {
            mimeType: "audio/webm",
        });

        audioChunksRef.current = [];

        mediaRecorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
                audioChunksRef.current.push(event.data);
            }
        };

        mediaRecorder.onstop = () => sendAudioToBackend(mode);


        mediaRecorder.start();
        mediaRecorderRef.current = mediaRecorder;
        if (mode === "questions") {
            setIsRecording(true);
        }
    };

    const stopRecording = (mode: string) => {
        mediaRecorderRef.current?.stop();
        if (mode === "questions") {
            setIsRecording(false);
        }

    };


    const startRecording1 = async () => {
        try {
            setRecordingTime(0);

            timerRef.current = setInterval(() => {
                setRecordingTime((prev) => prev + 1);
            }, 1000);

            const stream = await navigator.mediaDevices.getUserMedia({
                audio: true,
            });

            const recorder = new MediaRecorder(stream);
            let audioChunks: any = [];

            recorder.ondataavailable = (event) => {
                audioChunks.push(event.data);
            };

            /* recorder.onstop = async () => {
                const audioBlob = new Blob(audioChunks, {
                    type: "audio/wav",
                });

                const audioUrl = URL.createObjectURL(audioBlob);

                const audioFile = new File(
                    [audioBlob],
                    `recording-${Date.now()}.wav`,
                    {
                        type: "audio/wav",
                    }
                );

                const fileWithPreview = Object.assign(audioFile, {
                    preview: audioUrl,
                });

                const updatedFiles = [...voiceFiles, fileWithPreview];

                setVoiceFiles(updatedFiles);

                await validateAndTrainVoice(updatedFiles);

                stream.getTracks().forEach((track) => track.stop());
            }; */
            recorder.onstop = async () => {
                try {
                    const audioBlob = new Blob(audioChunks, {
                        type: recorder.mimeType,
                    });

                    // Convert blob -> ArrayBuffer
                    const arrayBuffer = await audioBlob.arrayBuffer();

                    // Decode audio
                    const audioContext = new AudioContext();
                    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);

                    // Convert to WAV
                    const wavBlob = audioBufferToWav(audioBuffer);

                    const audioUrl = URL.createObjectURL(wavBlob);

                    const audioFile = new File(
                        [wavBlob],
                        `recording-${Date.now()}.wav`,
                        {
                            type: "audio/wav",
                        }
                    );

                    const fileWithPreview = Object.assign(audioFile, {
                        preview: audioUrl,
                    });

                    /* const updatedFiles = [...voiceFiles, fileWithPreview];

                    setVoiceFiles(updatedFiles);

                    await validateAndTrainVoice(updatedFiles); */
                    const updatedFiles = [...voiceFiles, fileWithPreview];

                    setVoiceFiles(updatedFiles);

                    // send ONLY newly recorded file
                    // await validateAndTrainVoice([audioFile]);

                    stream.getTracks().forEach((track) => track.stop());
                } catch (err) {
                    console.error("WAV conversion failed:", err);
                    toast.error("Failed to process recording");
                }
            };
            recorder.start();

            setMediaRecorder1(recorder);
            setIsRecording1(true);
        } catch (error) {
            console.error("Mic access denied", error);
        }
    };

    const stopRecording1 = async () => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
        if (mediaRecorder1) {
            mediaRecorder1.stop();
            setIsRecording1(false);
        }
    };

    useEffect(() => {
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
            }
        };
    }, []);

    const formatTime = (seconds: number) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;

        return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
    };

    const sendAudioToBackend = async (mode: string) => {
        const audioBlob = new Blob(audioChunksRef.current, {
            type: "audio/webm",
        });




        const formData = new FormData();
        formData.append("audio", audioBlob, "speech.webm");

        try {
            const res = await fetch(`${process.env.REACT_APP_SPEECH_TO_TEXT_SERVICE}/speech_to_text`, {
                method: "POST",
                body: formData,
            });

            const data = await res.json();

            // assuming FastAPI returns: { text: "..." }
            if (mode === "questions") {
                setQuestionText((prev) => `${prev} ${data.text}`.trim());
            }
            else {
                setExpertise((prev) => `${prev} ${data.text}`.trim());
            }

        } catch (err) {
            console.error("Speech upload failed", err);
        }
    };

    const stripHtml = (html: string) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || "";
    };

    const formatAIResponse = (text: string) => {
        if (!text) return "";

        let formatted = text;

        formatted = formatted.replace(/\*{2,}/g, "");
        formatted = formatted.replace(/#{1,}/g, "");
        formatted = formatted.replace(/^\* (.+)$/gm, "• $1");

        formatted = formatted.replace(
            /(?:^|\n)(• .*(?:\n• .*)*)/g,
            (match) => {
                const items = match
                    .trim()
                    .split("\n")
                    .map((line) => `<li>${line.replace(/^• /, "")}</li>`)
                    .join("");
                return `<ul>${items}</ul>`;
            }
        );

        formatted = formatted.replace(/^(.+):$/gm, "<h3>$1</h3>");

        formatted = formatted.replace(
            /^(?!<h3>|<ul>|<li>|<\/ul>)(.+)$/gm,
            "<p>$1</p>"
        );

        formatted = formatted.replace(/<p>\s*<\/p>/g, "");

        return formatted;
    };

    const getChatBotResponse = async (query: string) => {
        if (!query.trim()) return;

        // add user message
        setChatMessages((prev) => [...prev, { role: "user", text: query }]);

        setQuestionText("");
        setIsChatLoading(true);

        try {
            const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

            const res = await axios.post(`${apiUrl}/api/prompts/chat_answer`, {
                courseid: "698b705681424ab945f978e4",
                query,
                chapter: ""
            });

            let answer = res?.data?.response || "No response";

            // cleanup formatting (same as view-course)
            answer = answer.replace(/\*{2,}/g, "");
            answer = answer.replace(/#{1,}/g, "");
            answer = answer.replace(/^\* (.+)$/gm, "• $1");

            const formatted = formatAIResponse(answer);

            setChatMessages((prev) => [
                ...prev,
                {
                    role: "bot",
                    text: formatted,
                },
            ]);

            // store clean text for TTS
            const cleanText = stripHtml(answer);
            setLastBotText(cleanText);

        } catch (err) {
            console.error("Chat error", err);
        } finally {
            setIsChatLoading(false);
        }
    };


    // Decide whether the "Add Content" button should be enabled
    const isInputValid = useMemo(() => {
        if (isUploadLoading || isloadingGetPage) return false;

        switch (urlPrefix) {
            case "text":
                return userBusinessText.trim().length > 0;

            case "https://": {
                const val = sourceUrl.trim();
                if (!val) return false;
                const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/i;
                return urlPattern.test(val);
            }

            case "youtubeid": {
                const val = sourceYoutubeUrl.trim();
                if (!val) return false;
                const ytPattern = /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/)|youtu\.be\/)[\w-]+/i;
                return ytPattern.test(val);
            }

            case "upload":
            case "word":
            case "pdf":
                return Boolean(uploadedvideopath);

            default:
                return false;
        }
    }, [
        urlPrefix,
        userBusinessText,
        sourceUrl,
        sourceYoutubeUrl,
        uploadedvideopath,
        isUploadLoading,
        isloadingGetPage,
    ]);

    /* useEffect(() => {
        if (!lastBotText) return;

        // Prevent duplicate autoplay
        if (prevTextRef.current === lastBotText) return;

        // Mark as played
        prevTextRef.current = lastBotText;

        // STOP any existing TTS FIRST
        dispatch(stopTTS());

        // Small delay ensures clean reset (important)
        const timer = setTimeout(() => {
            dispatch(
                speakText({
                    text: lastBotText,
                    voice: "default.wav",
                    id: "global-tts",
                })
            );
        }, 150);

        return () => clearTimeout(timer);
    }, [lastBotText, dispatch]); */
    useEffect(() => {
        if (!lastBotText) return;

        if (prevTextRef.current === lastBotText) return;

        prevTextRef.current = lastBotText;

        stop();
        playText(lastBotText);
    }, [lastBotText]);

    useEffect(() => {
        (window as any).isMutedGlobal = isMuted;

        if (audioRef.current) {
            audioRef.current.muted = isMuted;
        }
    }, [isMuted]);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };
    const handleExpandClick1 = () => {
        setExpanded1(!expanded1);
    };
    const handleExpandClick2 = () => {
        if (planDetails?.plan_name === 'ENTERPRISE') {
            setExpanded2(!expanded2);
        } else {
            setUpgradeModal(true);
        }
    }
    const handleExpandClick3 = () => {
        /* if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
            || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
            || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
            || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {
            setExpanded3(false);
            return false;
        }
        if (planDetails)
            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                setExpanded3(false);
                return false;
            } */
        if (planDetails?.white_label_options === true) {
            setExpanded3(!expanded3);
        } else {
            setUpgradeModal(true);
        }
    }

    const handleExpandClick4 = () => {
        setExpanded4(!expanded4)
    }

    const handleExpandClick5 = () => {
        setExpanded5(!expanded5);
    }

    const handleExpandClick6 = () => {
        /* if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
            || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
            || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
            || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {
            setExpanded6(false);
            return false;
        }
        if (planDetails)
            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                setExpanded6(false);
                return false;
            } */
        setExpanded6(!expanded6);
    }

    const handleExpandClick7 = () => {

        /* if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
            || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
            || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
            || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {

            setExpanded7(false);
            return false;
        }
        if (planDetails)

            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                setExpanded7(false);
                return false;
            } */

        if (planDetails?.embed_contact_form_newsletters_social_media_share === true) {
            setExpanded7(!expanded7);
        } else {
            setUpgradeModal(true);
        }
    }

    // Inter font — applied consistently across all text elements
    const interFont = "'Inter', sans-serif";

    const handleExpandClick8 = () => {
        /*  if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
             || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
             || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
             || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {
             setExpanded8(false);
             return false;
         }
         if (planDetails)
             if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                 setExpanded8(false);
                 return false;
             } */
        if (planDetails?.embed_contact_form_newsletters_social_media_share === true) {
            setExpanded8(!expanded8);
        } else {
            setUpgradeModal(true);
        }
    }

    const handleExpandClick9 = () => {
        /* if (selectedSubscriptionLevel == 'level_0' || selectedSubscriptionLevel == 'level_0y' || selectedSubscriptionLevel == 'level_1'
            || selectedSubscriptionLevel == 'level_2' || selectedSubscriptionLevel == 'level_4' || selectedSubscriptionLevel == 'level_5' || defaultPlanDetails?.mode == "Free Trial"
            || paymentSubscription == 'level_0' || paymentSubscription == 'level_0y' || paymentSubscription == 'level_1'
            || paymentSubscription == 'level_2' || paymentSubscription == 'level_4' || paymentSubscription == 'level_5') {
            setExpanded9(false);
            return false;
        }
        if (planDetails)
            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                setExpanded9(false);
                return false;
            } */
        if (planDetails?.embed_contact_form_newsletters_social_media_share === true) {
            setExpanded9(!expanded9);
        } else {
            setUpgradeModal(true);
        }
    }

    const handleExpandClick10 = () => {
        setExpanded10(!expanded10);
    }

    const handleExpandClick11 = () => {
        if (planDetails?.embed_youtube_video === true) {
            setExpanded11(!expanded11);
        } else {
            setUpgradeModal(true);
        }
    }

    const handleExpandClick12 = () => {
        setExpanded12(!expanded12);
    }

    const handleExpandClick14 = () => {
        setExpanded14(!expanded14);
    }

    const handleExpandClick15 = () => {
        setExpanded15(!expanded15);
    }



    /* useEffect(() => {
        if (!("webkitSpeechRecognition" in window)) {
            console.warn("Speech recognition not supported");
            return;
        }

        const recognition = new (window as any).webkitSpeechRecognition();
        recognition.continuous = true;
        recognition.interimResults = true;
        recognition.lang = "en-US";

        recognition.onresult = (event: any) => {
            let finalTranscript = "";

            for (let i = event.resultIndex; i < event.results.length; i++) {
                const result = event.results[i];

                // Only take FINAL result
                if (result.isFinal) {
                    finalTranscript += result[0].transcript;
                }
            }

            if (finalTranscript) {
                setQuestionText((prev) => (prev + " " + finalTranscript).trim());
            }
        };

        recognition.onend = () => {
            setIsListening(false);
        };

        recognition.onerror = () => {
            setIsListening(false);
        };

        recognitionRef.current = recognition;
    }, []); */

    const createSpeechRecognition = (
        onFinalTranscript: (text: string) => void,
        setListening: (val: boolean) => void
    ) => {
        if (!("webkitSpeechRecognition" in window)) {
            console.warn("Speech recognition not supported");
            return null;
        }

        const recognition = new (window as any).webkitSpeechRecognition();
        recognition.continuous = true;
        recognition.interimResults = true;
        recognition.lang = "en-US";

        recognition.onresult = (event: any) => {
            let finalTranscript = "";

            for (let i = event.resultIndex; i < event.results.length; i++) {
                const result = event.results[i];
                if (result.isFinal) {
                    finalTranscript += result[0].transcript;
                }
            }

            if (finalTranscript) {
                onFinalTranscript(finalTranscript);
            }
        };

        recognition.onend = () => setListening(false);
        recognition.onerror = () => setListening(false);

        return recognition;
    };

    const [processingStatus, setProcessingStatus] = useState<ProcessingStatusInternal | null>(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const [courseMedia, setCourseMedia] = useState<CourseMedia | null>(null);
    const [transcribedTxt, setTransccribedTxt] = useState<any>();
    const [scrappedContent, setScrappedContent] = useState<any>();

    const apiUrlForTranscribe = process.env.REACT_APP_SERVER_ENDPOINT || "";

    const [transcribingItems, setTranscribingItems] = useState<Set<string>>(new Set());
    const triggeredFilesRef = useRef(new Set<string>());

    // Refs mirror state so waitForTranscriptionComplete reads fresh values
    const isProcessingRef = useRef(isProcessing);
    const transcribingItemsRef = useRef(transcribingItems);

    // Controllable poller for course media + course rows
    const pollTimerRef = useRef<NodeJS.Timeout | null>(null);
    const pollGraceUntilRef = useRef<number>(0); // don't stop polling before this timestamp

    useEffect(() => { isProcessingRef.current = isProcessing; }, [isProcessing]);
    useEffect(() => { transcribingItemsRef.current = transcribingItems; }, [transcribingItems]);

    const makeProcessingKey = (contentType: string, index: number) =>
        `${contentType}:${index}`;

    // An item still needs processing only if it's not done and not already mid-flight.
    // On page load, "inprogress" means a prior run that won't auto-resume — don't re-trigger.
    /*  const needsProcessing = (item: any) => {
         const s = (item?.status || "").toLowerCase();
         return s !== "complete" && s !== "inprogress" && s !== "in_progress";
     }; */
    const needsProcessing = (item: any) => {
        const s = String(item?.status || "").toLowerCase();

        return !(
            s === "complete" ||
            s === "completed" ||
            s === "inprogress" ||
            s === "in_progress"
        );
    };

    async function updateProcessingStatusInternal({
        courseId, contentType, index, status, progress, transcription, identifier,
    }: UpdateProcessingStatusParams) {
        await fetch(`${apiUrlForTranscribe}/api/prompts/update_processing_status`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                course_id: courseId,
                content_type: contentType,
                index, status, progress, transcription, identifier,
            }),
        });
    }

    async function updateProcessingStatus({
        courseId, contentType, index, status, progress, transcription, identifier,
    }: UpdateProcessingStatusParams) {
        await fetch(`${apiUrlForTranscribe}/api/prompts/update_processing_status`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                course_id: courseId,
                content_type: contentType,
                index, status, progress, transcription, identifier,
            }),
        });
    }

    async function scrapeWebsite(url: string): Promise<string> {
        const res = await fetch(`${apiUrlForTranscribe}/api/prompts/scrap_page_test`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                start_url: url.startsWith("http") ? url : `https://${url}`,
                max_pages: 20,
                concurrency: 5,
                follow_external: false,
                save_to_file: false,
            }),
        });
        if (!res.ok) throw new Error("Scraping failed");
        const data = await res.json();
        setScrappedContent(data.summary);
        return data.summary;
    }

    async function processWebUrls(courseId: string, webUrls: any[]) {
        for (let i = 0; i < webUrls.length; i++) {
            const item = webUrls[i];
            if (!needsProcessing(item)) continue;

            const key = makeProcessingKey("web_urls", i);
            setTranscribingItems(prev => {
                const next = new Set(prev);
                next.add(key);
                return next;
            });

            try {
                await updateProcessingStatusInternal({ courseId, contentType: "web_urls", index: i, status: "in_progress", progress: 25, identifier: item.url });
                const summary = await scrapeWebsite(item.url);
                await updateProcessingStatusInternal({ courseId, contentType: "web_urls", index: i, status: "complete", progress: 100, transcription: summary, identifier: item.url });
            } catch (err) {
                console.error(err);
                await updateProcessingStatusInternal({ courseId, contentType: "web_urls", index: i, status: "failed", progress: 0, identifier: item.url });
            } finally {
                setTranscribingItems(prev => {
                    const next = new Set(prev);
                    next.delete(key);
                    return next;
                });
            }
        }
    }

    async function transcribeMedia({
        courseId, media_file_path, original_filename, contentType, auto_publish
    }: TranscribeMediaParams) {
        const formData = new FormData();
        formData.append("course_id", courseId);
        formData.append("media_file_path", media_file_path);
        formData.append("original_filename", original_filename);
        formData.append("content_type", contentType);
        formData.append("auto_publish", auto_publish);

        // Step 1: trigger the background task
        fetch(
            `${apiUrlForTranscribe}/api/prompts/process_get_video_audio_transcription_trigger`,
            {
                method: "POST",
                body: formData,
            }
        );
        // const triggerRes = await fetch(
        //     `${apiUrlForTranscribe}/api/prompts/process_get_video_audio_transcription_trigger`,
        //     {
        //         method: "POST",
        //         body: formData,
        //     }
        // );
        // const triggerData = await triggerRes.json();
        // if (!triggerRes.ok) {
        //     throw new Error(triggerData?.detail || triggerData?.message || "Failed to start transcription task");
        // }

        // const taskId = triggerData.task_id;
        // if (!taskId) {
        //     throw new Error("No task_id returned from trigger endpoint");
        // }

        // Step 2: poll until done (reuses your existing waitForTaskResult helper)
        //const result = await waitForTaskResult(taskId, apiUrlForTranscribe);

        // The shape coming back from the worker depends on what the backend returns.
        // Mirror the previous synchronous payload so processMediaList still works:
        //   { data: "<transcription text>" }
        // If the worker already wraps it as { data: ... }, just return result;
        // otherwise wrap it.
        // const transcription =
        //     typeof result === "string"
        //         ? result
        //         : result?.data ?? result?.transcription ?? result;

        // setTransccribedTxt(transcription);
        // return { data: transcription };
    }

    async function processMediaList({
        courseId, mediaList, contentType,
    }: ProcessMediaListParams) {
        for (let i = 0; i < mediaList.length; i++) {
            const media = mediaList[i];

            if (!needsProcessing(media)) continue;

            const key = makeProcessingKey(contentType, i);
            setTranscribingItems(prev => {
                const next = new Set(prev);
                next.add(key);
                return next;
            });

            try {
                await updateProcessingStatusInternal({
                    courseId, contentType, index: i,
                    status: "pending", progress: 0,
                    identifier: media.path,             // ← ADDED
                });
                if (triggeredFilesRef.current.has(media.path)) {
                    console.log("Skipping duplicate trigger:", media.path);
                    continue;
                }

                triggeredFilesRef.current.add(media.path);
                const response = await transcribeMedia({
                    courseId,
                    media_file_path: media.path,
                    original_filename: media.name,
                    contentType,
                    auto_publish: selectedAutoPublish ?? 0,
                });
                // await updateProcessingStatusInternal({
                //     courseId, contentType, index: i,
                //     status: "complete", progress: 100,
                //     transcription: response.data,
                //     identifier: media.path,             // ← ADDED
                // });
            } catch (err) {
                console.error(err);
                await updateProcessingStatusInternal({
                    courseId, contentType, index: i,
                    status: "failed", progress: 0,
                    identifier: media.path,             // ← ADDED
                });
            } finally {
                setTranscribingItems(prev => {
                    const next = new Set(prev);
                    next.delete(key);
                    return next;
                });
            }
        }
    }

    async function processAllMedia(courseMedia: any) {
        const course = courseMedia.result;

        const pendingAudio = (course.audio || []).some(needsProcessing);
        const pendingVideo = (course.video || []).some(needsProcessing);
        const pendingWeb = (course.web_urls || []).some(needsProcessing);

        if (!pendingAudio && !pendingVideo && !pendingWeb) {
            console.log("[Processing] Nothing pending — skipping on load");
            return;
        }

        if (course.audio?.length) await processMediaList({ courseId: course._id, mediaList: course.audio, contentType: "audio" });
        if (course.video?.length) await processMediaList({ courseId: course._id, mediaList: course.video, contentType: "video" });
        if (course.web_urls?.length) await processWebUrls(course._id, course.web_urls);
    }

    const fetchCourseMedia = async () => {
        const courseId = localStorage.getItem("course_id");
        if (!courseId) return;
        const res = await axios.post(`${apiUrlForTranscribe}/api/prompts/get_course_media`, { course_id: courseId });
        console.log('VIDEOS=>', res.data);
        setCourseMedia((prev: any) =>
            JSON.stringify(prev) === JSON.stringify(res.data) ? prev : res.data
        );
    };

    const stopPolling = () => {
        if (pollTimerRef.current) {
            clearInterval(pollTimerRef.current);
            pollTimerRef.current = null;
        }
    };

    const startPolling = (graceMs: number = 0) => {
        // extend the keep-alive window (used right after an upload)
        if (graceMs > 0) {
            pollGraceUntilRef.current = Date.now() + graceMs;
        }
        if (pollTimerRef.current) return; // already polling
        fetchCourseMedia();
        fetchCourse(true);
        pollTimerRef.current = setInterval(() => {
            fetchCourseMedia();
            fetchCourse(true);
        }, 5000);
    };

    // stop polling on unmount
    useEffect(() => () => stopPolling(), []);

    // Fetch course media on mount
    useEffect(() => {
        const courseId = localStorage.getItem("course_id");
        if (!courseId) return;
        fetchCourseMedia();
    }, []);

    // When courseMedia updates → kick off transcription / scraping
    useEffect(() => {
        if (!courseMedia || isProcessing) return;

        // WAIT until popup choice is made
        if (selectedAutoPublish === null) {
            console.log(
                "[Processing] Waiting for Yes/No popup selection"
            );
            return;
        }

        // Block on page load: only run after the user uploaded something this session.
        if (!userUploadedRef.current) {
            console.log("[Processing] Skipping on load — no user upload this session");
            return;
        }

        const runProcessing = async () => {
            setIsProcessing(true);
            try {
                console.log("FULL COURSE MEDIA", courseMedia);
                await processAllMedia(courseMedia);
            } finally {
                setIsProcessing(false);
            }
        };
        runProcessing();
    }, [courseMedia, selectedAutoPublish]);

    // Poll get_course_media every 5s while anything is still processing on the server
    // Stop polling once nothing is processing — but respect the grace window
    useEffect(() => {
        const ps = (courseMedia as any)?.result?.processing_status || {};

        const anyInProgress = (["video", "audio"] as const).some((type) =>
            (ps[type] || []).some((v: any) => {
                const s = String(v?.status || "").toLowerCase();
                return s === "inprogress" || s === "in_progress";
            })
        );

        const anyClipPending = (ps.video || []).some(
            (v: any) =>
                v?.clip_generated !== true &&
                String(v?.status || "").toLowerCase() === "completed"
        );

        // Don't stop during the grace window — the backend may not have
        // registered the transcription job yet.
        if (Date.now() < pollGraceUntilRef.current) return;

        if (pollTimerRef.current && !anyInProgress && !anyClipPending) {
            stopPolling();
        }
    }, [courseMedia]);

    // ─────────────────────────────────────────────────────────────────────────
    // When transcription finishes, fire the post-pipeline — but ONLY if
    // something was actually transcribed in this batch (not on page load
    // when everything is already complete).
    // ─────────────────────────────────────────────────────────────────────────
    const prevIsProcessingRef = useRef(false);
    const pipelineFiredRef = useRef(false);
    const sawAnyTranscribingRef = useRef(false);

    useEffect(() => {
        const wasProcessing = prevIsProcessingRef.current;
        const nowIdle = !isProcessing && transcribingItems.size === 0;

        // Mark that we saw at least one item actually mid-transcription
        if (transcribingItems.size > 0) {
            sawAnyTranscribingRef.current = true;
        }

        const justFinishedTranscription = wasProcessing && nowIdle;
        prevIsProcessingRef.current = isProcessing;

        if (
            justFinishedTranscription &&
            sawAnyTranscribingRef.current &&        // ← guards against no-op batches
            !pipelineFiredRef.current &&
            !pipelineRunningRef.current &&
            hasAnyContent()
        ) {
            pipelineFiredRef.current = true;
            sawAnyTranscribingRef.current = false;   // reset for the next batch

            console.log("[Pipeline] Transcription complete → firing post-pipeline");

            setTimeout(() => {
                handleCreateCourseStep2();
                setTimeout(() => { pipelineFiredRef.current = false; }, 60_000);
            }, 500);
        }
    }, [isProcessing, transcribingItems]);

    useEffect(() => {
        recognitionRef.current = createSpeechRecognition(
            (text) => {
                setQuestionText((prev) => (prev + " " + text).trim());
                // setUserBusinessText((prev) => (prev + " " + text).trim());
            },
            setIsListening
        );
    }, []);

    useEffect(() => {
        recognitionRef1.current = createSpeechRecognition(
            (text) => {
                setUserBusinessText((prev) => (prev + " " + text).trim());
            },
            setIsListening1
        );
    }, []);

    useEffect(() => {
        recognitionRef2.current = createSpeechRecognition(
            (text) => {
                setDTConcernVal((prev: any) => (prev + " " + text).trim());
            },
            setIsListening2
        );
    }, []);

    useEffect(() => {

        const campaignRes = async () => {
            try {
                const response = await campaignListMutation({ email: user_email || getCookie('user_email') || "" });
                if ('data' in response) {
                    setCampaignDatas(response.data);
                    console.log('campaign list response=>', response.data)
                } else {
                    console.error('Error fetching campaign List:', response.error);
                }
            } catch (error) {
                console.log('Error fetching campaign List:', error);
            }
        }
        campaignRes();
    }, [user_email])

    useEffect(() => {

        localStorage.removeItem('publishingCampId');
    }, []);

    /* const handleMicClick = async () => {
        if (!recognitionRef.current) return;

        if (isListening) {
            recognitionRef.current.stop();
            setIsListening(false);
            return;
        }

        try {
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                console.error("mediaDevices not supported");
                return;
            }

            // THIS LINE IS REQUIRED
            await navigator.mediaDevices.getUserMedia({ audio: true });

            recognitionRef.current.start();
            setIsListening(true);
        } catch (err) {
            console.error("Mic access error", err);
        }
    }; */
    const handleMic = async (
        recognitionRef: React.RefObject<any>,
        isListening: boolean,
        setIsListening: (val: boolean) => void
    ) => {
        if (!recognitionRef.current) return;

        if (isListening) {
            recognitionRef.current.stop();
            setIsListening(false);
            return;
        }

        try {
            if (!navigator.mediaDevices?.getUserMedia) {
                console.error("mediaDevices not supported");
                return;
            }

            await navigator.mediaDevices.getUserMedia({ audio: true });

            recognitionRef.current.start();
            setIsListening(true);
        } catch (err) {
            console.error("Mic access error", err);
        }
    };


    const handleEditClick = () => {
        textareaRef.current?.focus();
    };


    const validateCampaignName = () => {
        /* if(campaignName === ''){
            toast.error('Please fill your Campaign Name!');
            return false;
        } */

        const isDuplicate = campaignDatas.some((campaign: any) => campaign.campaign_name === campaignName);
        if (isDuplicate) {
            toast.error('Duplicate campaign Name. Please choose a different name!');
            return false;
        }
        return true;
    }

    const youtubeMatch = videoTag?.match(
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|watch)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    );
    //console.log('plan details =>', plans);
    const handleCreateCampaignClickold = async () => {
        if (FromEdit === 'startEditing' || localStorage.getItem('ChangepayMode') === 'true') {
            if (video && !videoTag) {
                toast.error('Please enter YouTube video URL on video section');
            } else if (video && !youtubeMatch) {
                toast.error('Please enter only YouTube video URL');

            } else {
                autoPublishCheck(campIdFrEdit);
                handleUpdateSetting(campIdFrEdit);
                localStorage.removeItem('ChangepayMode');
                localStorage.removeItem('IdChangingMode');
            }
            // navigate('/codegenie/generated-blogs', { state: { FromUpdatedCampaign: campIdFrEdit } });
            // if(planDetails?.owndomain === '1'){

            // }
        }
        else {
            // debugger;
            // const isDuplicate = campaignDatas.some((campaign: any) => campaign.campaign_name === campaignName);
            if (campaignName === '' /* || sourceUrl === '' || !paymentOption || (!limitPublish && !autoPublish) */) {
                // toast.error(`Please fill all the * required fields!`);
                toast.error('Please fill your Campaign Name!');
            } /* else if (isDuplicate) {
                toast.error('Duplicate campaign Name. Please choose a different name!');
            } */ else if (
                (urlPrefix === 'text' && sourceText === '') ||
                (urlPrefix !== 'text' && sourceUrl === '')
            ) {
                toast.error('Please fill your Source Page URL/TEXT');
            }
            /* else if (!paymentOption) {
                toast.error('Please choose the payment option!');
                return;
            }  *//* else if (!autoPublish) {
                toast.error('Please fill the autopublish blog!');
            } */ else if (video && !videoTag) {
                toast.error('Please enter YouTube video URL on video section');
            } else if (video && !youtubeMatch) {
                toast.error('Please enter only YouTube video URL');

            }
            /* else if (!name) {
                toast.error('Please fill the required field on author section!');
            } */
            else {
                try {
                    var tmpurl = urlPrefix === 'https://' ? (document.getElementById('sourceurl') as HTMLInputElement)?.value : '';
                    if (tmpurl.indexOf("http") < 0) tmpurl = urlPrefix === 'https://' ? "https://" + tmpurl : '';

                    const finalurl = tmpurl;
                    const youtubeMatch = finalurl?.match(
                        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|watch)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
                    );

                    setIsLoadingGetPage(true);
                    const videoid = youtubeMatch ? youtubeMatch[1] : '';

                    const response = await createCampaignMutation({ campaign_name: campaignName, url: finalurl ? encodeURIComponent(finalurl) : '', email: user_email || getCookie('user_email') || "", sourcemode: urlPrefix === 'text' ? 'text' : 'url', videoid: videoid ? videoid : '', product_desc: sourceText ? encodeURIComponent(sourceText) : '' });
                    console.log("response==" + response);


                    if ('data' in response) {

                        console.log('created campaign result=>', response.data);//getting campaign id here
                        if (response.data.status === 'success') {
                            setCampaignId(response.data.campaign_id);
                            autoPublishCheck(response.data.campaign_id);
                            handleUpdateSetting(response.data.campaign_id);
                            handleVerifyCheckClick(response.data.campaign_id);
                            toast.success(response.data.msg);
                            setIsLoadingGetPage(false);
                            localStorage.setItem('fromNewcampaign', 'true');
                            handleCheckout(response.data.campaign_id);
                            // setOpenPaymentInstructModal(true);
                        } else if (response.data.status === 'failed') {
                            setIsLoadingGetPage(false);
                            toast.error(response.data.msg);
                        }

                    }
                    else {
                        const errorMessage = (response?.error as any)?.data?.detail as string | undefined;

                        toast.error(errorMessage);
                        setIsLoadingGetPage(false);
                        //window.location.reload();
                    }
                } catch (error) {

                    setIsLoadingGetPage(false);
                    console.log('Error creating campaign:', error);
                }
            }
        }
    }


    const handleTextChange = (event: any) => {
        let inputText = event.target.value;
        setUserBusinessText(inputText);
    };

    useEffect(() => {

        let intervalId: any;
        if (isloadingGetPage && loaderProgress < 100) {
            intervalId = setInterval(() => {
                setLoaderProgress((prevProgress: any) => {
                    const newProgress = prevProgress + 2;
                    return newProgress >= 98 ? 98 : newProgress;
                });
            }, intervaltime);
        }

        return () => clearInterval(intervalId);
    }, [isloadingGetPage, loaderProgress]);


    /*** code for celery starts */
    interface TaskStatusResponse {
        state: "pending" | "done" | "error";
        result?: any;
        message?: string;
    }

    interface ScrapPageResponse {
        task_id: string;
    }

    const ContentSection = ({
        title,
        items,
        emptyText,
        renderItem,
    }: {
        title: string;
        items: any[];
        emptyText: string;
        renderItem: (item: any, idx: number) => JSX.Element;
    }) => (
        <div className="mb-6">
            <h3 className="text-white font-semibold mb-2">{title}</h3>

            {items.length === 0 ? (
                <p className="text-gray-400 text-sm">{emptyText}</p>
            ) : (
                <ul className="space-y-1">
                    {items.map(renderItem)}
                </ul>
            )}
        </div>
    );

    // Utility to sleep for some ms
    const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

    const fetchCourse = async (silent: boolean = false) => {
        try {
            const courseId = localStorage.getItem("course_id");
            if (!courseId) return;
            if (!silent) setLoading(true);     // skip the loader on background polls
            const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

            const { data } = await axios.post<GetCourseDetailsResponse>(
                `${apiUrl}/api/prompts/get_course_details`,
                { course_id: courseId }
            );

            // Only update state if the data actually changed → avoids needless re-render flicker
            setCourse((prev) =>
                JSON.stringify(prev) === JSON.stringify(data.result) ? prev : data.result
            );
        } catch (err) {
            console.error(err);
        } finally {
            if (!silent) setLoading(false);
        }
    };

    useEffect(() => {
        const courseId = localStorage.getItem("course_id");
        if (!courseId) return;



        fetchCourse();
    }, []);

    const waitForTaskResult = async (taskId: string, apiUrl: string): Promise<any> => {
        const statusUrl = `${apiUrl}/api/prompts/task_status?task_id=${taskId}`;

        while (true) {
            const { data } = await axios.get<TaskStatusResponse>(statusUrl);

            if (data.state === "done") {
                return data.result;
            } else if (data.state === "error") {
                throw new Error(data.message || "Task failed");
            }

            await sleep(2000); // poll every 2 seconds
        }
    };

    /*** code for celery ends */

    // Wait until every in-flight transcription/scrape has finished.
    // Polls refs (not stale closure state). 30-min timeout by default.
    const waitForTranscriptionComplete = (timeoutMs: number = 30 * 60 * 1000): Promise<void> => {
        return new Promise((resolve, reject) => {
            const startedAt = Date.now();
            const check = () => {
                const stillProcessing = isProcessingRef.current;
                const remainingItems = transcribingItemsRef.current.size;

                if (!stillProcessing && remainingItems === 0) {
                    resolve();
                    return;
                }

                if (Date.now() - startedAt > timeoutMs) {
                    reject(new Error(
                        `Transcription timed out after ${Math.round(timeoutMs / 60000)}m`
                    ));
                    return;
                }

                setTimeout(check, 500);
            };
            check();
        });
    };

    // Generic helper — POST to a "_trigger" endpoint, get task_id, poll until done.
    const runTriggerAndWait = async (
        endpoint: string,
        body: any = {},
        method: "POST" | "GET" = "POST",
        queryParams: Record<string, string> = {}
    ): Promise<any> => {
        const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";
        const fullUrl = `${apiUrl}${endpoint}`;

        let triggerRes;
        try {
            if (method === "POST") {
                triggerRes = await axios.post(fullUrl, body, {
                    params: queryParams,
                    headers: { accept: "application/json" },
                });
            } else {
                triggerRes = await axios.get(fullUrl, { params: queryParams });
            }
        } catch (err) {
            console.error(`[runTriggerAndWait] Failed to start ${endpoint}:`, err);
            throw err;
        }

        const taskId = triggerRes.data?.task_id;
        if (!taskId) {
            console.log(`[runTriggerAndWait] ${endpoint} returned synchronously`);
            return triggerRes.data;
        }

        console.log(`[runTriggerAndWait] ${endpoint} → task_id=${taskId}, polling...`);
        return await waitForTaskResult(taskId, apiUrl);
    };

    const handlescrappage = async (url: string) => {
        setIsLoadingGetPage(true);
        setLoaderProgress(4);
        // setIsScrapcheckloading(true);
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            // const response = await axios.get(
            //     `${apiUrl}/api/prompts/scrap_page?url=${url}`,
            // );

            // Step 1: start the task
            const { data } = await axios.get<ScrapPageResponse>(`${apiUrl}/api/prompts/scrap_page?url=${encodeURIComponent(url)}`);
            const taskId = data.task_id;

            // Step 2: poll until done
            const response = await waitForTaskResult(taskId, apiUrl);


            console.log('scrap_page response=>', response);
            if (response.result === 'failed') {
                setIsLoadingGetPage(false);
                toast.error(response.data);
            } else {
                // handleCreateCampaignClick();
                await fetchCourse();

                setTimeout(() => {
                    autoTriggerCourseFlow();
                }, 500);
            }
        } catch (error) {
            console.log(error);
        } finally {
            // setIsScrapcheckloading(false);
            setLoaderProgress(15);
        }
    }

    useEffect(() => {
        console.log(campaignId);
    }, [campaignId]);


    /* const handleCreateCourseStep2 = async () => {
        resetUploadState();
        if (!hasAnyContent()) {
            toast.error("Please upload at least one content to continue");
            return;
        }

        await updateAllProcessingStatuses(course);

        // navigate("/codegenie/new-course-2", { state: { FromSignUp: FromSignUp === 'true' ? FromSignUp : '', FromDT: 'true' } });
        navigate('/codegenie/generated-blogs', { state: { activeItem: "authority" } });
    } */

    const autoTriggerCourseFlow = async () => {
        // Bail if already triggering, already in the pipeline, or another flow is running
        if (autoAddRef.current || isupdating || pipelineRunningRef.current) return;
        if (!hasAnyContent()) return;

        try {
            autoAddRef.current = true;
            // Small delay so multiple back-to-back uploads coalesce into a single
            // pipeline run rather than queuing several
            await new Promise(resolve => setTimeout(resolve, 800));

            // Re-check after the delay — another instance may have started in the meantime
            if (pipelineRunningRef.current) {
                return;
            }

            await handleCreateCourseStep2();
        } catch (err) {
            console.error("Auto trigger failed", err);
        } finally {
            autoAddRef.current = false;
        }
    };

    const handleCreateCourseStep2 = async () => {
        // Guard: don't enter twice concurrently. Uploads firing autoTriggerCourseFlow
        // back-to-back will all see this guard and bail.
        if (pipelineRunningRef.current) {
            console.log("[Pipeline] Already running, skipping duplicate trigger");
            return;
        }
        if (isupdating) return;
        if (!hasAnyContent()) {
            toast.error("Please upload at least one content to continue");
            return;
        }

        pipelineRunningRef.current = true;
        setIsUpdating(true);
        setIsLoadingGetPage(true);
        setGetPageError(false);

        try {
            const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

            // Step 1: initialize processing status
            await updateAllProcessingStatuses(course);

            // Step 2: WAIT for transcription / scraping to finish
            // setProcessingStage("transcribing");
            // setLoadingText(
            //     <Typography fontSize="18px">
            //         <b>Transcribing your content…</b>
            //         <br />
            //         Converting your audio, video and web pages into text.
            //     </Typography>
            // );

            // try {
            //     await waitForTranscriptionComplete();
            // } catch (err) {
            //     console.error("Transcription wait failed:", err);
            //     toast.error("Transcription is taking too long. Please try again.");
            //     setGetPageError(true);
            //     return;
            // }

            // Step 3: combine the transcribed text on the server
            setProcessingStage("combining_text");
            setLoadingText(
                <Typography fontSize="18px">
                    <b>Organizing your content…</b>
                    <br />
                    Combining transcripts so your Digital Twin can learn.
                </Typography>
            );

            try {
                const courseId = localStorage.getItem("course_id");
                await axios.post(
                    `${apiUrl}/api/prompts/update_combined_text?course_id=${courseId}`
                );
            } catch (err) {
                console.error("Failed to update combined text:", err);
                // Non-fatal: continue.
            }

            // Step 4: migrate videos to podcasts (wait for task completion)
            // setProcessingStage("migrating");
            // setLoadingText(
            //     <Typography fontSize="18px">
            //         <b>Building your podcast library…</b>
            //         <br />
            //         Migrating your content into podcast format.
            //     </Typography>
            // );

            // try {
            //     await runTriggerAndWait(
            //         "/api/prompts/process_migrate_videos_to_podcasts_trigger",
            //         {},
            //         "POST",
            //         { user_email: user_email }
            //     );
            // } catch (err) {
            //     console.error("Migrate videos to podcasts failed:", err);
            //     toast.error("Podcast migration failed, but we'll continue.");
            // }

            // Step 5: update skillset / bio (wait for task completion)
            setProcessingStage("updating_skillset");
            setLoadingText(
                <Typography fontSize="18px">
                    <b>Updating your skillset & bio…</b>
                    <br />
                    Your Digital Twin is learning your unique expertise.
                </Typography>
            );

            try {
                await runTriggerAndWait(
                    "/api/prompts/process_update_skillset_bio_trigger",
                    {},
                    "POST",
                    { user_email: user_email }
                );
            } catch (err) {
                console.error("Update skillset failed:", err);
                toast.error("Skillset update failed.");
            }

            // Step 6: done
            setProcessingStage("done");
            setLoaderProgress(100);
            toast.success("Your Digital Twin is ready!");

        } catch (error) {
            console.error("Main process error:", error);
            toast.error("Something went wrong. Please try again.");
            setGetPageError(true);
        } finally {
            setIsUpdating(false);
            pipelineRunningRef.current = false;
            setTimeout(() => {
                setIsLoadingGetPage(false);
                setProcessingStage("idle");
            }, 1500);
        }
    };

    const voiceUIDRef = useRef(
        typeof crypto !== "undefined" && crypto.randomUUID
            ? crypto.randomUUID()
            : `voice_${Date.now()}`
    );

    const validateAndTrainVoice = async (files: any[] = []) => {
        console.log("FILES RECEIVED:", files);

        const hasVoiceFiles = files?.length > 0;

        if (!hasVoiceFiles) {
            toast.error('Please record your voice!')
            return true;
        }

        try {
            const formDataVoice = new FormData();

            /* const uniqueVoiceName = 
            typeof crypto !== "undefined" && crypto.randomUUID
                ? crypto.randomUUID()
                : `voice_${Date.now()}`; */

            // formDataVoice.append("voice_name", uniqueVoiceName);
            formDataVoice.append("voice_name", voiceUIDRef.current);

            /* files.forEach((file) => {
                formDataVoice.append("files", file);
            }); */
            files
                .filter((file) => !file.isExisting)
                .forEach((file) => {
                    formDataVoice.append("files", file);
                });

            console.log("CALLING TRAIN API...");

            const res = await axios.post(
                `${process.env.REACT_APP_TEXT_TO_SPEECH_SERVICE}/train_voice`,
                formDataVoice,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            console.log("TRAIN API RESPONSE:", res);

            if (res?.data?.status === "voice_trained") {
                toast.success("Voice trained successfully");

                // UPDATE PROGRESS
                setVoiceTrainProgress(100);

                // UPDATE LAST UPDATED TIME
                const now = new Date();

                const formattedDate = now.toLocaleDateString("en-US", {
                    month: "short",
                    day: "2-digit",
                    year: "numeric",
                });

                const formattedTime = now.toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                });

                setLastUpdated(`${formattedDate} • ${formattedTime}`);

                try {
                    const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
                    const updateVoiceName = await axios.post(`${apiUrl}/api/auth/update_digitial_twin_voice?email=${user_email}&voice_name=${res?.data?.voice_name}`);
                    if (updateVoiceName?.data?.status === 'success') {
                        toast.success(updateVoiceName?.data?.message);
                        return true;
                    } else {
                        toast.error('Updating voice name failed');
                        return false;
                    }
                    console.log('upadting voice name res =>', updateVoiceName);
                } catch (error: any) {
                    console.log('Error updating trained voice name =>', error);
                }
                return true;
            } else {
                toast.error("Voice training failed");
                return false;
            }
        } catch (error) {
            console.error("Voice training error:", error);
            toast.error("Voice training failed");
            return false;
        }
    };

    const handleCreateCourseStepPrevious = async () => {
        resetUploadState();
        //Save and then move to next screen
        navigate('/codegenie/new-course-intro', { state: { FromSignUp: FromSignUp === 'true' ? FromSignUp : '' } });

    }

    const handleCreateCampaignClick = async () => {


        if (FromEdit === 'startEditing' || localStorage.getItem('ChangepayMode') === 'true') {
            /*  if (video && !videoTag) {
                 toast.error('Please enter YouTube video URL on video section');
             } else if (video && !youtubeMatch) {
                 toast.error('Please enter only YouTube video URL');
 
             } else { */
            autoPublishCheck(campIdFrEdit);
            handleUpdateSetting(campIdFrEdit);
            localStorage.removeItem('ChangepayMode');
            localStorage.removeItem('IdChangingMode');
            // }
            // navigate('/codegenie/generated-blogs', { state: { FromUpdatedCampaign: campIdFrEdit } });
            // if(planDetails?.owndomain === '1'){

            // }
        }
        else {
            // debugger;
            // const isDuplicate = campaignDatas.some((campaign: any) => campaign.campaign_name === campaignName);
           /*  if (campaignName === '') {
                toast.error('Please fill your Campaign Name!');
            }  *//* else if (isDuplicate) {
                toast.error('Duplicate campaign Name. Please choose a different name!');
            } *//*  else */ if (
                (urlPrefix === 'text' && userBusinessText === '') ||
                (urlPrefix === 'https://' && sourceUrl === '') ||
                (urlPrefix === 'youtubeid' && sourceYoutubeUrl === '') ||
                (urlPrefix === 'upload' && !uploadedvideopath)
            ) {
                toast.error('Please fill any one of the source type!');
            } else if ((sourceUrl || userBusinessText) && blogcount > planDetails?.blog_count_balance) {
                setUpgradeModal(true);
                // toast.error('Blog count exceeds your plan limit. Please upgrade your plan to continue.');
            } else if ((sourceYoutubeUrl || uploadedvideopath) && blogcount > planDetails?.podcast_count_balance) {
                setUpgradeModal(true);
                // toast.error('Blog count exceeds your plan limit. Please upgrade your plan to continue.');
            }

            else {
                try {
                    var tmpurl = urlPrefix === 'youtubeid' ? (document.getElementById('sourceyoutubeurl') as HTMLInputElement)?.value : '';
                    if (tmpurl.indexOf("http") < 0) tmpurl = urlPrefix === 'youtubeid' ? "https://" + tmpurl : '';

                    const finalurl = tmpurl;
                    /* const youtubeMatch = finalurl?.match(
                        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/|playlist\?list=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
                    ); */
                    const youtubeMatch = finalurl?.match(
                        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/|playlist\?list=)|youtu\.be\/)([a-zA-Z0-9_-]+)/
                    );
                    const videoid = youtubeMatch ? youtubeMatch[1] : '';

                } catch (error) {

                    setIsLoadingGetPage(false);
                    console.log('Error creating campaign:', error);
                }
            }
        }
    }

    useEffect(() => {

        if (FromEdit === 'startEditing') {
            getVerifyingScript(campIdFrEdit);
            handleVerifyCheckClick(campIdFrEdit);
            cnameRec(campIdFrEdit);
        }
    }, []);

    const cnameRec = async (campIdFrEdit: string) => {
        try {
            const response = await getCnameEntriesMutation({ email: user_email || getCookie('user_email') || "", campaignid: campIdFrEdit || '' });
            if ('data' in response) {

                setCnameDomainName(response.data);
                setCnameRecords(response.data.cnamerecords);
            }
        } catch (error) {
            console.log('Error fetching dns record:', error);
        }
    }

    const fetchPlanDatas = async () => {
        try {
            const response = await getuserPlanDetails({ email: user_email || getCookie('user_email') || '', campaignid: /* campIdFrEdit || localStorage.getItem('IdChangingMode') ||  */'' });
            if ('data' in response) {

                setPlanDetails(response.data.data);
                //console.log('plan details***=>', response.data.data);
            }
        } catch (error) {
            console.log(error);
        }
    }



    useEffect(() => {

        // if (FromEdit === 'startEditing' || localStorage.getItem('ChangepayMode') === 'true' || successCancelSubscription === true) {
        fetchPlanDatas();
        //console.log(planDetails);
        // }
    }, []);

    const fetchCampDatas = async () => {
        try {
            const response = await getuserCampDetails({ campaignid: campIdFrEdit || /* localStorage.getItem('IdChangingMode') || */ '' });
            if ('data' in response) {

                setCampDetails(response.data.data);

            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {

        if (FromEdit === 'startEditing') {
            fetchCampDatas();
        }
    }, []);


    const autoPublishCheck = async (id: string) => {
        setIsUpdateLoader(true);
        try {
            const validVideoTag = videoTag?.trim() || campDetails?.videotag?.trim() || '';
            const response = await updateAutoPublishCheckMutation({ campaign_id: id, autopublish: autoPublish ? 1 : 0, threeblogperday: limitPublish ? 1 : 0, addtags: addtags ? 1 : 0, capturleads: capturleads ? 1 : 0, twitterurl: planDetails?.twitterurl || twitterUrl || '', fburl: planDetails?.fburl || fbUrl || '', pintresturl: planDetails?.pintresturl || pintrestUrl || '', linkedinurl: planDetails?.linkedinurl || linkedinUrl || '', newsletter: newsletter ? 1 : 0, twitternbutton: twitternbutton ? 1 : 0, fbbutton: fbbutton ? 1 : 0, pintrestbutton: /* pintrestbutton ? 1 : */ 0, linkedinbutton: linkedinbutton ? 1 : 0, video: video ? 1 : 0, owndomain: useOwnDomain ? 1 : 0, cta_lable: ctaLabel ? encodeURIComponent(ctaLabel) : planDetails?.cta_lable ? encodeURIComponent(planDetails?.cta_lable) : 'Learn More', cta_link: ctaLink ? encodeURIComponent(ctaLink) : campDetails?.cta_link ? encodeURIComponent(campDetails?.cta_link) : sourceUrl, videotag: encodeURIComponent(validVideoTag), iframe: 1, publish_to_ocesha: publishToOcesha ? 1 : 0, publish_to_code_genie: publishToCodegenie ? 1 : 0, competetor_search: competitorSearch ? 1 : 0 });

            if (FromEdit === 'startEditing') {
                if ('data' in response) {


                    // toast.success(response.data.msg);
                    if (FromEdit === 'startEditing') {
                        toast.success('Blog settings updated successfully!');
                    } else {
                        toast.success(response.data.msg);
                    }
                }
            }
        } catch (error) {
            console.log('Error:', error);
        } finally {
            setIsUpdateLoader(false);
        }
    }

    const fetchData = async () => {
        try {
            const response = await getUserDetailsMutation({ email: user_email || getCookie('user_email') || '', filter: '', start_date: '', end_date: '' });

            if ('data' in response) {

                // const datas = response.data.data;
                setUserDetails(response.data.data);

            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {

        fetchData();
    }, []);

    const handleCheckout = async (campaignId: string) => {

        let referral_param = localStorage.getItem("referral_param");
        localStorage.removeItem("referral_param");
        /* let couponcode = localStorage.getItem("couponcode");
        localStorage.removeItem("couponcode"); */

        try {
            const response = await createCheckoutSession({ "emailid": user_email || getCookie('user_email') || "", "username": userDetails?.name, "subscription_level": selectedSubscriptionLevel/* paymentOption === '$0/mo.' ? 'level_0' : paymentOption === '$14/mo.' ? 'level_1' : paymentOption === '$39/mo.' ? 'level_2' : paymentOption === '$99/mo.' ? 'level_3' : (paymentOption === '$0/mo.' && period === 'yearly') ? 'level_0y' : paymentOption === '$82.5/mo.' ? 'level_4' : paymentOption === '$165.8/mo.' ? 'level_5' : paymentOption === '$249.16/mo.' ? 'level_6' : '' */, "referral_param": referral_param || "", "couponcode": couponCode ?? "", "mode": '', campaignid: campaignId || '', "from_page": 'campaign', return_domain: '' });

            if (response.data.message == "Checkout url created") {
                // Assuming response contains the checkout URL
                const checkoutUrl = response.data.checkout_url;

                // Redirect to the Stripe checkout page
                window.location.href = checkoutUrl;
            }
            else if (response.data.error) {
                const errorMessage = response.data.error;
                if (errorMessage.includes('This promotion code cannot be redeemed because the associated customer has prior transactions.')) {
                    toast.error('Coupon code already applied');
                } else if (errorMessage.includes('This coupon cannot be redeemed because it does not apply to anything in this order.')) {
                    toast.error('Invalid Coupon code');
                } else {
                    toast.error('Invalid Coupon code');
                }
            }
            /* else {
                console.log('checkout res=>', response);
                toast.error("Something went wrong, checkout url not created");
            } */

        }
        catch (e) {
            alert(e);
            console.log(e);
        }
    }

    const data = [
        { heading: 'QUANTITY', value: '1' },
        { heading: 'PLAN TYPE', value: period === 'monthly' ? 'Monthly' : 'Yearly' },
        { heading: 'PLAN NAME', value: planDetails ? (planDetails.subscription_level === 'level_0' || planDetails.subscription_level === 'level_0y' ? 'Starter' : planDetails.subscription_level === 'level_1' || planDetails.subscription_level === 'level_4' ? 'Basic' : planDetails.subscription_level === 'level_2' || planDetails.subscription_level === 'level_5' ? 'Pro' : planDetails.subscription_level === 'level_3' || planDetails.subscription_level === 'level_6' ? 'Traffic Hacker' : '') : selectedSubscriptionLevel ? (selectedSubscriptionLevel === 'level_0' || selectedSubscriptionLevel === 'level_0y' ? 'Starter' : selectedSubscriptionLevel === 'level_1' || selectedSubscriptionLevel === 'level_4' ? 'Basic' : selectedSubscriptionLevel === 'level_2' || selectedSubscriptionLevel === 'level_5' ? 'Pro' : selectedSubscriptionLevel === 'level_3' || selectedSubscriptionLevel === 'level_6' ? 'Traffic Hacker' : '') : '' },
        { heading: 'TOTAL', value: planDetails ? (planDetails?.subscription_level === 'level_0' ? '$49/mo.' : planDetails?.subscription_level === 'level_1' ? '$99/mo.' : planDetails?.subscription_level === 'level_2' ? '$199/mo.' : planDetails?.subscription_level === 'level_3' ? '$299/mo.' : planDetails?.subscription_level === 'level_0y' ? '$' + (48.8 * 12).toFixed(1) + '/yr.' : planDetails?.subscription_level === 'level_4' ? '$' + (82.5 * 12).toFixed(1) + '/yr.'/* '$82.5/mo.' */ : planDetails?.subscription_level === 'level_5' ? '$' + (165.8 * 12).toFixed(1) + '/yr.'/* '$165.8/mo.' */ : planDetails?.subscription_level === 'level_6' ? '$' + (249.16 * 12).toFixed(1) + '/yr.'/* '$249.16/mo.' */ : '') : /* paymentOption */paymentOptYearlyCal },
        // { heading: 'PAYMENT', value: <Button variant="contained" sx={{ color: '#fff' }} onClick={handleCheckout}>Pay Now</Button> }
    ];


    const handledropdownChange = (event: any) => {
        setSelectedSection(event.target.value);
    }

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = Array.from(e.target.files || []);

        const validFiles = files.filter((file) => {
            const isWavType =
                file.type === "audio/wav" || file.type === "audio/x-wav";
            const isWavName = file.name.toLowerCase().endsWith(".wav");
            return isWavType || isWavName;
        });

        const invalidCount = files.length - validFiles.length;

        // Show error but DO NOT clear previous valid files
        if (invalidCount > 0) {
            toast.error("Only WAV files are allowed. Invalid files ignored.");
        }

        // Append new valid files (not replace)
        setVoiceFiles((prev) => {
            // avoid duplicates (optional but better)
            const newFiles = validFiles.filter(
                (file) => !prev.some((f) => f.name === file.name)
            );
            return [...prev, ...newFiles];
        });

        // reset input
        e.target.value = "";
    };

    const handleSourceUrlChange = (event: any) => {
        let urlVal = event.target.value;
        if (urlVal.startsWith('https://')) {
            urlVal = urlVal.replace('https://', '');
        }

        const element = document.getElementById("authurl") as HTMLInputElement;
        setSourceUrl(urlVal);
        localStorage.setItem('sourceurl', urlVal);
        if (element && !socialUrl) {
            element.value = urlVal;
            setSocialUrl(urlVal);
        }



    }

    const handleblogscountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setBlogCount(value);
        } else {
            toast.error('Please enter numeric value!');
        }
    }

    const handleSourceYoutubeUrlChange = (event: any) => {
        let urlVal = event.target.value;
        if (urlVal.startsWith('https://')) {
            urlVal = urlVal.replace('https://', '');
        }

        const element = document.getElementById("authurl") as HTMLInputElement;
        setSourceYoutubeUrl(urlVal);
        if (element && !socialUrl) {
            element.value = urlVal;
            setSocialUrl(urlVal);
        }


        // localStorage.setItem('sourceurl', urlVal);
    }

    const handleSourceTextChange = (event: any) => {
        let textVal = event.target.value;
        setSourceText(textVal);
        localStorage.setItem('sourcetext', textVal);
    }

    const handlePodcastUrlChange = (event: any) => {
        let podcastVal = event.target.value;
        setPodcastOrYoutubeUrl(podcastVal);
        localStorage.setItem('podcastUrl', podcastVal);
    }


    useEffect(() => {

        if (sourceYoutubeUrl) {
            setVideoTag(sourceYoutubeUrl);
        }
    }, [sourceYoutubeUrl]);

    const handlevideotag = (event: any) => {
        let videotagg = event.target.value.trim();;
        setVideoTag(videotagg);
        /* if (sourceYoutubeUrl) {
            setSourceYoutubeUrl(videotagg);
        } else */ if (campDetails) {
            setCampDetails({
                ...campDetails,
                videotag: videotagg
            })
        }
        localStorage.setItem('videoTag', videotagg);
    }

    const handletwitterUrlChange = (event: any) => {
        let urlVal = event.target.value;
        settwitterUrl(urlVal);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                twitterurl: urlVal
            });
        }
        localStorage.setItem('twitterurl', urlVal);
    }

    const handlefbUrlChange = (event: any) => {
        let urlVal = event.target.value;
        setfbUrl(urlVal);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                fburl: urlVal
            });
        }
        localStorage.setItem('fburl', urlVal);
    }

    const handlepintrestUrlChange = (event: any) => {
        let urlVal = event.target.value;
        setPintrestUrl(urlVal);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                pintresturl: urlVal
            });
        }
        localStorage.setItem('pintresturl', urlVal);
    }

    const handleCtaLabelChange = (event: any) => {
        let label = event.target.value;
        setCtaLabel(label);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                cta_lable: label
            });
        }
    }

    const handleCtaLinkChange = (event: any) => {
        let link = event.target.value;
        setCtaLink(link);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                cta_link: link
            });
        }
    }

    const handlelinkedinUrlChange = (event: any) => {
        let urlVal = event.target.value;
        setLinkedinUrl(urlVal);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                linkedinurl: urlVal
            });
        }
        localStorage.setItem('linkedinurl', urlVal);
    }


    const handlepaymentOptions = (value: any, subscription_level: any) => {
        // const payment_Option = event?.target.value;
        setPaymentOption(value);
        setSelectedSubscriptionLevel(subscription_level);

        setPaymentOptYearlyCal(value === '$48.8/mo.' && period === 'yearly' ? '$' + (48.8 * 12).toFixed(1) + '/yr.' : value === '$82.5/mo.' ? '$' + (82.5 * 12).toFixed(1) + '/yr.' : value === '$165.8/mo.' ? '$' + (165.8 * 12).toFixed(1) + '/yr.' : value === '$249.16/mo.' ? '$' + (249.16 * 12).toFixed(1) + '/yr.' : value)
        localStorage.setItem('paymentOption', value);
        localStorage.setItem('PaymentSubscription', subscription_level);

        if (subscription_level == 'level_0' || subscription_level == 'level_0y' || subscription_level == 'level_1'
            || subscription_level == 'level_2' || subscription_level == 'level_4' || subscription_level == 'level_5') {

            setExpanded3(false);
            setExpanded6(false);
            setExpanded7(false);
            setExpanded8(false);
            setExpanded9(false);

            setSocialMediaUrlPublish(false)
            setCapturLeads(false);
            setNewsLetter(false);
            setTwitternButton(false);
            setFbButton(false);
            setPintrestButton(false);
            setLinkedinButton(false);

            settwitterUrl('');
            setfbUrl('');
            setPintrestUrl('');
            setLinkedinUrl('');
        }
        else {

            setCapturLeads(true);
            setNewsLetter(true);
            setTwitternButton(true);
            setFbButton(true);
            setPintrestButton(true);
            setLinkedinButton(true);
        }

    }

    const paymentSubscription = localStorage.getItem('PaymentSubscription') || '';



    const handleAutoPublishChange = (event: any) => {
        const isChecked = event.target.checked;
        setAutopublish(isChecked);
        if (planDetails) {
            setPlanDetails({
                ...planDetails,
                autopublish: isChecked
            });
        }
        localStorage.setItem('autoPublish', isChecked.toString());
    };


    const handlePublishToOceshaChange = (event: any) => {
        const isChecked = event.target.checked;
        setPublishToOcesha(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                publish_to_ocesha: isChecked
            });
        }
        localStorage.setItem('publish_to_ocesha', isChecked.toString());
    };

    const handleCompetitorSearchChange = (event: any) => {
        const isChecked = event.target.checked;
        setCompetitorSearch(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                competetor_search: isChecked
            });
        }
        localStorage.setItem('competitor_search', isChecked.toString());
    };

    const handlePublishToCodegenieChange = (event: any) => {
        const isChecked = event.target.checked;
        setPublishToCodegenie(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                publish_to_code_genie: isChecked
            });
        }
        localStorage.setItem('publish_to_code_genie', isChecked.toString());
    };

    const handlelimitPublishChange = (event: any) => {
        const isChecked = event.target.checked;
        setLimitPublish(isChecked);
        if (planDetails) {
            setPlanDetails({
                ...planDetails,
                threeblogperday: isChecked
            });
        }
        localStorage.setItem('limitPublish', isChecked.toString());
    };

    const handlesocialMediaUrlPublishChange = (event: any) => {
        /* if (planDetails)
            if (planDetails?.subscription_level != "level_3" && planDetails?.subscription_level != "level_6") {
                return false;
            } */
        const isChecked = event.target.checked;
        setSocialMediaUrlPublish(isChecked);
        if (campDetails) {
            // Update planDetails if it exists (you can add specific updates if needed)
            setCampDetails({
                ...campDetails,
                // Here you can add any relevant updates to planDetails based on isChecked
                // For example:
                socialMediaUrlPublish: isChecked
            });
        }
        localStorage.setItem('smUrlpublish', isChecked.toString());
    };

    const handleaddtagsChange = (event: any) => {
        const isChecked = event.target.checked;
        setAddTags(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                addtags: isChecked
            });
        }
        localStorage.setItem('addTags', isChecked.toString());
    };

    const handletocChange = (event: any) => {
        const isChecked = event.target.checked;
        setToc(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                toc: isChecked
            });
        }
        localStorage.setItem('toc', isChecked.toString());
    };

    const handleexternalLinksChange = (event: any) => {
        const isChecked = event.target.checked;
        setExternalLinks(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                external_links: isChecked
            });
        }
        localStorage.setItem('externalLinks', isChecked.toString());
    };

    const handlecapturleadsChange = (event: any) => {
        const isChecked = event.target.checked;
        setCapturLeads(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                capturleads: isChecked
            });
        }
        localStorage.setItem('captureLeads', isChecked.toString());
    };

    const handlenewsletterChange = (event: any) => {
        const isChecked = event.target.checked;
        setNewsLetter(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                newsletter: isChecked
            });
        }
        localStorage.setItem('newsLetter', isChecked.toString());
    };

    const handletwitterBtnChange = (event: any) => {
        const isChecked = event.target.checked;
        setTwitternButton(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                twitternbutton: isChecked
            });
        }
        localStorage.setItem('twitterBtn', isChecked.toString());
    };

    const handlefbBtnChange = (event: any) => {
        const isChecked = event.target.checked;
        setFbButton(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                fbbutton: isChecked
            });
        }
        localStorage.setItem('fbBtn', isChecked.toString());
    };

    const handlepintrestBtnChange = (event: any) => {
        const isChecked = event.target.checked;
        setPintrestButton(isChecked);
        if (planDetails) {
            setPlanDetails({
                ...planDetails,
                pintrestbutton: isChecked
            });
        }
        localStorage.setItem('pintrestBtn', isChecked.toString());
    };

    const handlelinkedinBtnChange = (event: any) => {
        const isChecked = event.target.checked;
        setLinkedinButton(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                linkedinbutton: isChecked
            });
        }
        localStorage.setItem('linkedinBtn', isChecked.toString());
    };

    const handlevideoChange = (event: any) => {
        const isChecked = event.target.checked;
        setVideo(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                video: isChecked
            });
        }
        localStorage.setItem('video', isChecked.toString());
    };

    const handleOwnDomainChange = (event: any) => {
        const isChecked = event.target.checked;
        setUseOwnDomain(isChecked);
        if (planDetails) {
            setPlanDetails({
                ...planDetails,
                owndomain: isChecked
            });
        }
        localStorage.setItem('owndomain', isChecked.toString());
    };

    const handleAuthorUseDefaultChange = (event: any) => {
        const isChecked = event.target.checked;
        setUseAsDefault(isChecked);
        // if (userDetails) {
        //     setUserDetails({
        //         ...userDetails,
        //         blog_default: isChecked
        //     })
        // }
        // else 
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                use_as_default: isChecked
            });
        } else if (userDetails) {
            setUserDetails({
                ...userDetails,
                blog_default: isChecked
            });
        }
        localStorage.setItem('authorDefaultCheck', isChecked.toString());
    }

    const handleModalPayNowClick = () => {
        setOpenPaymentInstructModal(false);
        setExpanded(true);
        setTimeout(() => {
            paymentSectionRef?.current?.scrollIntoView({ behavior: 'smooth' });
        }, 300);
    };

    const campaignIdfromsuccess = localStorage.getItem('campaignid');

    const handleTopicConfirmation = async (topic: any, keywordCount: any, campId: any) => {
        setIsLoadingGetPage(true);
        setLoaderProgress(8);
        setLoadingText(
            <Typography fontSize="18px">
                <b>Researching Keywords</b>
                <br />
                We’re using AI Agents to research and suggest the best keywords to get traffic for your blog
            </Typography>
        );
        setTopicsList(false);
        setIsKeywordLoader(true);
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            // const response = await axios.get(
            //     `${apiUrl}/api/prompts/get_keywords?topic=${topic}&keywords=${keywordCount}&campaignid=${campaignId}`,
            // );

            // Step 1: start the task
            const { data } = await axios.get<ScrapPageResponse>(`${apiUrl}/api/prompts/get_keywords?topic=${topic}&keywords=${keywordCount}&campaignid=${campaignId}`);
            const taskId = data.task_id;

            // Step 2: poll until done
            const response2 = await waitForTaskResult(taskId, apiUrl);


            if (response2.result) {
                setLoaderProgress(100);
                await new Promise(resolve => setTimeout(resolve, 500));
                setIsLoadingGetPage(false);
                setKeywords(response2.data);
                setKeywordsList(true);
                setTopicsList(false);
            }
        } catch (error) {
            console.log('Error fetching keywords=>', error);
        } finally {
            setIsKeywordLoader(false);
            setLoaderProgress(40);
            setIsLoadingGetPage(false);
        }
    }

    const handleGetPageforCampaign = async (userEmail: any, campaignid: any, topic: any, keyword: any) => {
        setKeywordsList(false);
        setIsLoadingGetPage(true);
        setLoaderProgress(8);
        // if (!campIdFrEdit) {
        setLoadingText(
            <Typography fontSize="18px">
                <b>Writing Blog Content</b>
                <br />
                Our AI is now writing your blog(s) based on your content, topic, and keyword.  We will use Google EEAT standard that will help with your blog ranking well in Google Search.
            </Typography>
        );
        setIntervalTime(4000);
        // setIsLoadingGetPage(true);
        // }
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';

            //const response = await getPageforCampaign({ email: userEmail || getCookie('user_email') || "", campaign_id: campaignid || '', topic: topic, keywords: keyword });

            // Step 1: Call the mutation to start the task
            const { data: taskResponse }: any = await getPageforCampaign({
                email: userEmail || getCookie("user_email") || "",
                campaign_id: campaignid || "",
                topic,
                keywords: keyword,
            });

            const taskId = taskResponse.task_id;

            // Step 2: Poll until task is done or failed
            const response = await waitForTaskResult(taskId, apiUrl);


            if ('data' in response) {
                //console.log('getpagecampaign=>', response.data.result);


                if (response.result === 'success' && !campIdFrEdit) {
                    setLoaderProgress(100);
                    setTimeout(() => {
                        localStorage.setItem('activeItem', 'blogs');
                        setIsLoadingGetPage(false);
                        navigate('/codegenie/generated-blogs', { state: { FromCampaign: campaignIdfromsuccess } });
                        // setOpenGetPageSuccessModal(true);
                    }, 1000);
                } else if (response.result === 'failure') {
                    setGetPageError(true);
                    toast.error(response.message);
                }
            }
            else {
                const errorMessage = (response?.error as any)?.data?.detail as string | undefined;
                toast.error(errorMessage);
                setIsLoadingGetPage(false);
            }
        } catch (error) {
            toast.error('Error generating blogs');
            setIsLoadingGetPage(false);
            console.log('Error generating blogs:', error);
        }
    }



    const handleGetPageModalClose = async () => {
        setOpenGetPageSuccessModal(false);
        localStorage.setItem('activeItem', 'blogs');
        navigate('/codegenie/generated-blogs', { state: { FromCampaign: campaignIdfromsuccess } });
        // setExpanded3(true);
        // setTimeout(() => {
        //    getcnameEntriesRef?.current?.scrollIntoView({ behavior: 'smooth' });
        // }, 300);
        setIsLoadingCnameRec(true);

    }

    const getVerifyingScript = async (campaignId: string) => {
        // setExpanded4(true);
        /*  setTimeout(() => {
             getVerifyScript?.current?.scrollIntoView({ behavior: 'smooth' });
         }, 300); */
        try {
            const response = await getverifyscript({ userid: user_email || getCookie('user_email') || "", campaingid: campaignId || ''/* campaignId ? campaignId : campaignIdfromsuccess || '' */ });
            if ('data' in response) {

                setScript(response.data.script);
            }
        } catch (error) {
            console.log('fetching error', error);
        }
    }

    const handleVerifyCheckClick = async (campaignId: string) => {
        try {
            const response = await getcheckverified({ userid: user_email || getCookie('user_email') || "", campaingid: campaignId/* localStorage.getItem('campaignid') */ || '' });
            if ('data' in response) {

                setVerifyCheck(response.data.status);
                localStorage.removeItem('campaignid');
            }
        } catch (error) {
            console.log('fetching error', error);
        }
    }

    const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            const imageUrl = URL.createObjectURL(file);
            setUserImage(file/* e.target.files[0] */);
            const randomNumber = Math.random();
            setUserImageUrl(imageUrl + "?" + randomNumber);

            return () => URL.revokeObjectURL(imageUrl);
        }
    };

    const handleUpdateSetting = async (campaignId: string) => {
        // e.preventDefault();
        setIsUpdateLoader(true);
        let formData = new FormData();

        // let isFormValid = validateForm();
        // if (isFormValid) {
        //   setIsLoading(true);

        formData.append('name', name != "" && name != undefined ? name : planDetails?.name === undefined ? userDetails?.name : planDetails.name/* planDetails?.name || '' */);
        formData.append('campaignid', campaignId);
        if (userImage) {
            formData.append('user_image', userImage);
        }


        const element = document.getElementById("authurl") as HTMLInputElement;

        if (element.value) {
            formData.append('social_url', element.value);
        }
        else {
            formData.append('social_url', socialUrl);
        }



        const element1 = document.getElementById("usedefault") as HTMLInputElement;
        if (element1.checked) {
            formData.append('use_as_default', '1');
        }
        else {
            formData.append('use_as_default', useAsDefault ? '1' : '0');
        }


        //   formData.append('blog_default', blogDefault ? '1' : '0');
        //   formData.append('email', useremail);
        //   formData.append('auto_publish', isChecked ? `${isChecked}` : "0");
        /* if (!name || !campaignId) {
            toast.error('Please fill the required field on author section!');
        } */
        // else {
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const response = await axios.post(apiUrl + '/api/prompts/updateAuthorinfo', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.status == "success") {
                //   toast.success(response.data.message);
                //   setIsLoading(false);
                const randomNumber = Math.random();
                setUserImageUrl(response.data.user_image + "?" + randomNumber);
                /* if (FromEdit === 'startEditing') {
                    toast.success(response.data.message);
                } */
            }
            else {
                toast.error("Somethng went wrong..")
                //   setIsLoading(false);
            }

        } catch (error) {
            console.error('Error updating author settings:', error);
            // setIsLoading(false);
        } finally {
            setIsUpdateLoader(false);
        }
        // }

        // }

    };

    useEffect(() => {
        if (campDetails?.social_url)
            setSocialUrl(campDetails?.social_url);

        if (campDetails?.name)
            setName(campDetails?.name);



        if (campDetails?.use_as_default == 1)
            setUseAsDefault(true);

    }, [campDetails]);

    useEffect(() => {

        if (!campDetails?.social_url && userDetails?.social_url)
            setSocialUrl(userDetails?.social_url);

        if (!name)
            setName(userDetails?.name);

    }, [userDetails]);

    useEffect(() => {

        const storedCampaignName = localStorage.getItem('campaignName');
        if (storedCampaignName) {
            setCampaignName(storedCampaignName);
        }

        const storedAuthorName = localStorage.getItem('Authorname');
        if (storedAuthorName) {
            setName(storedAuthorName);
        }

        const storedAuthorurl = localStorage.getItem('Authorurl');
        if (storedAuthorurl) {
            setSocialUrl(storedAuthorurl);
        }

        const storedSourceUrl = localStorage.getItem('sourceurl');
        if (storedSourceUrl) {
            setSourceUrl(storedSourceUrl);
        }

        const storedSourceText = localStorage.getItem('sourcetext');
        if (storedSourceText) {
            setSourceText(storedSourceText);
        }

        const storedPodcastUrl = localStorage.getItem('podcastUrl');
        if (storedPodcastUrl) {
            setPodcastOrYoutubeUrl(storedPodcastUrl);
        }

        const storedtwitterUrl = localStorage.getItem('twitterurl');
        if (storedtwitterUrl) {
            settwitterUrl(storedtwitterUrl);
        }

        const storedFBUrl = localStorage.getItem('fburl');
        if (storedFBUrl) {
            setfbUrl(storedFBUrl);
        }

        const storedpintrestUrl = localStorage.getItem('pintresturl');
        if (storedpintrestUrl) {
            setPintrestUrl(storedpintrestUrl);
        }

        const storedLinkedinUrl = localStorage.getItem('linkedinurl');
        if (storedLinkedinUrl) {
            setLinkedinUrl(storedLinkedinUrl);
        }

        const payment_opt = localStorage.getItem('paymentOption');
        if (payment_opt) {
            setPaymentOption(payment_opt);
        }

        const storedAutoPublish = localStorage.getItem('autoPublish');
        if (storedAutoPublish !== null) {
            setAutopublish(storedAutoPublish === 'true');
        }

        const storedLimitPublish = localStorage.getItem('limitPublish');
        if (storedLimitPublish !== null) {
            setLimitPublish(storedLimitPublish === 'true');
        }

        const storedsocialMediaurlsPublish = localStorage.getItem('smUrlpublish');
        if (storedsocialMediaurlsPublish !== null) {
            setSocialMediaUrlPublish(storedsocialMediaurlsPublish === 'true');
        }

        const storedAddTags = localStorage.getItem('addTags');
        if (storedAddTags !== null) {
            setAddTags(storedAddTags === 'true');
        }

        const storedcaptureLeads = localStorage.getItem('captureLeads');
        if (storedcaptureLeads !== null) {
            setCapturLeads(storedcaptureLeads === 'true');
        }

        const storednewsLetter = localStorage.getItem('newsLetter');
        if (storednewsLetter !== null) {
            setNewsLetter(storednewsLetter === 'true');
        }

        const storedtwitterBtn = localStorage.getItem('twitterBtn');
        if (storedtwitterBtn !== null) {
            setTwitternButton(storedtwitterBtn === 'true');
        }

        const storedfbBtn = localStorage.getItem('fbBtn');
        if (storedfbBtn !== null) {
            setFbButton(storedfbBtn === 'true');
        }

        const storedpintrestBtn = localStorage.getItem('pintrestBtn');
        if (storedpintrestBtn !== null) {
            setPintrestButton(storedpintrestBtn === 'true');
        }

        const storedlinkedinBtn = localStorage.getItem('linkedinBtn');
        if (storedlinkedinBtn !== null) {
            setLinkedinButton(storedlinkedinBtn === 'true');
        }

        const storedvideo = localStorage.getItem('video');
        if (storedvideo !== null) {
            setVideo(storedvideo === 'true');
        }

        const storedAuthorDefCheck = localStorage.getItem('authorDefaultCheck');
        if (storedAuthorDefCheck !== null) {
            setUseAsDefault(storedAuthorDefCheck === 'true');
        }
    }, []);

    const handleCampaignNameChange = (event: any) => {
        const newName = event.target.value;
        if (newName === planDetails?.product_name) {
            toast.error('Already campaign name exist!');
        } else {
            setCampaignName(newName);
            if (planDetails) {
                setPlanDetails({
                    ...planDetails,
                    product_name: newName
                });
            }
            localStorage.setItem('campaignName', newName);
        }
    };

    const handleAuthorNameChange = (event: any) => {
        const newName = event.target.value;
        setName(newName);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                name: newName
            });
        }
        else if (userDetails) {
            setUserDetails({
                ...userDetails,
                name: newName
            });
        }
        localStorage.setItem('Authorname', newName);
    }

    const handleAuthorUrlChange = (event: any) => {
        const newUrl = event.target.value;

        setSocialUrl(newUrl);
        // if (userDetails) {
        //     setUserDetails({
        //         ...userDetails,
        //         social_url: newUrl
        //     })
        // }
        // else 
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                social_url: newUrl
            });
        }
        else if (userDetails) {
            setUserDetails({
                ...userDetails,
                social_url: newUrl
            });
        }
        localStorage.setItem('Authorurl', newUrl);
    }

    const handleCopyName = (name: string) => {
        navigator.clipboard.writeText(name).then(() => {
            toast.success('Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
            });
            //toast.success('Copied to Clipboard!');
        })
    }

    const handleCopyscript = (script: string) => {
        navigator.clipboard.writeText(script).then(() => {
            toast.success('Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
            });
            //toast.success('Copied to Clipboard!');
        })
    }

    const handleCopyVal = (value: string) => {
        navigator.clipboard.writeText(value).then(() => {
            toast.success('Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
            });
            //oast.success('Copied to Clipboard!');
        })
    }

    const placeholderText = 'https://www.youtube.com/watch?v=X7sEkixKk4g&t=1s';

    const code_snippet = script/* `<!- Traffic Monster tag (gtag.js) --> <script async src=https://www.googletagmanage EGRK3ZCMNX"></script> <script> window.dataLayer =
window.dataLayer || []; function gtag() {dataLayer.push(arguments) i) gtag('is' new Date gtag('config', 'G-EGRKзZCMNX');` */;

    /* const handleShare = (url: any) => {
        window.open(url, '_blank');
    };

    const shareOnTwitter = () => {
        handleShare(`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}`);
    };

    const shareOnPinterest = () => {
        handleShare(`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(window.location.href)}`);
    };

    const shareOnFacebook = () => {
        handleShare(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`);
    };

    const shareOnLinkedin = () => {
        handleShare(`https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(window.location.href)}`);
        handleShare(`https://www.linkedin.com/sharing/share-offsite/url=${encodeURIComponent(window.location.href)}`);

    }; */

    useEffect(() => {

        setUserImageUrl(planDetails?.user_image || campDetails?.user_image);
    }, [planDetails]);

    const NormallyValArray = [period == "monthly" ? '' : 'Normally $14/mo.', period == "monthly" ? '' : 'Normally $49/mo.', period == "monthly" ? '' : 'Normally $99/mo.', period == "monthly" ? '' : 'Normally $149/mo.'];

    const handleChangePayMethodClick = async () => {
        localStorage.setItem('ChangepayMode', 'true');
        localStorage.setItem('IdChangingMode', campIdFrEdit);
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const response = await axios.post(apiUrl + `/api/subscription/change_payment_method?email=${user_email}`, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.status === 'success') {
                window.open(response.data.portal_url, '_blank');
            }
        } catch (error) {
            console.log('Error changing payment method', error);
        }
    }

    const handleCancelSubscriptionClick = async () => {
        setCancellingLoader(true);
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const response = await axios.post(apiUrl + `/api/subscription/Cancel_Subscription?campaign_id=${campIdFrEdit}`, {
                headers: {
                    'content-type': 'multipart/form-data',
                }
            });
            if (response.data.status === 'success') {
                setSuccessCancelSubscription(true);
                setConfirmCancelSubscription(false);
                toast.success('Cancelled Subscription!');
            }
        } catch (error) {
            toast.error('Error cancelling subscription');
            console.log('Error cancelling subscription', error);
        } finally {
            setCancellingLoader(false);
        }
    }

    const currentlocationurl = window.location.origin;
    const addtoMyblogscodeSnippet =
        `<iframe src="${currentlocationurl}/blogs?campaignid=${campIdFrEdit}&header=off" height="600" width="900" title="Iframe Example"></iframe>`;

    const handleCopyCodeSnippet = (value: string) => {
        navigator.clipboard.writeText(value).then(() => {
            toast.success('Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
            });
            //toast.success('Copied to Clipboard!');
        })
    }

    const handleuploadvideoChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const apiUrl: string = process.env.REACT_APP_UPLOAD_SERVER_ENDPOINT || "";
        const CHUNK_SIZE = 10 * 1024 * 1024; // 10 MB
        const CONCURRENCY = 20;
        const RETRIES = 3;

        const controller = new AbortController();
        abortControllerRef.current = controller;

        // UI state
        if (urlPrefix === "word" || urlPrefix === "pdf") {
            setLoadingText("Uploading your document...");
        } else {
            setLoadingText("Uploading your media...");
        }
        setUploadVideo(file.name);
        setIsLoadingGetPage(true);
        setLoaderProgress(0);
        //setLoaderProgress(5);

        // helpers
        const splitIntoChunks = (f: File, chunkSize: number) => {
            const parts: { index: number; start: number; end: number; blob: Blob }[] = [];
            let idx = 0;
            for (let start = 0; start < f.size; start += chunkSize) {
                const end = Math.min(start + chunkSize, f.size);
                parts.push({ index: idx++, start, end, blob: f.slice(start, end) });
            }
            return parts;
        };

        const initUpload = async (filename: string, totalSize: number, chunkSize: number) => {
            const form = new FormData();
            form.append("filename", filename);
            form.append("total_size", String(totalSize));
            form.append("chunk_size", String(chunkSize));
            const resp = await axios.post(`${apiUrl}/upload/init`, form, { signal: controller.signal });
            return resp.data as { upload_id: string; total_chunks: number; chunk_size: number };
        };

        const getStatus = async (uploadId: string) => {
            try {
                const resp = await axios.get(`${apiUrl}/upload/${uploadId}/status`, { signal: controller.signal });
                return resp.data as { uploaded: number[] };
            } catch (err) {
                return { uploaded: [] };
            }
        };

        const uploadChunk = async (uploadId: string, index: number, blob: Blob) => {
            // form field names: index, chunk (server expects chunk)
            const form = new FormData();
            form.append("index", String(index));
            form.append("chunk", blob, `chunk_${index}`);
            return axios.post(`${apiUrl}/upload/${uploadId}/chunk`, form, {
                headers: { "Content-Type": "multipart/form-data" },
                timeout: 0, // disable timeout for big chunk uploads
                signal: controller.signal,
            });
        };

        const completeUpload = async (uploadId: string) => {
            const resp = await axios.post(`${apiUrl}/upload/${uploadId}/complete`, undefined, { signal: controller.signal });

            return resp.data;
        };

        try {
            // 1) init (or reuse existing upload_id for this filename if present)
            //let uploadId: string | null = localStorage.getItem(`upload_id:${file.name}`) || null;   
            let uploadId: string | null = null;
            let initResp: { upload_id: string; total_chunks: number; chunk_size: number } | null = null;
            if (uploadId) {
                // verify status
                const status = await getStatus(uploadId);
                // if status empty, re-init
                if (!status || !Array.isArray(status.uploaded)) {
                    uploadId = null;
                    localStorage.removeItem(`upload_id:${file.name}`);
                }
            }

            if (!uploadId) {
                initResp = await initUpload(file.name, file.size, CHUNK_SIZE);
                uploadId = initResp.upload_id;
                // save for resume
                localStorage.setItem(`upload_id:${file.name}`, uploadId);
            } else {
                // fetch metadata from server - we still need total_chunks/chunk_size
                // try to call /upload/{uploadId}/status for chunk_size info or re-init
                const status = await getStatus(uploadId);
                // if we don't have chunk size, re-init
                initResp = {
                    upload_id: uploadId,
                    total_chunks: Math.ceil(file.size / CHUNK_SIZE),
                    chunk_size: CHUNK_SIZE,
                };
            }

            //setLoaderProgress(10);

            // 2) build chunk list and skip already-uploaded
            const chunks = splitIntoChunks(file, CHUNK_SIZE);
            const statusResp = await getStatus(uploadId);
            const uploadedSet = new Set<number>((statusResp.uploaded || []).map((n: number) => Number(n)));
            const pending = chunks.filter((c) => !uploadedSet.has(c.index));

            if (pending.length === 0) {

                // nothing to upload, just complete
                const comp = await completeUpload(uploadId);
                setUploadedvideopath(comp.data || comp); // adapt to your response
                toast.success("File Uploaded Successfully!");
                userUploadedRef.current = true;
                setLoaderProgress(100);
                //alert('test....1');
                setTimeout(() => setIsLoadingGetPage(false), 1000);
                return;
            }

            // 3) upload chunks with concurrency and retries
            let uploadedBytes = (chunks.length - pending.length) * CHUNK_SIZE;
            const totalBytes = file.size;
            setLoaderProgress(Math.round((uploadedBytes / totalBytes) * 100));

            // worker pool: process pending in batches of CONCURRENCY
            const queue = [...pending]; // shallow copy

            const uploadWorker = async () => {
                while (queue.length > 0) {
                    const c = queue.shift();
                    if (!c) break;
                    let attempt = 0;
                    while (attempt < RETRIES) {
                        attempt++;
                        try {
                            await uploadChunk(uploadId!, c.index, c.blob);
                            // success
                            uploadedBytes += c.end - c.start;
                            const pct = Math.min(100, Math.round((uploadedBytes / totalBytes) * 100));
                            setLoaderProgress(10 + Math.round(pct * 0.85)); // scale to UI (10..95)
                            break;
                        } catch (err) {
                            console.warn(`Chunk ${c.index} attempt ${attempt} failed`, err);
                            if (attempt >= RETRIES) throw err;
                            // backoff
                            await new Promise((res) => setTimeout(res, 500 * attempt));
                        }
                    }
                }
            };

            // start worker pool
            const workers = new Array(Math.min(CONCURRENCY, pending.length)).fill(null).map(() => uploadWorker());
            await Promise.all(workers);

            // 4) complete
            setLoaderProgress(95);
            const completeResp = await completeUpload(uploadId);
            // handle response (adjust the key depending on your server)
            const finalPath = completeResp.data || completeResp;
            setUploadedvideopath(finalPath);
            setUploadedDuration(completeResp.duration || "");
            setUploadedSize(completeResp.size_mb || "");
            /*  if (urlPrefix === "word" || urlPrefix === "pdf") {
                 setTimeout(async () => {
                     await handleAddContent();
                 }, 200);
             } */

            toast.success("File Uploaded Successfully!");

            const uploadType = getUploadContentType(finalPath);
            // alert('test....2');
            // setAutoPublishDialogOpen(true);
            if (uploadType === "audio" || uploadType === "video") {
                setAutoPublishDialogOpen(true);
            }
            /* setTimeout(() => {
                autoTriggerCourseFlow();
            }, 500); */
            startPolling(20000); // keep polling ~20s so the transcription job is caught

            // cleanup
            localStorage.removeItem(`upload_id:${file.name}`);
            setLoaderProgress(100);
            setIsAddContentDisabled(false);
        } catch (err: any) {
            /* console.error("Upload failed", err);
            toast.error("Error uploading video");
            setLoaderProgress(0); */
            const wasCancelled = axios.isCancel(err) || err?.name === "CanceledError" || err?.code === "ERR_CANCELED";
            if (wasCancelled) {
                console.log("Upload cancelled — user left the page.");
                // No success/error toast here — the upload genuinely did not finish.
            } else {
                console.error("Upload failed", err);
                // same upload function for documents, audio and video: name the right kind
                const failedType = getUploadContentType(file?.name || "");
                const failedExt = (file?.name || "").split(".").pop()?.toLowerCase() || "";
                const failedLabel =
                    failedType === "video" ? "video"
                    : failedType === "audio" ? "audio file"
                    : ["pdf", "doc", "docx", "txt", "ppt", "pptx"].includes(failedExt) ? "document"
                    : "file";
                toast.error(`Error uploading ${failedLabel}${file?.name ? ` "${file.name}"` : ""}. Please try again.`);
            }
            setLoaderProgress(0);
            // do not remove stored upload_id so user can retry/resume
        } finally {
            setTimeout(() => setIsLoadingGetPage(false), 1000);
        }
    };


    const handleAutoPublishChoice = (value: number) => {
        setSelectedAutoPublish(value);
        setAutoPublishDialogOpen(false);

        setTimeout(() => {
            autoTriggerCourseFlow();
        }, 300);
    };


    useEffect(() => {

        setNewsLetter(!!planDetails?.embed_contact_form_newsletters_social_media_share);
        setCapturLeads(!!planDetails?.embed_contact_form_newsletters_social_media_share);
        setTwitternButton(!!planDetails?.embed_contact_form_newsletters_social_media_share);
        setFbButton(!!planDetails?.embed_contact_form_newsletters_social_media_share);
        setLinkedinButton(!!planDetails?.embed_contact_form_newsletters_social_media_share);
        setVideo(!!planDetails?.embed_youtube_video);

    }, [planDetails]);

    const clearCookies = () => {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
            const [name] = cookie.split("=");
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
        }
    };



    const handleItemClick = (itemName: any) => {
        localStorage.setItem('activeItem', itemName);
        setActiveItem(localStorage.getItem('activeItem') ? localStorage.getItem('activeItem') : itemName);
        localStorage.removeItem('campaignid');
        localStorage.removeItem('returningtocampaign');
        localStorage.removeItem('sourceurl');
        localStorage.removeItem('campaignName');
        localStorage.removeItem('paymentOption');
        localStorage.removeItem('autoPublish');
        localStorage.removeItem('limitPublish');
        localStorage.removeItem('smUrlpublish');
        localStorage.removeItem('addTags');
        localStorage.removeItem('captureLeads');
        localStorage.removeItem('newsLetter');
        localStorage.removeItem('twitterBtn');
        localStorage.removeItem('fbBtn');
        localStorage.removeItem('pintrestBtn');
        localStorage.removeItem('linkedinBtn');
        localStorage.removeItem('video');
        localStorage.removeItem('twitterurl');
        localStorage.removeItem('fburl');
        localStorage.removeItem('pintresturl');
        localStorage.removeItem('linkedinurl');
        localStorage.removeItem('smUrlpublish');
        localStorage.removeItem('owndomain');
        localStorage.removeItem('ChangepayMode');
        localStorage.removeItem('IdChangingMode');
        localStorage.removeItem('PaymentSubscription');
        localStorage.removeItem('Authorurl');
        localStorage.removeItem('Authorname');
        localStorage.removeItem('authorDefaultCheck');
        localStorage.removeItem('videoTag');
        localStorage.removeItem('podcastUrl');
        localStorage.removeItem('sourcetext');

        if (itemName == 'createcontent') {
            navigate('/codegenie/new-podcast');
        }
        else if (itemName == 'createcourse') {
            navigate('/codegenie/new-course-2-1');
        } else if (itemName === 'course') {
            navigate('/codegenie/generated-courses');
        }
        else {
            navigate('/codegenie/generated-blogs');
        }

        if (itemName === 'upgrade') {
            /*  const value = {
                 _id: "",
                 product_name: "CodeGenie",
                 product_module: genieSelector.module ? genieSelector.module : "",
                 userid: "",
                 productid: ""
             };
             getProduct(value); */
            localStorage.setItem('fromUpgrade', 'true');
            navigate('/pricing', { state: { campIdFromUpgrade: localStorage.getItem('campId') || ''/* selectedCampaign */, from_page: 'blog_listing' } });
        } else if (itemName === 'logout') {
            clearCookies();
            localStorage.setItem("logged_in", "false");
            //console.log("loggedin:" + localStorage.getItem("logged_in"));
            dispatch(logout());
            var module = localStorage.getItem("module");


            toast.success("Logout success");
            // localStorage.removeItem("payment");
            localStorage.removeItem("msg");
            localStorage.removeItem("complexity");
            localStorage.removeItem("module");
            localStorage.removeItem("subscription_level");
            localStorage.removeItem("free_plan");
            // localStorage.removeItem("userRole");
            localStorage.removeItem("localStorage_msg");
            localStorage.removeItem("allSet");
            localStorage.removeItem("Blogs Generated");
            localStorage.removeItem("remaining_wish_count");
            localStorage.removeItem("userRole");
            localStorage.removeItem("payment");
            localStorage.removeItem("user_email");
            localStorage.removeItem("logged_in");
            localStorage.removeItem("prevImg");
            localStorage.removeItem("fromUpgrade");
            localStorage.removeItem("blogsCount");
            localStorage.removeItem("Generating Count");
            localStorage.removeItem("finalData");
            localStorage.removeItem("user_pass");
            localStorage.removeItem("fromNewcampaign");
            localStorage.removeItem("campaignid");
            localStorage.removeItem("returningtocampaign");
            localStorage.removeItem('sourceurl');
            localStorage.removeItem('campaignName');
            localStorage.removeItem('paymentOption');
            localStorage.removeItem('autoPublish');
            localStorage.removeItem('limitPublish');
            localStorage.removeItem('campId');
            localStorage.removeItem('campaignid');
            localStorage.removeItem('returningtocampaign');
            localStorage.removeItem('sourceurl');
            localStorage.removeItem('campaignName');
            localStorage.removeItem('paymentOption');
            localStorage.removeItem('autoPublish');
            localStorage.removeItem('limitPublish');
            localStorage.removeItem('smUrlpublish');
            localStorage.removeItem('addTags');
            localStorage.removeItem('captureLeads');
            localStorage.removeItem('newsLetter');
            localStorage.removeItem('twitterBtn');
            localStorage.removeItem('fbBtn');
            localStorage.removeItem('pintrestBtn');
            localStorage.removeItem('linkedinBtn');
            localStorage.removeItem('video');
            localStorage.removeItem('twitterurl');
            localStorage.removeItem('fburl');
            localStorage.removeItem('pintresturl');
            localStorage.removeItem('linkedinurl');
            localStorage.removeItem('owndomain');
            localStorage.removeItem('ChangepayMode');
            localStorage.removeItem('IdChangingMode');
            localStorage.removeItem('user_name');
            localStorage.removeItem('refreshCount');
            localStorage.removeItem('publishingCampId');
            localStorage.removeItem('Authorurl');
            localStorage.removeItem('Authorname');
            localStorage.removeItem('authorDefaultCheck');
            localStorage.removeItem('appsumo_coupon_code');
            localStorage.removeItem('podcastUrl');
            localStorage.removeItem('AlertMessage');
            localStorage.removeItem('CreatingfromLanding');
            localStorage.removeItem('UrlfromLanding');
            localStorage.removeItem('signedup');
            localStorage.removeItem('uploadedvideo');
            localStorage.removeItem('uploadedVideoName');
            localStorage.removeItem('uploadStatus');
            localStorage.removeItem('editedposthashtags');
            localStorage.removeItem('editedpostblogsummary');
            localStorage.removeItem('editedpostblogtitle');
            localStorage.removeItem('editedposturl');
            localStorage.removeItem('user_email');
            localStorage.removeItem('YoutubeUrlfromLanding');
            localStorage.removeItem('FirstLogin');
            localStorage.removeItem('DirectSignup');
            localStorage.removeItem('FromIndexPage');
            localStorage.removeItem('activeItem');
            localStorage.removeItem('UpdateduserImage');
            localStorage.removeItem('publish_to_code_genie');
            localStorage.removeItem('publish_to_ocesha');
            localStorage.removeItem('competitor_search');
            localStorage.removeItem('FromEditBlog');
            localStorage.removeItem('ErrorAlert');
            localStorage.removeItem('FromSignIn');
            removeCookie('user_email');
            localStorage.clear();

            if (module == process.env.REACT_APP_MAIN_PRODUCT_NAME)
                navigate("/Anycode_landing");
            else
                redirectAfterLogout(); //"https://ocesha.ai";
        }
    };

    const handleMenuToggle = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleTopicSelect = (topic: any) => {
        setSelectedTopic(topic);
    }

    const handleKeywordSelect = (keyword: any) => {
        setSelectedKeyword(keyword);
    }

    // Server processing status from get_course_media → keyed by path & name, per content type
    const serverStatusState = useMemo(() => {
        const make = () => ({
            byPath: new Map<string, string>(),
            byName: new Map<string, string>(),
        });
        const result: Record<string, { byPath: Map<string, string>; byName: Map<string, string> }> = {
            video: make(),
            audio: make(),
        };

        const ps = (courseMedia as any)?.result?.processing_status || {};
        (["video", "audio"] as const).forEach((type) => {
            const list = ps[type] || [];
            list.forEach((v: any) => {
                const status = String(v?.status || "").toLowerCase();
                const pathKey = v?.path || v?.identifier;
                if (pathKey) result[type].byPath.set(pathKey, status);
                if (v?.name) result[type].byName.set(v.name, status);
            });
        });

        return result;
    }, [courseMedia]);

    // true when the server reports this item as still transcribing ("inprogress")
    const getServerProcessing = (type: "video" | "audio", item: any): boolean => {
        const bucket = serverStatusState[type];
        // prefer the freshly-polled processing_status; fall back to the row's own field
        const looked =
            (item?.path && bucket.byPath.get(item.path)) ||
            (item?.name && bucket.byName.get(item.name));
        const status = looked ?? item?.status;
        const s = String(status || "").toLowerCase();
        return s === "inprogress" || s === "in_progress";
    };

    const audioItems: UploadedItem[] =
        course?.audio && course.audio.length > 0
            ? course.audio.map(
                (a: { name: string; duration: string }, index: number) => ({
                    label: `${a.name} – ${a.duration}`,
                    deletable: true,
                    index,
                    isTranscribing: transcribingItems.has(makeProcessingKey("audio", index)),
                    serverProcessing: getServerProcessing("audio", a),
                })
            )
            : [
                {
                    label: "Audio not uploaded",
                    deletable: false,
                },
            ];


    // Map clip-generation state from get_course_media → keyed by path (identifier) and name
    const videoClipState = useMemo(() => {
        const byPath = new Map<string, { clipGenerated: boolean; status: string }>();
        const byName = new Map<string, { clipGenerated: boolean; status: string }>();

        const list = (courseMedia as any)?.result?.processing_status?.video || [];
        list.forEach((v: any) => {
            const entry = {
                clipGenerated: v?.clip_generated === true,
                status: String(v?.status || "").toLowerCase(),
            };
            const pathKey = v?.path || v?.identifier;
            if (pathKey) byPath.set(pathKey, entry);
            if (v?.name) byName.set(v.name, entry);
        });

        return { byPath, byName };
    }, [courseMedia]);

    // "completed" but clip not generated yet  → still processing
    const getVideoClipPending = (v: any): boolean => {
        const entry =
            (v?.path && videoClipState.byPath.get(v.path)) ||
            (v?.name && videoClipState.byName.get(v.name));

        const clipGenerated = entry ? entry.clipGenerated : (v?.clip_generated === true);
        const status = entry ? entry.status : v?.status;

        return clipGenerated !== true && String(status || "").toLowerCase() === "completed";
    };




    const videoItems: UploadedItem[] =
        course?.video && course.video.length > 0
            ? course.video.map(
                (v: { name: string; duration: string }, index: number) => ({
                    label: `${v.name} – ${v.duration}`,
                    deletable: true,
                    index,
                    isTranscribing: transcribingItems.has(makeProcessingKey("video", index)),
                    clipPending: getVideoClipPending(v),
                    serverProcessing: getServerProcessing("video", v),
                })
            )
            : [
                {
                    label: "Video not uploaded",
                    deletable: false,
                },
            ];

    const documentItems: UploadedItem[] =
        course?.documents && course.documents.length > 0
            ? course.documents.map((d: { name: string; size: string }, index: number) => ({
                label: `${d.name} – ${d.size}`,
                deletable: true,
                index,
            }))
            : [
                {
                    label: "Document file not uploaded",
                    deletable: false,
                },
            ];


    const youtubeItems =
        course?.youtube_urls && course.youtube_urls.length > 0
            ? course.youtube_urls.map((item: any, index: number) => ({
                label: item.url,
                deletable: true,
                index,
            }))
            : [
                {
                    label: "YouTube URL not added",
                    deletable: false,
                },
            ];


    const webItems =
        course?.web_urls && course.web_urls.length > 0
            ? course.web_urls.map((item: any, index: number) => ({
                label: item.url,
                deletable: true,
                index,
                isTranscribing: transcribingItems.has(makeProcessingKey("web_urls", index)), // 🔽
            }))
            : [
                {
                    label: "Web URL not added",
                    deletable: false,
                },
            ];

    const textDocItems =
        course?.text_documents && course.text_documents.length > 0
            ? course.text_documents.map((doc: any, index: number) => ({
                label: typeof doc === "string" ? doc : (doc?.value ?? doc?.text ?? ""),
                deletable: true,
                index,
            }))
            : [
                {
                    label: "Text Document not found",
                    deletable: false,
                },
            ];


    // const textDocItems =
    //     course?.text_documents && course.text_documents.length > 0
    //         ? course.text_documents.map((url: string, index: number) => ({
    //             label: url,
    //             deletable: true,
    //             index,
    //         }))
    //         : [
    //             {
    //                 label: "Text Document not found",
    //                 deletable: false,
    //             },
    //         ];


    const mapToContentType = (prefix: string) => {
        switch (prefix) {
            case "https://":
                return "web";
            case "youtubeid":
                return "youtube";
            case "text":
                return "text";
            case "upload":
                return "video"; // or audio (based on file type)
            case "word":
            case "pdf":
                return "document";
            default:
                return "";
        }
    };






    const fetchCourseDetails = async (courseId: string) => {
        try {
            setLoading(true);

            const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

            const { data } = await axios.post<GetCourseDetailsResponse>(
                `${apiUrl}/api/prompts/get_course_details`,
                { course_id: courseId }
            );

            if (data?.result?.expertise) {
                setExpertise(data.result.expertise); // ✅ pre-populate
            }
        } catch (error: any) {
            console.error("Failed to fetch course details", error);
            toast.error(
                error?.response?.data?.detail || "Failed to load course details"
            );
        } finally {
            setLoading(false);
        }
    };

    const handleAddContent = async () => {
        const courseId = localStorage.getItem("course_id") || "";
        /* if (!courseId) {
            toast.error("Course not found");
            return;
        } */

        const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";
        let contentType = mapToContentType(urlPrefix);


        let payloadValue: any = null;
        const file = uploadedFiles?.[0];

        if (urlPrefix === "text") {
            payloadValue = userBusinessText;
        }

        if (urlPrefix === "https://") {
            payloadValue = sourceUrl;
        }

        if (urlPrefix === "youtubeid") {
            payloadValue = sourceYoutubeUrl;
        }

        if (urlPrefix === "upload") {
            if (!uploadedvideopath) {
                toast.error("File not uploaded yet");
                return;
            }


            const detectedType = getUploadContentType(uploadedvideopath);
            if (!detectedType) {
                toast.error("Unsupported file type");
                return;
            }
            contentType = detectedType;


            payloadValue = {
                path: uploadedvideopath.split("###")[0],
                name: uploadedvideopath.split("###")[1],
                duration: uploadedDuration || "00:00",
                status: "pending",
                progress: 0
            };
        }

        if (urlPrefix === "word" || urlPrefix === "pdf") {
            if (!uploadedvideopath) {
                toast.error("File not uploaded yet");
                return;
            }

            payloadValue = {
                path: uploadedvideopath.split("###")[0],
                name: uploadedvideopath.split("###")[1],
                size: uploadedSize
            };

        }

        if (!payloadValue) {
            toast.error("No content to upload");
            return;
        }

        try {
            const user_email = localStorage.getItem("user_email") || "";
            const res = await axios.post(`${apiUrl}/api/prompts/create_course`, {
                user_email: user_email,
                course_id: courseId,
                content_type: contentType,
                content_value: payloadValue,
                digital_twin_instruction: DTinstruction
            });

            console.log('course creation res=>', res);
            localStorage.setItem("course_id", res?.data?.course_id);

            toast.success("Content added successfully");
            userUploadedRef.current = true;
            await axios.post(
                `${apiUrl}/api/prompts/update_combined_text?course_id=${res?.data?.course_id}`
            );
            // refresh content
            fetchCourseDetails(courseId || res?.data?.course_id);
            await fetchCourse();

            setTimeout(() => {
                autoTriggerCourseFlow();
            }, 500);
            // triggers the transcription useEffect for new audio/video
            await fetchCourseMedia();
            startPolling(20000); // keep polling ~20s so the new job is caught

            // optional: clear state
            setUploadedFiles([]);
            setUploadedvideopath("");
            setSourceUrl("");
            setSourceYoutubeUrl("");
            setUserBusinessText("");
            resetUploadState();
            // Reset so the next addition can trigger again
            autoAddRef.current = false;

        } catch (err) {
            console.error(err);
            toast.error("Failed to add content");
            // Also reset on error so user can retry
            autoAddRef.current = false;
        }

        await fetchCourse();
    };

    const resetUploadState = () => {
        setUrlPrefix("word");
        setSourceUrl("");
        setSourceYoutubeUrl("");
        setUserBusinessText("");
        setUploadedFiles([]);
        setUploadedvideopath("");
        setUploadedDuration("");
        setUploadedSize("");
        setUploadVideo("");
        setIsLoadingGetPage(false);
        setLoaderProgress(0);
        setLoadingText("");
        setIsAddContentDisabled(false); // 
        if (fileInputRef.current) {
            fileInputRef.current.value = "";
        }
        autoAddRef.current = false;
    };

    const handleDeleteContent = async (
        contentType: "audio" | "video" | "document" | "youtube" | "web" | "text",
        index: number
    ) => {
        const courseId = localStorage.getItem("course_id");
        if (!courseId) {
            toast.error("Course not found");
            return;
        }

        const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

        try {
            await axios.post(`${apiUrl}/api/prompts/delete_course_content`, {
                course_id: courseId,
                content_type: contentType,
                index,
            });

            toast.success("Content removed");

            //  refresh UI instantly
            fetchCourse();
        } catch (err) {
            console.error(err);
            toast.error("Failed to remove content");
        }
    };

    const handleSourceSelect = (selectedValue: string) => {
        if (
            campDetails?.source !== 'upload' &&
            campDetails?.source !== 'youtube' &&
            campDetails?.source !== 'url' &&
            campDetails?.source !== 'text'
        ) {
            setUrlPrefix(selectedValue);

            switch (selectedValue) {
                case 'https://':
                    setSourceUrl('');
                    setIsAddContentDisabled(false);
                    break;
                case 'youtubeid':
                    setSourceYoutubeUrl('');
                    setIsAddContentDisabled(true);
                    break;
                case 'text':
                    setUserBusinessText('');
                    setIsAddContentDisabled(false);
                    break;
                case 'upload':
                    setIsAddContentDisabled(true);
                    break;
                case 'word':
                    setIsAddContentDisabled(true);
                    break;
                default:
                    break;
            }
        }
    };

    // auto click 'Add Content' btn
    useEffect(() => {

        if (autoAddRef.current) return;

        /* const hasText =
            (urlPrefix === "text" || campDetails?.source === "text") &&
            !!userBusinessText?.trim(); */

        /*const hasUrl =
            (urlPrefix === "https://" || campDetails?.source === "url") &&
            !!sourceUrl?.trim();*/

        const hasYoutube =
            (urlPrefix === "youtubeid" || campDetails?.source === "youtube") &&
            !!sourceYoutubeUrl?.trim();

        const hasUpload =
            (urlPrefix === "upload" ||
                urlPrefix === "word" ||
                urlPrefix === "pdf") &&
            !!uploadedvideopath;

        if (/* hasText || */ hasYoutube || hasUpload) {
            autoAddRef.current = true;
            handleAddContent();
        }

    }, [
        // userBusinessText,
        sourceYoutubeUrl,
        uploadedvideopath,
        urlPrefix,
        campDetails?.source
    ]);

    // auto play intro(SPEAKER)
    const secondAudio =
        "https://tts.ocesha.ai/media/a5264db5-662f-4fcd-842c-6bd97c77b9b4.wav";

    useEffect(() => {
        // Reset hasFetched if name wasn't available yet
        if (!userDetails?.name) return;
        if (hasFetched.current) return;

        hasFetched.current = true;
        fetchAudio();
    }, [userDetails?.name]); // fires whenever name becomes available


    const fetchAudio = async () => {
        try {
            // Site language other than English: "Hi <name>" and the intro clip in that
            // language (WAVs generated once per language and reused, see utils/voiceClips.ts)
            localizedClipUrl(secondAudio).then((u) => { localizedIntro.current = u; }).catch(() => {});
            const localizedGreeting = await getGreetingUrl(userDetails?.name || "").catch(() => null);
            if (localizedGreeting) { playAudio(localizedGreeting); return; }

            const res = await axios.post(
                `${process.env.REACT_APP_TEXT_TO_SPEECH_SERVICE}/speak?text=${encodeURIComponent(`Hi ${userDetails?.name}`)}`,
            );

            const data = res?.data;

            if (data?.audio_path) {
                playAudio(data.audio_path);
            }
        } catch (err) {
            console.log("Error fetching audio:", err);
        }
    };

    const playAudio = (url: string) => {
        const audio = new Audio(url);
        audioRef.current = audio;

        // Respect mute state
        audio.muted = isMuted;

        const playPromise = audio.play();
        if (playPromise !== undefined) {
            playPromise.catch((err) => {
                console.log("Autoplay blocked, waiting for user gesture:", err);
                // Retry on first user interaction
                const retryPlay = () => {
                    audio.play().catch(() => { });
                    document.removeEventListener("click", retryPlay);
                    document.removeEventListener("keydown", retryPlay);
                };
                document.addEventListener("click", retryPlay, { once: true });
                document.addEventListener("keydown", retryPlay, { once: true });
            });
        }

        audio.onended = () => {
            const nextAudio = new Audio(localizedIntro.current || secondAudio);
            audioRef.current = nextAudio;
            nextAudio.muted = isMuted; // respect mute for second audio too
            nextAudio.play().catch(() => { });
            nextAudio.onended = () => { };
        };
    };

    const toggleMute = () => {
        setIsMuted((prev) => {
            const newState = !prev;

            if (audioRef.current) {
                if (newState) {
                    // MUTE → pause
                    audioRef.current.pause();
                } else {
                    // UNMUTE → resume
                    audioRef.current.play().catch(() => { });
                }
            }

            return newState;
        });
    };

    // console.log('uploaded items res =>', webItems);
    const hasValidItems = (items: any[]) =>
        items?.some(item => item?.deletable === true);

    const hasAnyUploadedContent =
        hasValidItems(audioItems) ||
        hasValidItems(videoItems) ||
        hasValidItems(documentItems) ||
        hasValidItems(webItems) ||
        hasValidItems(textDocItems);

    // getting user profile details
    const fetchUserData = async () => {
        try {
            // setUserLoading(true);

            const response = await getUserDetailsMutation({ email: user_email, filter: '', start_date: '', end_date: '' });

            if ('data' in response) {
                // const datas = response.data.data;
                setUserDetails(response.data.data);
                console.log('userdetails on digital twin=>', response.data.data);

            }
        } catch (error) {
            console.log(error);
        } /* finally {
            setUserLoading(false);
        } */
    };

    useEffect(() => {
        if (hasFetched.current) return;

        hasFetched.current = true;

        fetchUserData();
    }, []);

    // update user profile image
    const UpdateUserData = async (selectedFile?: File) => {
        let formData = new FormData();

        if (selectedFile) {
            formData.append('user_image', selectedFile);
        }
        formData.append('social_url', userDetails?.social_url || '');
        formData.append('blog_default', userDetails?.blog_default || 1);
        formData.append('name', userDetails?.name || '');
        formData.append('email', userDetails?.email);
        formData.append('auto_publish', userDetails?.auto_publish || 1);

        try {
            // start loader only when an image is being uploaded
            if (selectedFile) setIsUploadingPhoto(true);

            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';

            const response = await axios.post(
                apiUrl + '/api/auth/updateUserSettings',
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            if (response.data.status === "success") {
                toast.success(response.data.message);
                await fetchUserData();
                setImageVersion(Date.now());
                window.dispatchEvent(new Event("profileUpdated"));
            } else {
                toast.error("Something went wrong..");
            }
        } catch (error) {
            console.error('Error updating user settings:', error);
            toast.error("Failed to update photo");
        } finally {
            // stop loader regardless of success/failure
            if (selectedFile) setIsUploadingPhoto(false);
        }
    };

    // file choose
    const handleUserImageChange = async (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const file = event.target.files?.[0];

        if (!file) return;

        setUserImage(file);

        // immediately upload
        await UpdateUserData(file);
    };

    useEffect(() => {
        // console.log('digital twin voice =>', userDetails);
        const fetchExistingVoice = async () => {
            try {
                if (!userDetails?.digitial_twin_voice) return;

                setLoadingVoices(true);

                // remove .wav
                const voiceName = userDetails.digitial_twin_voice.replace(
                    /\.wav$/i,
                    ""
                );
                const response = await axios.get(`${process.env.REACT_APP_TEXT_TO_SPEECH_SERVICE}/list_wav?voice_name=${voiceName}`)

                const files = response?.data?.files || [];

                if (files.length > 0) {
                    const preloadedFiles = files.map(
                        (url: string, index: number) => ({
                            name: url.split("/").pop(),
                            preview: url,
                            isExisting: true,
                            id: index,
                        })
                    );

                    setVoiceFiles(preloadedFiles as any);
                }
            } catch (error) {
                console.error("Failed to load existing voice", error);
            } finally {
                setLoadingVoices(false);
            }
        };

        fetchExistingVoice();
    }, [userDetails?.digitial_twin_voice]);

    return (
        <>
            {/* <Header /> */}
            <div style={{ overflowX: 'hidden' }}>
                <div className="row">
                    {/* <div className="col-10">
                        <Ocesha_header handleItemClick={handleItemClick} />
                    </div> */}

                    <div className={/* FromSignUp === 'true' ? */ "col-sm-12 col-md-12 col-lg-12"/*  : "col-sm-12 col-md-10 col-lg-10" */} /* style={{ paddingRight: '2%' }} *//* style={{ margin: '7%' }} */>
                        {/* <Ocesha_header handleItemClick={handleItemClick} FromSignUp={FromSignUp} />
                        {FromSignUp === 'true' ? <Divider sx={{ mt: 2 }} /> : <hr />} */}
                        <div className="overlay-container" style={{ paddingRight: FromSignUp === 'true' ? '10%' : undefined, paddingLeft: FromSignUp === 'true' ? '10%' : undefined }}>
                            <div style={{ width: '98%', marginBottom: '10%' }}>
                                {/* {isloadingGetPage && !getPageError && (
                                    <div style={{
                                        position: 'fixed',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                        zIndex: 9999,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backdropFilter: 'blur(5px)',
                                        overflow: 'hidden',
                                    }}>

                                        <div style={{
                                            width: '80%', maxWidth: '700px',
                                            padding: '20px',
                                            backgroundColor: '#282C39',
                                            borderRadius: '8px',
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                            textAlign: 'center'
                                        }}>
                                            <Typography style={{ fontSize: '30px' }}>{loadingText}</Typography>
                                            <br></br>
                                            <ProgressBar
                                                completed={loaderProgress}
                                                bgColor={loaderProgress >= 90 ? "#4CAF50" : "#4BA5EB"}
                                                height="20px"
                                                labelColor="#ffffff"
                                                labelAlignment="center"
                                            />
                                            <br></br>
                                            <Typography style={{ fontSize: '20px' }}>Sit tight while we upload your content...</Typography>
                                        </div>
                                    </div>
                                )} */}

                                {/* {(subscriptionFromCampList || planDetails?.mode == "Free Trial" || defaultPlanDetails?.mode == "Free Trial") ?
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Box sx={{ background: '#090619', borderRadius: '5px', padding: isMobile ? '6%' : '2%', width: isMobile ? '100%' : '50%', }}>
                                <Typography sx={{ fontSize: '15px', fontWeight: 'bolder', color: "#fff" }}><span style={{ display: 'flex', justifyContent: 'center', marginBottom: '2%' }}><InfoIcon style={{ color: 'Orange', fontSize: '30px' }} /></span><span>{(((planDetails?.subscription_level == 'level_3' || planDetails?.subscription_level == 'level_6') && planDetails?.mode == "Free Trial") || defaultPlanDetails?.mode == "Free Trial") ? 'Note: Traffic Hacker plan NOT ACTIVATED.  You can view this page but you will not be able to create new campaigns/update existing campaign with all features, until you have activated your Traffic Hacker plan.' : 'Note: You can view this page but you will not be able to create new campaigns until you upgrade to Traffic Hacker plan.'}</span></Typography>
                            </Box>
                        </Grid>
                    </Grid> : ''} */}

                                {planDetails?.payment_status === 'pending' ?
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <Box sx={{ background: '#090619', borderRadius: '5px', padding: isMobile ? '6%' : '2%', width: isMobile ? '100%' : '50%', }}>
                                                <Typography sx={{ fontSize: '15px', fontWeight: 'bolder', color: "#fff" }}><span style={{ display: 'flex', justifyContent: 'center', marginBottom: '2%' }}><InfoIcon style={{ color: 'Orange', fontSize: '30px' }} /></span><span style={{ display: 'flex', justifyContent: 'center' }}>{'Note: Subscription is PENDING, please complete the payment.'}</span></Typography>
                                            </Box>
                                        </Grid>
                                    </Grid> : ''}

                                <Stack spacing={1.5}>
                                    <Typography fontFamily={interFont} fontSize={26} fontWeight={700} letterSpacing="-0.02em" color="#FFFFFF">
                                        My Digital Twin
                                    </Typography>
                                    <Typography fontFamily={interFont} fontSize={12} color="#D9D9D9" mb={3}>
                                        Train your AI twin with your content, voice, and visuals so it can represent you more accurately.
                                    </Typography>

                                    <Box
                                        sx={{
                                            position: "relative",
                                            mb: 2,
                                            px: 2,
                                            py: 1.2,
                                            borderRadius: "10px",
                                            background: "transparent",
                                            // background: "linear-gradient(90deg, rgba(16, 40, 69, 0.6) 0%, rgba(24, 64, 107, 0.6) 50%, rgba(16, 40, 69, 0.6) 100%)",
                                            backdropFilter: "blur(8px)",
                                            WebkitBackdropFilter: "blur(8px)", // for Safari
                                            border: "1px solid rgba(68, 157, 212, 0.3)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            flexWrap: "wrap",
                                            gap: 1,
                                            overflow: "hidden",

                                            // overlay gradient (lighter & subtle)
                                            "&::before": {
                                                content: '""',
                                                position: "absolute",
                                                inset: 0,
                                                background:
                                                    "linear-gradient(90deg, rgba(16,40,69,0.25) 0%, rgba(24,64,107,0.25) 50%, rgba(16,40,69,0.25) 100%)",
                                                pointerEvents: "none",
                                                zIndex: 0,
                                            },

                                            // keep content above overlay
                                            "& > *": {
                                                position: "relative",
                                                zIndex: 1,
                                            },
                                        }}
                                    >
                                        <Stack direction="row" spacing={1} alignItems="center">
                                            <InfoOutlinedIcon sx={{ color: '#4BA5EB' }} />
                                            <Typography fontFamily={interFont} fontSize={13} color="#fff" fontWeight={500}>
                                                {/* The more high-quality content, voice samples, and photos you provide, the smarter and more accurate your digital twin becomes. */}
                                                Your Digital Twin has been trained using the content you've uploaded. It helps recommend content on your Dashboard, create courses from your expertise, answer audience questions, and power your AI-driven experiences across the platform. The more high-quality content you provide, the smarter and more personalized your Digital Twin becomes.
                                            </Typography>
                                        </Stack>
                                        {/* <Button
                                            size="small"
                                            startIcon={<ImportContactsOutlinedIcon sx={{ fontSize: '22px', color: '#4BA5EB' }} />}
                                            sx={{
                                                textTransform: "none",
                                                fontFamily: interFont,
                                                fontSize: 12,
                                                // fontWeight: 600,
                                                color: "#fff",
                                                background: 'transparent',
                                                // background: "#4BA5EB",
                                                // border: "1px solid rgba(68, 157, 212, 0.3)",
                                                border: "1px solid #4BA5EB",
                                                borderRadius: "7px",
                                                px: 1.8,
                                                py: 0.5,
                                                display: "inline-flex",
                                                alignItems: "center",
                                                lineHeight: 1, // 👈 removes extra vertical space

                                                "& .MuiButton-startIcon": {
                                                    margin: 0,                 // ❌ remove default margin
                                                    marginRight: "6px",        // ✅ controlled spacing
                                                    display: "flex",
                                                    alignItems: "center",
                                                },

                                                "& .MuiButton-startIcon svg": {
                                                    verticalAlign: "middle",   // 👈 fixes icon baseline issue
                                                },

                                                "&:hover": { background: "rgba(68, 157, 212, 0.3)" },
                                            }}
                                        >
                                            Learn more
                                        </Button>*/}
                                    </Box>
                                </Stack>

                                {/* <div className="row gx-2"> */}
                                <Grid container spacing={2} mt={1}>

                                    {/* old design - left card(Rohan image with intro, ask ai bar and voice uploading) */}
                                    {/* <div className="col-sm-12 col-md-4 col-lg-4 py-4" style={{ paddingLeft: '1.5rem' }}> */}
                                    {/* <Box
                                            component="img"
                                            src={RohanImg}
                                            alt="Rohan Hall"
                                            sx={{
                                                width: "100%",
                                                // height: 260,
                                                objectFit: "cover",
                                                // borderRadius: "12px",
                                                // mb: 2
                                            }}
                                        />
                                        <Paper
                                            sx={{
                                                background: "#0B0C14",
                                                borderTopLeftRadius: 0,
                                                borderTopRightRadius: 0,
                                                borderBottomLeftRadius: "16px",
                                                borderBottomRightRadius: "16px",
                                                border: "1px solid #2a2a2a",
                                                p: 3,
                                                mb: 2
                                            }}
                                        >
                                            <Box position="relative">
                                                <Typography
                                                    sx={{
                                                        color: "#D9D9D9",
                                                        fontSize: "16px",
                                                        lineHeight: "22px",
                                                        mb: 2,
                                                        textAlign: 'center'
                                                    }}
                                                >
                                                    Hi {userDetails?.name}, Now let’s train your digital brain.
                                                    Everything you upload here helps me understand your expertise at a deeper level so I can represent you more accurately and create better content for you.
                                                </Typography>
                                            </Box>
                                        </Paper> */}

                                    {/* Ask box */}
                                    {/* <Paper sx={{ p: 2, background: "#2b2b32", borderRadius: "8px" }}> */}

                                    {/* Chat messages */}
                                    {/* <Box sx={{ maxHeight: 200, overflowY: "auto", mb: 1 }}>
                                                {chatMessages.map((msg, i) => (
                                                    <Box key={i} sx={{ textAlign: msg.role === "user" ? "right" : "left", mb: 1 }}>
                                                        <Typography
                                                            sx={{
                                                                display: "inline-block",
                                                                px: 1.5,
                                                                py: 0.8,
                                                                borderRadius: 2,
                                                                background: msg.role === "user" ? "#4BA5EB" : "#000000",
                                                                color: "#fff",
                                                                fontSize: "14px"
                                                            }}
                                                        >
                                                            {msg.role === "bot" ? (
                                                                <Box
                                                                    dangerouslySetInnerHTML={{ __html: msg.text }}
                                                                />
                                                            ) : (
                                                                msg.text
                                                            )}
                                                        </Typography>
                                                    </Box>
                                                ))}

                                                {isChatLoading && (
                                                    <Typography sx={{ color: "#aaa", fontSize: 12 }}>
                                                        Thinking...
                                                    </Typography>
                                                )}
                                            </Box> */}

                                    {/* Input */}
                                    {/* <TextareaAutosize
                                                value={questionText}
                                                onChange={(e) => setQuestionText(e.target.value)}
                                                placeholder="Ask AI anything..."
                                                minRows={2}
                                                style={{
                                                    width: "100%",
                                                    background: "#2b2b32",
                                                    color: "#fff",
                                                    border: "none",
                                                    outline: "none",
                                                }}
                                            /> */}

                                    {/* Bottom actions */}
                                    {/* <Stack direction="row" justifyContent="flex-end" spacing={1} mt={1}> */}

                                    {/* SPEAKER (GLOBAL) */}
                                    {/*  <IconButton
                                                    onClick={toggleMute}
                                                    sx={{
                                                        background: isMuted
                                                            ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                                            : "linear-gradient(135deg, #4BA5EB 0%, #1E7BC0 100%)",
                                                        borderRadius: "12px",
                                                        width: 45,
                                                        height: 45,
                                                        boxShadow: isMuted
                                                            ? "0 4px 15px rgba(102,126,234,0.5)"
                                                            : "0 4px 15px rgba(75,165,235,0.5)",
                                                        border: "1px solid rgba(255,255,255,0.2)",
                                                        transition: "all 0.3s ease",
                                                        "&:hover": {
                                                            transform: "scale(1.1)",
                                                            boxShadow: isMuted
                                                                ? "0 6px 20px rgba(102,126,234,0.7)"
                                                                : "0 6px 20px rgba(75,165,235,0.7)",
                                                        },
                                                        animation: !isMuted ? "speakerPulse 2s infinite" : "none",
                                                        "@keyframes speakerPulse": {
                                                            "0%": { boxShadow: "0 4px 15px rgba(75,165,235,0.5)" },
                                                            "50%": { boxShadow: "0 4px 25px rgba(75,165,235,0.9)" },
                                                            "100%": { boxShadow: "0 4px 15px rgba(75,165,235,0.5)" },
                                                        },
                                                    }}
                                                >
                                                    {isMuted ? (
                                                        <VolumeOffIcon sx={{ color: "#fff", fontSize: "22px" }} />
                                                    ) : (
                                                        <VolumeUpIcon sx={{ color: "#fff", fontSize: "22px" }} />
                                                    )}
                                                </IconButton> */}

                                    {/* MIC */}
                                    {/*  <IconButton
                                                    // onClick={handleMicClick}
                                                    onClick={() => handleMic(recognitionRef, isListening, setIsListening)}
                                                    sx={{
                                                        animation: isListening ? "pulse 1s infinite" : "none",
                                                        "@keyframes pulse": {
                                                            "0%": { transform: "scale(1)" },
                                                            "50%": { transform: "scale(1.1)" },
                                                            "100%": { transform: "scale(1)" },
                                                        },
                                                    }}
                                                >
                                                    <MicNoneOutlinedIcon sx={{ color: isListening ? "red" : "#fff" }} />
                                                </IconButton> */}

                                    {/* SEND */}
                                    {/* <IconButton onClick={() => getChatBotResponse(questionText)}>
                                                    <SendIcon sx={{ color: "#fff" }} />
                                                </IconButton> */}

                                    {/* </Stack> */}
                                    {/* </Paper> */}

                                    {/* voice uploading */}
                                    {/* <Box sx={{ p: 3, border: '1px solid gray', borderRadius: '5px', mt: 2 }}>
                                            <Typography color="#fff" sx={{ fontSize: '20px', fontWeight: 'bold', mb: 1 }}>Train your voice</Typography>
                                            <Divider />
                                            <Grid container paddingY={'1%'}>
                                                <Typography color="#fff"
                                                    variant="h6"
                                                    fontWeight={400}>Voice Name</Typography>
                                                <TextField
                                                    InputProps={{
                                                        style: customInputStyle,
                                                    }}
                                                    sx={{ width: "100%" }}
                                                    type="text"
                                                    // placeholder="E.g. https://www.linkedin.com/in/profile_name"
                                                    value={voiceName}
                                                    onChange={(e) => setVoiceName(e.target.value)}
                                                />
                                            </Grid>

                                            <Typography color="#fff"
                                                variant="h6"
                                                fontWeight={400} sx={{ mt: 1 }}>Upload Voice Files</Typography>
                                            <input
                                                type="file"
                                                accept=".wav,audio/wav"
                                                multiple
                                                onChange={handleFileChange}
                                            />

                                            {voiceFiles.length > 0 && (
                                                <Box mt={2}>
                                                    <Typography variant="subtitle2" mb={1} color={voiceFiles.length >= 3 ? "green" : "gray"}>
                                                        Selected Files ({voiceFiles.length})
                                                    </Typography>

                                                    <Stack direction="row" flexWrap="wrap" gap={1}>
                                                        {voiceFiles.map((file, index) => (
                                                            <Chip
                                                                key={index}
                                                                label={file.name}
                                                                onDelete={() =>
                                                                    setVoiceFiles((prev) =>
                                                                        prev.filter((_, i) => i !== index)
                                                                    )
                                                                }
                                                                deleteIcon={<CloseIcon />}
                                                                variant="outlined"
                                                                sx={{
                                                                    maxWidth: 250,
                                                                    "& .MuiChip-label": {
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis"
                                                                    },
                                                                    "& .MuiChip-deleteIcon": {
                                                                        color: "red",
                                                                        "&:hover": {
                                                                            color: "darkred",
                                                                        },
                                                                    },
                                                                    color: 'gray'
                                                                }}
                                                            />
                                                        ))}
                                                    </Stack>
                                                </Box>
                                            )}
                                            {voiceFiles.length > 0 && voiceFiles.length < 3 && (
                                                <Typography color="error" variant="caption">
                                                    Minimum 3 WAV files required
                                                </Typography>
                                            )}
                                        </Box> */}
                                    {/* </div> */}
                                    {/* ----------------- END --------- old design - left card(Rohan image with intro, ask ai bar and voice uploading) */}
                                    <Grid item xs={12} md={3.5}>
                                        {/* <Box
                                            sx={{
                                                minHeight: "100vh",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                px: 2,
                                                background: "#0B0C14",
                                            }}
                                        > */}
                                        {/* =============== profile and training status ============== */}
                                        <Paper
                                            sx={{
                                                width: "100%",
                                                // maxWidth: 380,
                                                p: 1.5,
                                                borderRadius: "20px",
                                                textAlign: "center",
                                                /* background:
                                                    "linear-gradient(180deg, rgba(16,40,69,0.6) 0%, rgba(11,12,20,0.9) 100%)", */
                                                background: 'transparent',
                                                backdropFilter: "blur(10px)",
                                                // border: "1px solid rgba(75,165,235,0.2)",
                                                border: "1px solid rgba(255,255,255,0.1)",
                                            }}
                                        >
                                            {/* Title */}
                                            <Typography color="#FFFFFF" fontSize={14} fontWeight={400} mb={2} mt={1} textAlign={'center'}>
                                                Your Digital Twin
                                            </Typography>

                                            {/* Avatar with upload overlay */}
                                            <Box
                                                sx={{
                                                    position: "relative",
                                                    width: 120,
                                                    height: 120,
                                                    margin: "0 auto",
                                                    mb: 2,
                                                }}
                                            >
                                                <Avatar
                                                    src={
                                                        userDetails?.user_image
                                                            ? `${userDetails.user_image}?v=${imageVersion}`
                                                            : undefined
                                                    }
                                                    sx={{
                                                        width: 120,
                                                        height: 120,
                                                        // Slight blur while uploading so the spinner reads cleanly
                                                        filter: isUploadingPhoto ? "blur(2px) brightness(0.6)" : "none",
                                                        transition: "filter 0.25s ease",
                                                        "& img": {
                                                            objectFit: "cover",
                                                            objectPosition: "top center",
                                                        },
                                                    }}
                                                />

                                                {/* Spinner + label overlay — shown only while uploading */}
                                                {isUploadingPhoto && (
                                                    <Box
                                                        sx={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            borderRadius: "50%",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            background: "rgba(0,0,0,0.45)",
                                                            backdropFilter: "blur(2px)",
                                                            zIndex: 2,
                                                        }}
                                                    >
                                                        <CircularProgress
                                                            size={36}
                                                            thickness={4}
                                                            sx={{ color: "#4BA5EB" }}
                                                        />
                                                        <Typography
                                                            fontSize={10}
                                                            color="#fff"
                                                            fontWeight={600}
                                                            mt={0.8}
                                                            letterSpacing="0.04em"
                                                            textTransform="uppercase"
                                                        >
                                                            Uploading
                                                        </Typography>
                                                    </Box>
                                                )}
                                            </Box>

                                            <input
                                                type="file"
                                                accept="image/*"
                                                ref={fileInputRef1}
                                                style={{ display: "none" }}
                                                onChange={handleUserImageChange}
                                            />

                                            <Button
                                                startIcon={
                                                    isUploadingPhoto
                                                        ? <CircularProgress size={14} sx={{ color: "#4BA5EB" }} />
                                                        : <CameraAltIcon />
                                                }
                                                onClick={() => fileInputRef1.current?.click()}
                                                disabled={isUploadingPhoto}
                                                sx={{
                                                    textTransform: "none",
                                                    borderRadius: "10px",
                                                    px: 2,
                                                    py: 0.7,
                                                    color: "#4BA5EB",
                                                    border: "1px solid rgba(75,165,235,0.4)",
                                                    mb: 1.5,
                                                    "&.Mui-disabled": {
                                                        color: "rgba(75,165,235,0.5)",
                                                        borderColor: "rgba(75,165,235,0.2)",
                                                    },
                                                }}
                                            >
                                                {isUploadingPhoto ? "Uploading…" : "Change Photo"}
                                            </Button>

                                            {/* Description */}
                                            <Typography fontSize={12} color="#D9D9D9" mb={3} textAlign={'center'}>
                                                This photo will be used to represent you<br /> across your digital twin.
                                            </Typography>

                                            {/* Status Box */}
                                            <Box
                                                sx={{
                                                    textAlign: "left",
                                                    p: 2,
                                                    borderRadius: "12px",
                                                    border: "1px solid rgba(255,255,255,0.1)",
                                                    background: "rgba(255,255,255,0.02)",
                                                    width: '100%'
                                                }}
                                            >
                                                <Stack direction="row" justifyContent="space-between" mb={1}>
                                                    <Typography color="#fff" fontSize={14}>
                                                        Training Status
                                                    </Typography>

                                                    <Chip
                                                        label="Active"
                                                        size="small"
                                                        sx={{
                                                            background: "rgba(0,200,83,0.2)",
                                                            color: "#00C853",
                                                            fontWeight: 600,
                                                            borderRadius: '5px'
                                                        }}
                                                    />
                                                </Stack>

                                                <Typography fontSize={11} color="#9aa0b4" mb={1}>
                                                    Last updated: {lastUpdated || "--"}{/* May 02, 2026 • 10:32 AM */}
                                                </Typography>

                                                <LinearProgress
                                                    variant="determinate"
                                                    value={voiceTrainProgress}
                                                    sx={{
                                                        height: 6,
                                                        borderRadius: 5,
                                                        backgroundColor: "rgba(255,255,255,0.1)",
                                                        "& .MuiLinearProgress-bar": {
                                                            background: "#4BA5EB",
                                                        },
                                                    }}
                                                />

                                                <Typography fontSize={11} color="#9aa0b4" mt={1}>
                                                    Your twin is learning and improving.
                                                </Typography>
                                            </Box>
                                        </Paper>
                                        {/* xxxxxxxxxxxxx End profile and training status xxxxxxxxxxxxx */}

                                        {/* ======== upload voice data ======= */}
                                        <Box
                                            sx={{
                                                mt: 2,
                                                p: { xs: 2, md: 3 },
                                                borderRadius: "16px",
                                                background: 'transparent',
                                                /* background:
                                                    "linear-gradient(180deg, rgba(16,40,69,0.5) 0%, rgba(11,12,20,0.9) 100%)", */
                                                // border: "1px solid rgba(75,165,235,0.2)",
                                                border: "1px solid rgba(255,255,255,0.1)"
                                            }}
                                        >
                                            {/* HEADER */}
                                            <Stack direction="row" spacing={2} /* alignItems="center" */ mb={2}>
                                                {/* <Box
                                                            sx={{
                                                                width: 32,
                                                                height: 32,
                                                                borderRadius: "50%",
                                                                background: "#4BA5EB",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                fontWeight: 700,
                                                                color: "#000",
                                                            }}
                                                        >
                                                            2
                                                        </Box> */}

                                                <Box>
                                                    <Typography fontSize={18} fontWeight={600} color="#fff">
                                                        Add voice data
                                                    </Typography>
                                                    <Typography fontSize={12} color="#D9D9D9">
                                                        {/* Upload voice recordings to help your digital twin<br /> replicate your voice accurately. */}
                                                        This will help fine tune your digital twin voice to sound more like you.
                                                    </Typography>
                                                </Box>
                                            </Stack>

                                            {/* VOICE NAME */}
                                            {/* <Box mb={2}>
                                                <Typography color="#D9D9D9" fontSize={13} mb={0.5}>
                                                    Voice Name
                                                </Typography>
                                                <TextField
                                                    fullWidth
                                                    InputProps={{
                                                        style: {
                                                            // background: "#1f1f24",
                                                            background: 'transparent',
                                                            color: "#fff",
                                                            borderRadius: "8px",
                                                            border: "1px solid rgba(255,255,255,0.1)"
                                                        },
                                                    }}
                                                    value={voiceName}
                                                    onChange={(e) => setVoiceName(e.target.value)}
                                                />
                                            </Box> */}

                                            {/* DRAG & DROP AREA */}
                                            {/* <Box
                                                sx={{
                                                    border: "1px dashed rgba(255,255,255,0.2)",
                                                    borderRadius: "12px",
                                                    p: 2,
                                                    textAlign: "center",
                                                    background: "rgba(255,255,255,0.02)",
                                                }}
                                            >
                                               
                                                <input
                                                    type="file"
                                                    accept=".wav,audio/wav"
                                                    multiple
                                                    onChange={handleFileChange}
                                                    style={{ display: "none" }}
                                                    id="voice-upload"
                                                />
                                                <GraphicEqIcon sx={{ color: '#4BA5EB', marginBottom: '1px' }} />
                                                <Typography color="#D9D9D9" textAlign={"center"}>
                                                    Drag and drop audio files here
                                                </Typography>

                                                <Typography color="#9aa0b4" mb={1} textAlign={"center"}>
                                                    or
                                                </Typography>

                                                <Button
                                                    variant="outlined"
                                                    onClick={() => document.getElementById("voice-upload")?.click()}
                                                    sx={{
                                                        borderColor: "#4BA5EB",
                                                        color: "#4BA5EB",
                                                        textTransform: "none",
                                                        borderRadius: "8px",
                                                    }}
                                                >
                                                    Choose File
                                                </Button>

                                            </Box> */}

                                            {/* record voice and upload */}
                                            {/* Voice Wave + Mic */}
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <Stack
                                                    direction="row"
                                                    spacing={3}
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    sx={{ width: "100%" }}
                                                >
                                                    {/* Left Wave */}
                                                    <Box
                                                        sx={{
                                                            width: "90px",
                                                            height: "30px",
                                                            background:
                                                                "repeating-linear-gradient(to right, #4BA5EB 0 2px, transparent 2px 8px)",
                                                            opacity: 0.7,
                                                            borderRadius: "20px",
                                                        }}
                                                    />

                                                    {/* Mic Button */}
                                                    <IconButton
                                                        onClick={() =>
                                                            isRecording1 ? stopRecording1() : startRecording1()
                                                        }
                                                        className={isRecording1 ? "recording-mic-btn" : "mic-btn"}
                                                        sx={{
                                                            width: 60,
                                                            height: 60,
                                                            background: isRecording1
                                                                ? "linear-gradient(135deg, #ff4d4d, #ff0000)"
                                                                : "linear-gradient(135deg, #4BA5EB, #2563EB)",
                                                            "&:hover": {
                                                                background: isRecording1
                                                                    ? "linear-gradient(135deg, #ff4d4d, #ff0000)"
                                                                    : "linear-gradient(135deg, #4BA5EB, #2563EB)",
                                                            },
                                                        }}
                                                    >
                                                        <MicNoneOutlinedIcon
                                                            sx={{
                                                                color: "#fff",
                                                                fontSize: "22px",
                                                            }}
                                                        />
                                                    </IconButton>

                                                    {/* Right Wave */}
                                                    <Box
                                                        sx={{
                                                            width: "90px",
                                                            height: "30px",
                                                            background:
                                                                "repeating-linear-gradient(to right, #4BA5EB 0 2px, transparent 2px 8px)",
                                                            opacity: 0.7,
                                                            borderRadius: "20px",
                                                        }}
                                                    />
                                                </Stack>

                                                {/* <Typography
                                                    sx={{
                                                        mt: 2,
                                                        color: "#4BA5EB",
                                                        fontWeight: 600,
                                                        fontSize: "16px",
                                                    }}
                                                >
                                                    {isRecording1 ? "Recording..." : "Tap to speak"}
                                                </Typography> */}
                                                <Typography
                                                    sx={{
                                                        mt: 2,
                                                        color: isRecording1 ? "#ff4d4d" : "#4BA5EB",
                                                        fontWeight: 700,
                                                        fontSize: "16px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    {isRecording1
                                                        ? `Recording • ${formatTime(recordingTime)}`
                                                        : "Tap to speak"}
                                                </Typography>

                                                <Typography
                                                    sx={{
                                                        color: "rgba(255,255,255,0.6)",
                                                        fontSize: "13px",
                                                        mt: 0.5,
                                                    }}
                                                >
                                                    Record your audio directly
                                                </Typography>
                                            </Box>

                                            <Typography fontSize={10.5} color="D9D9D9" mt={2}>
                                                Recommended: Clear recordings, 30 secs - 2 minutes total
                                            </Typography>

                                            {/*  <Typography fontSize={11} color="#D9D9D9">
                                                Formats: MP3, WAV, M4A • Max size: 200MB
                                            </Typography> */}

                                            {/* FILE LIST (UNCHANGED LOGIC) */}
                                            {/* {voiceFiles.length > 0 && (
                                                <Box mt={2}>
                                                    <Typography
                                                        variant="subtitle2"
                                                        mb={1}
                                                        color={voiceFiles.length >= 3 ? "green" : "#9aa0b4"}
                                                    >
                                                        Selected Files ({voiceFiles.length})
                                                    </Typography>

                                                    <Stack direction="row" flexWrap="wrap" gap={1}>
                                                        {voiceFiles.map((file, index) => (
                                                            <Chip
                                                                key={index}
                                                                label={file.name}
                                                                onDelete={() =>
                                                                    setVoiceFiles((prev) =>
                                                                        prev.filter((_, i) => i !== index)
                                                                    )
                                                                }
                                                                deleteIcon={<CloseIcon />}
                                                                variant="outlined"
                                                                sx={{
                                                                    maxWidth: 250,
                                                                    color: "#ccc",
                                                                    borderColor: "rgba(255,255,255,0.2)",
                                                                    "& .MuiChip-label": {
                                                                        overflow: "hidden",
                                                                        textOverflow: "ellipsis",
                                                                    },
                                                                    "& .MuiChip-deleteIcon": {
                                                                        color: "red",
                                                                        "&:hover": { color: "darkred" },
                                                                    },
                                                                }}
                                                            />
                                                        ))}
                                                    </Stack>
                                                </Box>
                                            )}

                                            {voiceFiles.length > 0 && voiceFiles.length < 3 && (
                                                <Typography color="error" variant="caption">
                                                    Minimum 3 WAV files required
                                                </Typography>
                                            )} */}
                                            {/* Recorded Files */}
                                            <Stack spacing={2} mt={2}>
                                                {loadingVoices ? (
                                                    <Stack spacing={2} mt={2}>
                                                        {[1, 2].map((item) => (
                                                            <Box
                                                                key={item}
                                                                sx={{
                                                                    border: "1px solid rgba(255,255,255,0.15)",
                                                                    borderRadius: "10px",
                                                                    p: 1.5,
                                                                    background: "rgba(255,255,255,0.03)",
                                                                }}
                                                            >
                                                                <Skeleton
                                                                    variant="text"
                                                                    width="60%"
                                                                    height={25}
                                                                    sx={{ bgcolor: "rgba(255,255,255,0.12)" }}
                                                                />

                                                                <Skeleton
                                                                    variant="rectangular"
                                                                    width="100%"
                                                                    height={36}
                                                                    sx={{
                                                                        mt: 1,
                                                                        borderRadius: "8px",
                                                                        bgcolor: "rgba(255,255,255,0.12)",
                                                                    }}
                                                                />
                                                            </Box>
                                                        ))}
                                                    </Stack>
                                                ) : (voiceFiles.map((file: any, index) => (
                                                    <Box
                                                        key={index}
                                                        sx={{
                                                            border: "1px solid rgba(255,255,255,0.15)",
                                                            borderRadius: "10px",
                                                            p: 1.5,
                                                            background: "rgba(255,255,255,0.03)",
                                                        }}
                                                    >
                                                        <Stack
                                                            direction="row"
                                                            justifyContent="space-between"
                                                            alignItems="center"
                                                            mb={1}
                                                        >
                                                            <Typography
                                                                sx={{
                                                                    color: "#ccc",
                                                                    fontSize: "13px",
                                                                    maxWidth: "250px",
                                                                    overflow: "hidden",
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                }}
                                                            >
                                                                {file.name}
                                                            </Typography>

                                                            <IconButton
                                                                size="small"
                                                                onClick={() =>
                                                                    setVoiceFiles((prev) =>
                                                                        prev.filter((_: any, i: number) => i !== index)
                                                                    )
                                                                }
                                                            >
                                                                <CloseIcon sx={{ color: "red", fontSize: 18 }} />
                                                            </IconButton>
                                                        </Stack>
                                                        {(() => {
                                                            console.log("preview url =>", file.preview);
                                                            return null;
                                                        })()}
                                                        {/* AUDIO PLAYER */}
                                                        <audio
                                                            controls
                                                            src={file.preview}
                                                            style={{
                                                                width: "100%",
                                                                height: "36px",
                                                            }}
                                                        />
                                                    </Box>
                                                )))}

                                                {/* {voiceFiles.length > 0 && ( */}
                                                {voiceFiles.some((file: any) => !file.isExisting) && (
                                                    <Button
                                                        variant="contained"
                                                        fullWidth
                                                        onClick={() => validateAndTrainVoice(voiceFiles)}
                                                        sx={{
                                                            mt: 2,
                                                            borderRadius: "10px",
                                                            textTransform: "none",
                                                            fontWeight: 600,
                                                            background: "linear-gradient(135deg, #4BA5EB, #2563EB)",
                                                            "&:hover": {
                                                                background: "linear-gradient(135deg, #4BA5EB, #2563EB)",
                                                            },
                                                        }}
                                                    >
                                                        Add Voice
                                                    </Button>)}
                                                {/* )} */}
                                            </Stack>

                                            {/* {voiceFiles.length > 0 && voiceFiles.length < 3 && (
                                                <Typography color="error" variant="caption">
                                                    Minimum 3 recordings required
                                                </Typography>
                                            )} */}
                                        </Box>
                                        {/* ======== End upload voice data ======== */}

                                        {/* ========= Ask AI ========== */}
                                        {/* Ask box */}
                                        {/* <Paper sx={{ p: 2, background: "#2b2b32", borderRadius: 4, mt: 1 }}>

                                            <Box sx={{ maxHeight: 200, overflowY: "auto", mb: 1 }}>
                                                {chatMessages.map((msg, i) => (
                                                    <Box key={i} sx={{ textAlign: msg.role === "user" ? "right" : "left", mb: 1 }}>
                                                        <Typography
                                                            sx={{
                                                                display: "inline-block",
                                                                px: 1.5,
                                                                py: 0.8,
                                                                borderRadius: 2,
                                                                background: msg.role === "user" ? "#4BA5EB" : "#000000",
                                                                color: "#fff",
                                                                fontSize: "14px"
                                                            }}
                                                        >
                                                            {msg.role === "bot" ? (
                                                                <Box
                                                                    dangerouslySetInnerHTML={{ __html: msg.text }}
                                                                />
                                                            ) : (
                                                                msg.text
                                                            )}
                                                        </Typography>
                                                    </Box>
                                                ))}

                                                {isChatLoading && (
                                                    <Typography sx={{ color: "#aaa", fontSize: 12 }}>
                                                        Thinking...
                                                    </Typography>
                                                )}
                                            </Box>

                                            <TextareaAutosize
                                                value={questionText}
                                                onChange={(e) => setQuestionText(e.target.value)}
                                                placeholder="Ask AI anything..."
                                                minRows={2}
                                                style={{
                                                    width: "100%",
                                                    background: "#2b2b32",
                                                    color: "#fff",
                                                    border: "none",
                                                    outline: "none",
                                                }}
                                            />

                                            <Stack direction="row" justifyContent="flex-end" spacing={1} mt={1}>
                                                <IconButton
                                                    onClick={toggleMute}
                                                    sx={{
                                                        background: isMuted
                                                            ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                                            : "linear-gradient(135deg, #4BA5EB 0%, #1E7BC0 100%)",
                                                        borderRadius: "12px",
                                                        width: 45,
                                                        height: 45,
                                                        boxShadow: isMuted
                                                            ? "0 4px 15px rgba(102,126,234,0.5)"
                                                            : "0 4px 15px rgba(75,165,235,0.5)",
                                                        border: "1px solid rgba(255,255,255,0.2)",
                                                        transition: "all 0.3s ease",
                                                        "&:hover": {
                                                            transform: "scale(1.1)",
                                                            boxShadow: isMuted
                                                                ? "0 6px 20px rgba(102,126,234,0.7)"
                                                                : "0 6px 20px rgba(75,165,235,0.7)",
                                                        },
                                                        animation: !isMuted ? "speakerPulse 2s infinite" : "none",
                                                        "@keyframes speakerPulse": {
                                                            "0%": { boxShadow: "0 4px 15px rgba(75,165,235,0.5)" },
                                                            "50%": { boxShadow: "0 4px 25px rgba(75,165,235,0.9)" },
                                                            "100%": { boxShadow: "0 4px 15px rgba(75,165,235,0.5)" },
                                                        },
                                                    }}
                                                >
                                                    {isMuted ? (
                                                        <VolumeOffIcon sx={{ color: "#fff", fontSize: "22px" }} />
                                                    ) : (
                                                        <VolumeUpIcon sx={{ color: "#fff", fontSize: "22px" }} />
                                                    )}
                                                </IconButton>

                                                <IconButton
                                                    onClick={() =>
                                                        isRecording
                                                            ? stopRecording("questions")
                                                            : startRecording("questions")
                                                    }
                                                    className={isRecording ? "recording-mic-btn" : "mic-btn"}
                                                >
                                                    <MicNoneOutlinedIcon sx={{ color: "#fff", fontSize: "20px", }} />
                                                </IconButton>

                                                <IconButton onClick={() => getChatBotResponse(questionText)}>
                                                    <SendIcon sx={{ color: "#fff" }} />
                                                </IconButton>

                                            </Stack>
                                        </Paper> */}
                                        {/* xxxxxxxxx End Ask AI xxxxxxxx */}
                                        {/* </Box> */}
                                    </Grid>

                                    <Grid item xs={12} md={8.5}>
                                        {/* ============ upload contents here ============ */}
                                        <Typography
                                            sx={{
                                                textAlign: "center",
                                                fontSize: { xs: "22px", md: "32px" },
                                                fontWeight: 700,
                                                color: "#fff",
                                                lineHeight: 1.3,
                                                mb: 1.5
                                            }}
                                        >
                                            Add content to train your{" "}
                                            <span
                                                style={{
                                                    background: "linear-gradient(90deg, #4BA5EB, #6C63FF)",
                                                    WebkitBackgroundClip: "text",
                                                    WebkitTextFillColor: "transparent"
                                                }}
                                            >
                                                AI Digital Twin <AutoAwesomeIcon sx={{ fontSize: 24, color: "gold" }} />
                                            </span>
                                        </Typography>

                                        <Typography
                                            sx={{
                                                textAlign: "center",
                                                fontSize: "14px",
                                                color: "#A0AEC0",
                                                maxWidth: "600px",
                                                mx: "auto",
                                                lineHeight: 1.6
                                            }}
                                        >
                                            Add any content you already have. This helps me understand
                                            your knowledge, style, and unique perspective.
                                        </Typography>
                                        <Box sx={{
                                            mt: 4,
                                            p: 3,
                                            borderRadius: "16px",
                                            border: "1px solid #767676",
                                        }}>
                                            <Paper
                                                sx={{
                                                    p: 3,
                                                    borderRadius: "12px",
                                                    background: "#1f1f24",
                                                    border: "1px solid #2f2f36",
                                                    width: "100%",
                                                }}
                                            >
                                                {/* SECTION TITLE */}


                                                {/* TAB STYLE SELECTOR */}
                                                <Grid container spacing={2} sx={{ mb: 3 }}>
                                                    {[
                                                        { label: "Document", value: "word", icon: <DescriptionOutlinedIcon />, color: "#6C63FF", desc: "Upload PDFs, Word docs, or Presentation." },
                                                        { label: "Website / URL", value: "https://", icon: <LinkOutlinedIcon />, color: "#22C55E", desc: "Add links to your website, blog, articles or publications." },
                                                        { label: "Audio / Video", value: "upload", icon: <SmartDisplayOutlinedIcon />, color: "#F59E0B", desc: "Upload videos, podcasts, or audio files." },
                                                        { label: "Text", value: "text", icon: <TitleIcon />, color: "#EF4444", desc: "Paste or type content like articles, notes or scripts." },
                                                        //{ label: "More Later", value: "later", icon: <CloudUploadOutlinedIcon />, color: "#06B6D4", desc: "You can always add more content after setup." },
                                                    ].map((item, index) => {
                                                        const selected =
                                                            (urlPrefix || campDetails?.source || "upload") === item.value;

                                                        const isDisabled = item.value === "later";
                                                        const isAudioVideoLocked =
                                                            item.value === "upload" &&
                                                            ["level_0a", "level_4", "level_5"].includes(userDetails?.subscription_level);

                                                        return (
                                                            <Grid item xs={12} sm={6} md={3} key={index}>
                                                                <Tooltip
                                                                    title={
                                                                        isAudioVideoLocked
                                                                            ? "You can unlock this feature in higher plans."
                                                                            : ""
                                                                    }
                                                                    arrow
                                                                    placement="top"
                                                                >

                                                                    <Box
                                                                        onClick={() => {
                                                                            if (!isDisabled && !isAudioVideoLocked) {
                                                                                handleSourceSelect(item.value);
                                                                            }
                                                                        }}
                                                                        sx={{
                                                                            p: 2,
                                                                            borderRadius: "14px",
                                                                            cursor: isAudioVideoLocked
                                                                                ? "not-allowed"
                                                                                : isDisabled
                                                                                    ? "default"
                                                                                    : "pointer",/* isDisabled ? "default" : "pointer" */
                                                                            border: selected
                                                                                ? "1px solid #3B82F6"
                                                                                : "1px solid rgba(255,255,255,0.08)",
                                                                            background:
                                                                                "linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01))",
                                                                            textAlign: "center",
                                                                            position: "relative",

                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            alignItems: "center",
                                                                            justifyContent: "space-between",
                                                                            height: "100%",

                                                                            "&:hover": {
                                                                                borderColor: isAudioVideoLocked
                                                                                    ? "rgba(255,255,255,0.12)"
                                                                                    : "#3B82F6",
                                                                            },
                                                                            overflow: "hidden",
                                                                        }}
                                                                    >

                                                                        {isAudioVideoLocked && (
                                                                            <Box
                                                                                sx={{
                                                                                    position: "absolute",
                                                                                    inset: 0,
                                                                                    background: "rgba(255,255,255,0.12)", // Lighter overlay
                                                                                    backdropFilter: "blur(1px)",
                                                                                    WebkitBackdropFilter: "blur(1px)",
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    justifyContent: "center",
                                                                                    zIndex: 10,
                                                                                    borderRadius: "14px",
                                                                                }}
                                                                            >
                                                                                <Box
                                                                                    sx={{
                                                                                        width: 50,
                                                                                        height: 50,
                                                                                        borderRadius: "50%",
                                                                                        bgcolor: "rgba(0,0,0,0.55)",
                                                                                        border: "2px solid rgba(255,255,255,0.35)",
                                                                                        boxShadow: "0 4px 16px rgba(0,0,0,0.35)",
                                                                                        display: "flex",
                                                                                        alignItems: "center",
                                                                                        justifyContent: "center",
                                                                                    }}
                                                                                >
                                                                                    <LockOutlinedIcon
                                                                                        sx={{
                                                                                            color: "#fff",
                                                                                            fontSize: 26,
                                                                                        }}
                                                                                    />
                                                                                </Box>
                                                                            </Box>
                                                                        )}

                                                                        {/* Selected Tick */}
                                                                        {selected && (
                                                                            <CheckCircleIcon
                                                                                sx={{
                                                                                    position: "absolute",
                                                                                    top: 8,
                                                                                    right: 8,
                                                                                    color: "#3B82F6",
                                                                                    fontSize: 18,
                                                                                }}
                                                                            />
                                                                        )}

                                                                        {/* Icon Circle */}
                                                                        <Box
                                                                            sx={{
                                                                                width: 50,
                                                                                height: 50,
                                                                                borderRadius: "50%",
                                                                                fontSize: 26,
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                justifyContent: "center",
                                                                                background: item.color,
                                                                            }}
                                                                        >
                                                                            {React.cloneElement(item.icon, { fontSize: "medium", color: "fff" })}
                                                                        </Box>

                                                                        {/* Title */}
                                                                        <Typography sx={{ color: "#fff", fontSize: 12, mb: 1, textAlign: "center", maxWidth: "140px", mx: "auto", }}>
                                                                            {item.label}
                                                                        </Typography>

                                                                        <Typography sx={{ color: "#fff", fontSize: 10, mb: 1, textAlign: "center", maxWidth: "150px", mx: "auto", lineHeight: "18px", minHeight: "36px", }}>
                                                                            {item.desc}
                                                                        </Typography>

                                                                        {/* Button
                                                                          <Button
                                                                            variant={selected ? "contained" : "outlined"}
                                                                            sx={{
                                                                              fontSize: "12px",
                                                                              textTransform: "none",
                                                                              borderRadius: "8px",
                                                                              mt: 1,
                                                                              backgroundColor: selected ? "#3B82F6" : "transparent",
                                                                              color: "#fff",
                                                                              borderColor: "rgba(255,255,255,0.2)",
                                                                            }}
                                                                          >
                                                                            Add Source
                                                                          </Button> */}
                                                                    </Box>
                                                                </Tooltip>
                                                            </Grid>
                                                        );
                                                    })}
                                                </Grid>

                                                {/* INPUT AREA */}
                                                <Box sx={{ width: "100%" }}>
                                                    {urlPrefix === "text" || campDetails?.source === "text" ? (
                                                        <Box sx={{ position: "relative", width: "100%" }}>
                                                            <Box
                                                                sx={{
                                                                    height: "160px",
                                                                    maxHeight: "160px",
                                                                    overflowY: "auto",
                                                                    border: "1px solid #3a3a42",
                                                                    borderRadius: "10px",
                                                                    background: "#18181c",
                                                                }}
                                                            >
                                                                <TextareaAutosize
                                                                    style={{
                                                                        width: "100%",
                                                                        minHeight: "100%",
                                                                        border: "none",
                                                                        background: "transparent",
                                                                        color: "#fff",
                                                                        padding: "14px",
                                                                        fontSize: "14px",
                                                                        outline: "none",
                                                                        resize: "none",
                                                                    }}
                                                                    value={
                                                                        campDetails
                                                                            ? campDetails?.product_desc
                                                                            : userBusinessText
                                                                    }
                                                                    onChange={handleTextChange}
                                                                    placeholder="Describe your business, expertise, or content..."
                                                                />
                                                            </Box>
                                                            <IconButton
                                                                // onClick={handleMicClick1}
                                                                onClick={() => handleMic(recognitionRef1, isListening1, setIsListening1)}
                                                                /* sx={{
                                                                    position: "absolute",
                                                                    bottom: "10px",
                                                                    right: "10px",
                                                                    animation: isListening1 ? "pulse 1s infinite" : "none",
                                                                    "@keyframes pulse": {
                                                                        "0%": { transform: "scale(1)" },
                                                                        "50%": { transform: "scale(1.1)" },
                                                                        "100%": { transform: "scale(1)" },
                                                                    },
                                                                }} */
                                                                className={isListening1 ? "recording-mic-btn" : "mic-btn"}
                                                                sx={{
                                                                    // width: 60,
                                                                    // height: 60,
                                                                    position: "absolute",
                                                                    bottom: "10px",
                                                                    right: "10px",
                                                                    background:
                                                                        "linear-gradient(135deg, #4BA5EB, #2563EB)",
                                                                    "&:hover": { background: "linear-gradient(135deg, #4BA5EB, #2563EB)" }
                                                                }}
                                                            >
                                                                <MicNoneOutlinedIcon
                                                                    sx={{ color: /* isListening1 ? "red" : */ "#fff" }}
                                                                />
                                                            </IconButton>
                                                        </Box>
                                                    ) : urlPrefix === "https://" ||
                                                        campDetails?.source === "url" ? (
                                                        <TextField
                                                            fullWidth
                                                            placeholder="Enter your website URL"
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    background: "#18181c",
                                                                    borderRadius: "10px",
                                                                    color: "#fff",
                                                                    "& fieldset": {
                                                                        borderColor: "#3a3a42",
                                                                    },
                                                                    "&:hover fieldset": {
                                                                        borderColor: "#4b4b55",
                                                                    },
                                                                    "&.Mui-focused fieldset": {
                                                                        borderColor: "#3b82f6",
                                                                    },
                                                                },
                                                            }}
                                                            InputProps={{
                                                                readOnly: FromEdit,
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <Typography sx={{ color: "#6b7280" }}>
                                                                            https://
                                                                        </Typography>
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                            value={campDetails ? campDetails?.url : sourceUrl}
                                                            onChange={handleSourceUrlChange}
                                                            id="sourceurl"
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter" && sourceUrl.trim()) {
                                                                    e.preventDefault();
                                                                    handleAddContent();
                                                                }
                                                            }}
                                                        />
                                                    ) : urlPrefix === "upload" ? (
                                                        <Box
                                                            sx={{
                                                                position: "relative",
                                                                border: "1px dashed rgba(75,165,235,0.4)",
                                                                borderRadius: "12px",
                                                                px: 3,
                                                                py: 2,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 2,
                                                                background:
                                                                    "linear-gradient(90deg, rgba(11,25,45,0.6), rgba(11,25,45,0.2))",
                                                                cursor: "pointer",

                                                                "&:hover": {
                                                                    borderColor: "#4BA5EB",
                                                                    background:
                                                                        "linear-gradient(90deg, rgba(11,25,45,0.8), rgba(11,25,45,0.3))",
                                                                },
                                                            }}
                                                        >
                                                            <input
                                                                type="file"
                                                                accept="video/*,audio/*"
                                                                style={{
                                                                    position: "absolute",
                                                                    top: 0,
                                                                    left: 0,
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    opacity: 0,
                                                                    cursor: "pointer",
                                                                    zIndex: 2,
                                                                }}
                                                                onChange={handleuploadvideoChange}
                                                            />

                                                            <CloudUploadOutlinedIcon
                                                                sx={{
                                                                    color: "#4BA5EB",
                                                                    fontSize: 26,
                                                                    flexShrink: 0,
                                                                }}
                                                            />

                                                            {/* Text block */}
                                                            <Box>
                                                                <Typography sx={{ color: "#D1D5DB", fontSize: "14px" }}>
                                                                    Or drag and drop files here to upload
                                                                </Typography>

                                                                <Typography
                                                                    sx={{
                                                                        fontSize: "12px",
                                                                        color: "#A0AEC0",
                                                                        mt: 0.3,
                                                                    }}
                                                                >
                                                                    MP3, MP4, WAV (Max 100MB each)
                                                                </Typography>
                                                            </Box>

                                                            {isUploadLoading && (
                                                                <CircularProgress size={28} sx={{ mt: 2 }} />
                                                            )}
                                                        </Box>
                                                    ) : urlPrefix === "word" ? (
                                                        <Box
                                                            sx={{
                                                                position: "relative",
                                                                border: "1px dashed rgba(75,165,235,0.4)",
                                                                borderRadius: "12px",
                                                                px: 3,
                                                                py: 2,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 2,
                                                                background:
                                                                    "linear-gradient(90deg, rgba(11,25,45,0.6), rgba(11,25,45,0.2))",
                                                                cursor: "pointer",

                                                                "&:hover": {
                                                                    borderColor: "#4BA5EB",
                                                                    background:
                                                                        "linear-gradient(90deg, rgba(11,25,45,0.8), rgba(11,25,45,0.3))",
                                                                },
                                                            }}
                                                        >
                                                            <input
                                                                type="file"
                                                                accept=".doc,.docx,.pdf"
                                                                style={{
                                                                    position: "absolute",
                                                                    inset: 0,
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    opacity: 0,
                                                                    cursor: "pointer",
                                                                }}
                                                                onChange={handleuploadvideoChange}
                                                            />

                                                            <CloudUploadOutlinedIcon
                                                                sx={{
                                                                    color: "#4BA5EB",
                                                                    fontSize: 26,
                                                                    flexShrink: 0,
                                                                }}
                                                            />

                                                            {/* Text block */}
                                                            <Box>
                                                                <Typography sx={{ color: "#D1D5DB", fontSize: "14px" }}>
                                                                    Or drag and drop files here to upload
                                                                </Typography>

                                                                <Typography
                                                                    sx={{
                                                                        fontSize: "12px",
                                                                        color: "#A0AEC0",
                                                                        mt: 0.3,
                                                                    }}
                                                                >
                                                                    PDF, DOCX, TXT (Max 100MB each)
                                                                </Typography>
                                                            </Box>

                                                            {isUploadLoading && (
                                                                <CircularProgress size={28} sx={{ mt: 2 }} />
                                                            )}
                                                        </Box>
                                                    ) : (
                                                        <Box
                                                            sx={{
                                                                position: "relative",
                                                                border: "1px dashed rgba(75,165,235,0.4)",
                                                                borderRadius: "12px",
                                                                px: 3,
                                                                py: 2,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 2,
                                                                background:
                                                                    "linear-gradient(90deg, rgba(11,25,45,0.6), rgba(11,25,45,0.2))",
                                                                cursor: "pointer",

                                                                "&:hover": {
                                                                    borderColor: "#4BA5EB",
                                                                    background:
                                                                        "linear-gradient(90deg, rgba(11,25,45,0.8), rgba(11,25,45,0.3))",
                                                                },
                                                            }}
                                                        >
                                                            <input
                                                                type="file"
                                                                accept=".doc,.docx,.pdf"
                                                                style={{
                                                                    position: "absolute",
                                                                    inset: 0,
                                                                    width: "100%",
                                                                    height: "100%",
                                                                    opacity: 0,
                                                                    cursor: "pointer",
                                                                }}
                                                                onChange={handleuploadvideoChange}
                                                            />

                                                            <CloudUploadOutlinedIcon
                                                                sx={{
                                                                    color: "#4BA5EB",
                                                                    fontSize: 26,
                                                                    flexShrink: 0,
                                                                }}
                                                            />

                                                            {/* Text block */}
                                                            <Box>
                                                                <Typography sx={{ color: "#D1D5DB", fontSize: "14px" }}>
                                                                    Or drag and drop files here to upload
                                                                </Typography>

                                                                <Typography
                                                                    sx={{
                                                                        fontSize: "12px",
                                                                        color: "#A0AEC0",
                                                                        mt: 0.3,
                                                                    }}
                                                                >
                                                                    PDF, DOCX, TXT (Max 100MB each)
                                                                </Typography>
                                                            </Box>

                                                            {isUploadLoading && (
                                                                <CircularProgress size={28} sx={{ mt: 2 }} />
                                                            )}
                                                        </Box>
                                                    )}
                                                </Box>
                                                {isloadingGetPage && !getPageError && (
                                                    <div style={{
                                                        padding: '20px',
                                                        //backgroundColor: '#282C39',
                                                        //borderRadius: '8px',
                                                        //boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                        textAlign: 'center'
                                                    }}>

                                                        {/* Custom Progress Bar */}
                                                        <Box
                                                            sx={{
                                                                width: "100%",
                                                                height: "10px",
                                                                background: "rgba(255,255,255,0.08)",
                                                                borderRadius: "999px",
                                                                overflow: "hidden",
                                                                position: "relative",
                                                                mt: 2,
                                                            }}
                                                        >
                                                            <Box
                                                                sx={{
                                                                    width: `${loaderProgress}%`,
                                                                    height: "100%",
                                                                    borderRadius: "999px",
                                                                    background:
                                                                        "linear-gradient(90deg, #3B82F6 0%, #6366F1 50%, #8B5CF6 100%)",
                                                                    transition: "width 0.4s ease-in-out",
                                                                    boxShadow: "0 0 14px rgba(99,102,241,0.45)",
                                                                }}
                                                            />
                                                        </Box>

                                                        <Typography style={{ fontSize: '16px', textAlign: "center" }}>
                                                            {processingStage === "transcribing" && "Transcribing your content…"}
                                                            {processingStage === "combining_text" && "Organizing your content…"}
                                                            {processingStage === "migrating" && "Building your podcast library…"}
                                                            {processingStage === "updating_skillset" && "Updating your skillset & bio…"}
                                                            {processingStage === "done" && "All set! Your Digital Twin is ready."}
                                                            {processingStage === "idle" && "Uploading…"}
                                                        </Typography>
                                                    </div>
                                                )}
                                            </Paper>

                                            <input
                                                ref={fileInputRef}
                                                type="file"
                                                hidden
                                                multiple
                                                onChange={handleFilesUpload}
                                            />
                                            {urlPrefix !== "word" && urlPrefix !== "pdf" && (
                                                <Button
                                                    variant="contained"
                                                    sx={{ mt: 2 }}
                                                    onClick={handleAddContent}
                                                    disabled={!isInputValid}
                                                >
                                                    Add Content
                                                </Button>
                                            )}
                                        </Box>
                                        {/* xxxxxxxxxxxxxxxx End upload contents here xxxxxxxxxxxxxxxx */}

                                        {/* =========== List Uploaded Contents ============= */}
                                        {hasAnyUploadedContent && (<Box sx={{
                                            mt: 2,
                                            p: 3,
                                            borderRadius: "16px",
                                            // border: "1px solid #767676",
                                            border: "1px solid rgba(255,255,255,0.1)",
                                        }}>
                                            <Stack direction="row" spacing={1.5} alignItems="center" mb={2}>
                                                <Box component="img" src={checkGreen} sx={{ width: 22 }} />
                                                <Typography fontSize="18px" fontWeight="bold" color="white">
                                                    Uploaded Content
                                                </Typography>
                                            </Stack>

                                            {hasValidItems(audioItems) && (<UploadedGroup
                                                icon={audioIcon}
                                                title="Audio"
                                                items={audioItems}
                                                onDelete={(index) => requestDelete("audio", index)}
                                            />)}

                                            {hasValidItems(videoItems) && (<UploadedGroup
                                                icon={videoIcon}
                                                title="Video"
                                                items={videoItems}
                                                onDelete={(index) => requestDelete("video", index)}
                                            />)}

                                            {hasValidItems(documentItems) && (<UploadedGroup
                                                icon={docIcon}
                                                title="Document File (Pdf/word)"
                                                items={documentItems}
                                                onDelete={(index) => requestDelete("document", index)}
                                            />)}

                                            {/*}<UploadedGroup
                                                                                            icon={youtubeIcon}
                                                                                            title="YouTube URL"
                                                                                            items={youtubeItems}
                                                                                            onDelete={(index) => requestDelete("youtube", index)}
                                                                                        />*/}

                                            {hasValidItems(webItems) && (<UploadedGroup
                                                icon={linkIcon}
                                                title="Web URLs"
                                                items={webItems}
                                                onDelete={(index) => requestDelete("web", index)}
                                            />)}

                                            {hasValidItems(textDocItems) && (<UploadedGroup
                                                icon={textIcon}
                                                title="Text Documents"
                                                items={textDocItems}
                                                onDelete={(index) => requestDelete("text", index)}
                                            />)}
                                        </Box>)}
                                        {/* xxxxxxxxx End List Uploaded Contents xxxxxxxxx */}

                                        {/* ======== Step 2 and 3 ======= */}
                                        <Grid container spacing={2} mt={1}>

                                            {/* ======== upload voice data ======= */}
                                            {/* <Grid item xs={12} md={6}>
                                               
                                            </Grid> */}
                                            {/* xxxxxxxxxx End upload voice data xxxxxxxxxx */}

                                            {/* ======= instructions for your digital twin ======== */}
                                            {/* <Grid item xs={12} md={6}>
                                                <Box
                                                    sx={{
                                                        height: "100%",
                                                        p: { xs: 2, md: 3 },
                                                        borderRadius: "16px",
                                                        background: "transparent",
                                                        border: "1px solid rgba(255,255,255,0.1)",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent: "space-between",
                                                    }}
                                                >
                                                   
                                                    <Stack direction="row" spacing={2} mb={2}>
                                                        <Box
                                                            sx={{
                                                                width: 32,
                                                                height: 32,
                                                                borderRadius: "50%",
                                                                background: "#4BA5EB",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                fontWeight: 700,
                                                                color: "#000",
                                                            }}
                                                        >
                                                            3
                                                        </Box>

                                                        <Box>
                                                            <Typography fontSize={18} fontWeight={600} color="#fff">
                                                                Instructions for your digital twin
                                                            </Typography>
                                                            <Typography fontSize={12} color="#D9D9D9">
                                                                Provide guidance and key context for how your<br /> digital twin should represent you.
                                                            </Typography>
                                                        </Box>
                                                    </Stack>

                                                    <Box
                                                        sx={{
                                                            borderRadius: "12px",
                                                            border: "1px solid rgba(255,255,255,0.1)",
                                                            background: "rgba(255,255,255,0.02)",
                                                            p: 2,
                                                            flex: 1,
                                                        }}
                                                    >
                                                        <TextareaAutosize
                                                            placeholder={`e.g. How should my digital twin introduce itself? What topics should it focus on? Any tone, style, or rules it should follow?`}
                                                            style={{
                                                                width: "100%",
                                                                height: "120px",
                                                                background: "transparent",
                                                                border: "none",
                                                                outline: "none",
                                                                color: "#fff",
                                                                resize: "none",
                                                                fontSize: "14px",
                                                            }}
                                                            value={DTinstruction}
                                                            onChange={(e: any) => setDTinstruction(e.target.value)}
                                                        />
                                                    </Box>

                                                    <Typography fontSize={11} color="#9aa0b4" mt={2}>
                                                        The more detail you provide, the better your twin can represent you.
                                                    </Typography>
                                                </Box>
                                            </Grid> */}
                                            {/* xxxxxxx End instructions for youe digital twin xxxxxxx */}

                                        </Grid>
                                        {/* xxxxxxxxx End step 2 and 3 xxxxxxxxxxx */}


                                    </Grid>

                                    {/* </div> */}</Grid>

                                <Stack spacing={1.5} mt={2}>
                                    <Box
                                        sx={{
                                            mb: 2,
                                            px: 2,
                                            py: 1.2,
                                            borderRadius: "10px",
                                            background: "transparent",
                                            // background: "linear-gradient(90deg, rgba(16, 40, 69, 0.6) 0%, rgba(24, 64, 107, 0.6) 50%, rgba(16, 40, 69, 0.6) 100%)",
                                            backdropFilter: "blur(8px)",
                                            WebkitBackdropFilter: "blur(8px)", // for Safari
                                            // border: "1px solid rgba(68, 157, 212, 0.3)",
                                            border: "1px solid rgba(255,255,255,0.1)",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            flexWrap: "wrap",
                                            gap: 1,
                                        }}
                                    >
                                        <Stack direction="column" spacing={1} alignItems="left">
                                            {/* <Box
                                                sx={{
                                                    width: 8,
                                                    height: 8,
                                                    borderRadius: "50%",
                                                    background: "#9aa0b4",
                                                    boxShadow: "0 0 6px #9aa0b4",
                                                    flexShrink: 0,
                                                }}
                                            /> */}
                                            {/* <InfoOutlinedIcon sx={{ color: '#4BA5EB' }} /> */}
                                            <Typography fontFamily={interFont} fontSize={13} color="#FFFFFF" fontWeight={600}>
                                                Need help?
                                            </Typography>
                                            <Typography fontFamily={interFont} fontSize={12} color="#D9D9D9">
                                                Not sure what to upload and how it works? Check out our guide or contact support.
                                            </Typography>
                                        </Stack>

                                        <Stack direction="row" spacing={1} alignItems="right" display={'none'}>
                                            <Button
                                                size="small"
                                                startIcon={<ImportContactsOutlinedIcon sx={{ fontSize: 15, color: '#4BA5EB' }} />}
                                                /* onClick={() => {
                                                    setShowingDummy(false);
                                                    localStorage.setItem("mockDataCleared", "true");
                                                }} */
                                                sx={{
                                                    textTransform: "none",
                                                    fontFamily: interFont,
                                                    fontSize: 12,
                                                    fontWeight: 600,
                                                    color: "#4BA5EB",
                                                    // background: "#4BA5EB",
                                                    // border: "1px solid rgba(68, 157, 212, 0.3)",
                                                    border: "1px solid #4BA5EB",
                                                    borderRadius: "5px",
                                                    px: 1.8,
                                                    py: 0.5,
                                                    "&:hover": { background: "rgba(68, 157, 212, 0.3)" },
                                                }}
                                            >
                                                View Guide
                                            </Button>
                                            <Button
                                                size="small"
                                                startIcon={<EmailOutlinedIcon sx={{ fontSize: 15, color: '#4BA5EB' }} />}
                                                /* onClick={() => {
                                                    setShowingDummy(false);
                                                    localStorage.setItem("mockDataCleared", "true");
                                                }} */
                                                sx={{
                                                    textTransform: "none",
                                                    fontFamily: interFont,
                                                    fontSize: 12,
                                                    fontWeight: 600,
                                                    color: "#4BA5EB",
                                                    // background: "#4BA5EB",
                                                    // border: "1px solid rgba(68, 157, 212, 0.3)",
                                                    border: "1px solid #4BA5EB",
                                                    borderRadius: "5px",
                                                    px: 1.8,
                                                    py: 0.5,
                                                    "&:hover": { background: "rgba(68, 157, 212, 0.3)" },
                                                }}
                                            >
                                                Contact Support
                                            </Button>
                                        </Stack>
                                    </Box>
                                </Stack>

                                <div style={{ marginTop: '2%', display: 'flex', justifyContent: 'right' }}>
                                    <Button variant="outlined" onClick={() => {
                                        localStorage.setItem('activeItem', 'course');
                                        // navigate('/codegenie/generated-blogs');
                                        navigate('/codegenie/generated-courses');
                                        localStorage.removeItem('campaignid');
                                        localStorage.removeItem('returningtocampaign');
                                        localStorage.removeItem('sourceurl');
                                        localStorage.removeItem('campaignName');
                                        localStorage.removeItem('paymentOption');
                                        localStorage.removeItem('autoPublish');
                                        localStorage.removeItem('limitPublish');
                                        localStorage.removeItem('smUrlpublish');
                                        localStorage.removeItem('addTags');
                                        localStorage.removeItem('captureLeads');
                                        localStorage.removeItem('newsLetter');
                                        localStorage.removeItem('twitterBtn');
                                        localStorage.removeItem('fbBtn');
                                        localStorage.removeItem('pintrestBtn');
                                        localStorage.removeItem('linkedinBtn');
                                        localStorage.removeItem('video');
                                        localStorage.removeItem('twitterurl');
                                        localStorage.removeItem('fburl');
                                        localStorage.removeItem('pintresturl');
                                        localStorage.removeItem('linkedinurl');
                                        localStorage.removeItem('smUrlpublish');
                                        localStorage.removeItem('owndomain');
                                        localStorage.removeItem('ChangepayMode');
                                        localStorage.removeItem('IdChangingMode');
                                        localStorage.removeItem('PaymentSubscription');
                                        localStorage.removeItem('Authorurl');
                                        localStorage.removeItem('Authorname');
                                        localStorage.removeItem('authorDefaultCheck');
                                        localStorage.removeItem('videoTag');
                                        localStorage.removeItem('podcastUrl');
                                        localStorage.removeItem('sourcetext');
                                    }} sx={{ marginBottom: '3%', width: '8%', display: 'none' }}>Close</Button>&ensp;
                                    {/* {<Button variant="contained" onClick={() => {
                                        console.log('Handling create campaign...');
                                        handleCreateCourseStepPrevious();

                                    }} style={{ height: '45px', filter: isUploadLoading ? 'blur(2px)' : 'none', pointerEvents: isUploadLoading ? 'none' : 'auto' }} >{isUpdateLoader || isScrapcheckloading ? <CircularProgress size={24} style={{ color: '#fff' }} /> : planDetails?.payment_status === 'pending' ? 'Complete Payment' : FromEdit === 'startEditing' || localStorage.getItem('ChangepayMode') === 'true' ? 'Previous' : 'Previous'}</Button>} */}
                                    &ensp;
                                    <Button
                                        variant="contained"
                                        onClick={() => {
                                            console.log('Handling create campaign...');
                                            if (audioRef.current) {
                                                audioRef.current.pause();
                                                audioRef.current.currentTime = 0;
                                            }
                                            handleCreateCourseStep2();
                                        }}
                                        disabled={isProcessing || isUpdateLoader || isupdating || isScrapcheckloading}
                                        style={{
                                            height: '45px',
                                            filter: isUploadLoading ? 'blur(2px)' : 'none',
                                            pointerEvents: isUploadLoading ? 'none' : 'auto',
                                            marginBottom: '3%',
                                            width: '8%',
                                            display: 'none'
                                        }}
                                    >
                                        {isProcessing ? (
                                            <Stack direction="row" alignItems="center" spacing={1}>
                                                <CircularProgress size={18} style={{ color: '#fff' }} />
                                                <span style={{ fontSize: 12 }}>Processing…</span>
                                            </Stack>
                                        ) : isUpdateLoader || isScrapcheckloading || isupdating ? (
                                            <CircularProgress size={24} style={{ color: '#fff' }} />
                                        ) : planDetails?.payment_status === 'pending' ? (
                                            'Complete Payment'
                                        ) : (
                                            'Save'
                                        )}
                                    </Button>

                                </div>


                            </div>
                        </div>
                    </div >
                </div>
            </div >

            <Modal
                open={openpaymentInstructModal}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "95%" : 600,
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        pt: 2,
                        px: 4,
                        pb: 3,
                    }}
                >
                    {/* <Typography sx={{ fontSize: '25px' }}>ThankYou!</Typography> */}
                    <PriorityHighIcon style={{ color: 'yellow', fontSize: '38px' }} />
                    <p id="child-modal-description" style={{ textAlign: 'center'/* , fontSize: 'xx-large', marginTop: '22px' */ }}>Please make a payment to complete your process.</p>
                    <Stack flexDirection="row">
                        <Button
                            onClick={handleModalPayNowClick}
                            variant="contained"
                            sx={{ mr: 2 }}
                        >
                            Pay Now
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal
                open={openGetPagesuccessModal}
                onClose={() => setOpenGetPageSuccessModal(false)}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "95%" : 600,
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        pt: 2,
                        px: 4,
                        pb: 3,
                    }}
                >
                    <TaskAltIcon style={{ color: 'green', fontSize: '40px' }} />
                    <p id="child-modal-description" style={{ textAlign: 'center' }}>We have generated your first blogs. We will automatically generate new blogs daily per your selected plan.  You can edit each blog from the My Blog page with the Edit button and Export the blogs to social media or blogging platforms with the Export button.  Use the Help button on each page to learn more.</p>
                    <Stack flexDirection="row">
                        {/* <Box sx={{ display: "inline-block", margin: "0 10px" }}>
              <Button variant="contained" onClick={() => navigate('/pricing')}>Go For Pricing</Button>
            </Box> */}

                        <Button
                            onClick={handleGetPageModalClose}
                            variant="contained"
                            sx={{ mr: 2 }}
                        >
                            Close
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal
                open={confirmCancelSubscription}
                onClose={() => setConfirmCancelSubscription(false)}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "95%" : 800,
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        pt: 2,
                        px: 4,
                        pb: 3,
                    }}
                >
                    <InfoIcon style={{ color: 'Orange', fontSize: '40px' }} />
                    <p id="child-modal-description" style={{ textAlign: 'center', color: '#fff' }}>When you cancel your subscription you are also canceling the hosting of your blog pages.  If you would like to keep this content, please copy the content to use on a different platform.  Once cancelled the content will be archived for 30 days then it will be deleted from the Traffic Monster servers and from Google Indexing.</p>
                    <Stack flexDirection="row" sx={{ gap: '10px', marginTop: '2%' }}>
                        {/* <Box sx={{ display: "inline-block", margin: "0 10px" }}>
              <Button variant="contained" onClick={() => navigate('/pricing')}>Go For Pricing</Button>
            </Box> */}
                        <Button
                            onClick={handleCancelSubscriptionClick}
                            variant="contained"
                            sx={{ /* mr: 2, */ fontWeight: 'bolder', fontSize: '17px' }}
                        >
                            {cancellingLoader ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Continue'}
                        </Button>
                        <Button
                            onClick={() => setConfirmCancelSubscription(false)}
                            variant="contained"
                            sx={{ /* mr: 2, */ fontWeight: 'bolder', fontSize: '17px' }}
                        >
                            Exit
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal
                open={upgradeModal}
                /* onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setHelperModal(false);
                    }
                }} */
                disableEscapeKeyDown
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "95%" : "40%",
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        pt: 2,
                        px: 4,
                        pb: 3,
                        borderRadius: '15px',
                        padding: '3%'
                    }}
                >
                    <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}><InfoIcon sx={{ color: '#ffcc00' }} /><br />
                        {((sourceUrl || userBusinessText) && blogcount > planDetails?.blog_count_balance) || ((sourceYoutubeUrl || uploadedvideopath) && blogcount > planDetails?.podcast_count_balance) ? 'Blog count exceeds your plan limit. Please upgrade your plan to continue.' : 'This feature is not included in your plan.  Please upgrade to have access to this feature.'}</Typography>

                    <Stack flexDirection="row" sx={{ display: 'flex', gap: '10px', marginTop: '1%' }}>

                        {/* <Button
                            variant="contained"
                            onClick={() => {
                                const value = {
                                    _id: "",
                                    product_name: "CodeGenie",
                                    product_module: genieSelector.module ? genieSelector.module : "",
                                    userid: "",
                                    productid: ""
                                };
                                getProduct(value);
                                localStorage.setItem('fromUpgrade', 'true');
                                navigate('/pricing');
                            }}>
                            Upgrade
                        </Button> */}

                        <Button
                            onClick={() => setUpgradeModal(false)}
                            variant="contained"
                        // sx={{ mr: 2, marginTop: '15%' }}
                        >
                            Close
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal
                open={helperPopup}
                /* onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        setHelperModal(false);
                    }
                }} */
                disableEscapeKeyDown
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{
                        position: "absolute" as "absolute",
                        top: "50%",
                        left: "50%",
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transform: "translate(-50%, -50%)",
                        width: isMobile ? "95%" : "70%",
                        bgcolor: "background.paper",
                        border: "2px solid #000",
                        boxShadow: 24,
                        pt: 2,
                        px: 4,
                        pb: 3,
                        borderRadius: '15px',
                        padding: '3%'
                    }}
                >
                    {/* <video
                        controls
                        style={{ width: '100%' }}
                        src={helpervideosrc}
                        autoPlay
                    /> */}
                    <iframe
                        width="100%"
                        height="500"
                        src={helpervideosrc}
                        title="Help Video"
                        frameBorder="0"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                    ></iframe>
                    <Stack flexDirection="row">
                        <Button
                            onClick={() => setHelperPopup(false)}
                            variant="contained"
                            sx={{ mr: 2, marginTop: '15%' }}
                        >
                            Close
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal open={topicsList}
                // onClose={() => setTopicsList(false)}
                aria-labelledby="modal-title"
                aria-describedby="modal-description">
                <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "70%", // Adjusted width for responsiveness
                    maxWidth: 1000,
                    bgcolor: "#36393F",
                    border: "none",
                    pt: 2,
                    px: 4,
                    pb: 3,
                    height: '85%',
                    maxHeight: '110vh',
                    overflow: 'auto',
                    borderRadius: '8px',
                    boxShadow: '0px 50px 50px rgba(0, 0, 0, 0.5)'
                }}>
                    <Stack width="100%">
                        <Grid container>
                            <Grid item xs={12} lg={12}>
                                <Typography variant='h5' fontWeight="bold" style={{ color: '#fff' }}>Blog Topics</Typography>
                                <Typography variant='h6' fontWeight="normal" style={{ color: '#fff' }}>Below are some suggested topics to write about. You can also give us a different topic below.  Our AI will write about this topic using the content you provided.
                                </Typography>
                            </Grid>
                        </Grid>
                        <Divider style={{ height: '2px', backgroundColor: '#CBCBCB', marginTop: '1%' }} />
                        <Box sx={{
                            maxHeight: '38vh',
                            overflowY: 'auto',
                            marginTop: '1%'
                        }}>
                            <RadioGroup value={selectedTopic} onChange={(e) => handleTopicSelect(e.target.value)}>
                                <Grid container spacing={1} mt={1} justifyContent="flex-start">
                                    {topics && topics?.map((topic: any, index: any) => (
                                        <Grid item xs={12} lg={12} style={{ padding: '0.5%', height: '50px' }} key={index}>
                                            <Button
                                                fullWidth
                                                color="primary"
                                                sx={{
                                                    textAlign: 'left',
                                                    bgcolor: selectedTopic === topic ? '#0168B5' : 'transparent',
                                                    color: selectedTopic === topic ? '#fff' : '#CBCBCB',
                                                    borderColor: '#CBCBCB',
                                                    '&:hover': { bgcolor: '#0168B5', color: '#fff' },
                                                    display: 'flex',
                                                    justifyContent: 'flex-start',
                                                    alignItems: 'center',
                                                    // minHeight: '30px'
                                                }}
                                                onClick={() => handleTopicSelect(topic)}
                                            >
                                                <Radio
                                                    checked={selectedTopic === topic}
                                                    value={topic}
                                                    sx={{ color: '#CBCBCB', '&.Mui-checked': { color: '#4BA5EB' } }}
                                                />
                                                {topic.replace(/-/g, ' ')}
                                            </Button>
                                        </Grid>
                                    ))}
                                </Grid>
                            </RadioGroup>
                        </Box>
                        <Divider style={{ height: '2px', backgroundColor: '#CBCBCB', marginTop: '1%' }} />
                        <Typography variant='h5' fontWeight="bold" style={{ color: '#fff', textAlign: 'center' }}>Or</Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            // label="Selected Topic"
                            value={selectedTopic}
                            onChange={(e) => setSelectedTopic(e.target.value)}
                            // InputProps={{ readOnly: true }}
                            sx={{ mt: 3, bgcolor: '#35353C', borderRadius: '5px' }}
                            placeholder="Input your topic here"
                        />
                        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
                            <Button
                                variant="contained"
                                // color="primary"
                                disabled={!selectedTopic}
                                // onClick={() => handleGetPageforCampaign(campaignId, selectedTopic)}
                                onClick={() => handleTopicConfirmation(selectedTopic, 10, campaignId)}
                                sx={{ color: '#fff' }}
                            >
                                {isKeywordLoader ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Continue'}
                            </Button>
                        </Stack>

                    </Stack>
                </Box>
            </Modal>

            <Modal open={keywordsList}
                // onClose={() => setTopicsList(false)}
                aria-labelledby="modal-title"
                aria-describedby="modal-description">
                <Box sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "70%",
                    maxWidth: 1000,
                    bgcolor: "#36393F",
                    border: "none",
                    pt: 2,
                    px: 4,
                    pb: 3,
                    height: '87%',
                    maxHeight: '110vh',
                    overflow: 'auto',
                    borderRadius: '8px',
                    boxShadow: '0px 50px 50px rgba(0, 0, 0, 0.5)'
                }}>
                    <Stack width="100%">
                        <Grid container>
                            <Grid item xs={12} lg={12}>
                                <Typography variant='h5' fontWeight="bold" style={{ color: '#fff' }}>Keyword Suggestions</Typography>
                                <Typography variant='h6' fontWeight="normal" style={{ color: '#fff' }}>Below are some keywords that we suggest could help you with traffic for your blog.   Pick one or add your own.  Keep in mind that the higher the potential traffic the more difficult it may be for your blog to rank high in google search results.
                                </Typography>
                            </Grid>
                        </Grid>
                        <Divider style={{ height: '2px', backgroundColor: '#CBCBCB', marginTop: '1%' }} />

                        <Box sx={{
                            maxHeight: '38vh',
                            overflowY: 'auto',
                            marginTop: '1%'
                        }}>
                            <RadioGroup value={selectedKeyword} onChange={(e) => handleKeywordSelect(e.target.value)}>
                                <Grid container spacing={1} mt={1} justifyContent="flex-start">
                                    {keywords && keywords.length > 0 ? (
                                        <Table sx={{ width: '100%', padding: '1%' }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: 'bold', color: '#fff', borderBottom: '1px solid #CBCBCB', background: '#4BA5EB' }}>Select</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold', color: '#fff', borderBottom: '1px solid #CBCBCB', background: '#4BA5EB' }}>Keyword</TableCell>
                                                    {/* <TableCell sx={{ fontWeight: 'bold', color: '#fff', borderBottom: '1px solid #CBCBCB', background: '#4BA5EB' }}>Potential Traffic</TableCell> */}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {keywords.map((keyword: any, index: any) => (
                                                    <TableRow key={index} sx={{ '&:hover': { bgcolor: '#0168B5', color: '#fff' }, bgcolor: selectedKeyword === keyword.keyword ? '#0168B5' : 'transparent' }}>
                                                        <TableCell sx={{ borderBottom: '1px solid #CBCBCB' }}>
                                                            <Radio
                                                                checked={selectedKeyword === keyword.keyword}
                                                                value={keyword.keyword}
                                                                onChange={() => handleKeywordSelect(keyword.keyword)}
                                                                sx={{ color: '#CBCBCB', '&.Mui-checked': { color: '#4BA5EB' } }}
                                                            />
                                                        </TableCell>
                                                        <TableCell sx={{ color: selectedKeyword === keyword.keyword ? '#fff' : '#CBCBCB', borderBottom: '1px solid #CBCBCB' }}>
                                                            {keyword.keyword}
                                                        </TableCell>
                                                        {/* <TableCell sx={{ color: selectedKeyword === keyword.keyword ? '#fff' : '#CBCBCB', borderBottom: '1px solid #CBCBCB' }}>
                                                            {keyword.potentical_traffic}
                                                        </TableCell> */}
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    ) : (
                                        <div className="alert alert-info" role="alert">
                                            Keyword search failed, Please try again.
                                        </div>
                                    )}

                                </Grid>
                            </RadioGroup>
                        </Box>
                        <Divider style={{ height: '2px', backgroundColor: '#CBCBCB', marginTop: '1%' }} />
                        <Typography variant='h5' fontWeight="bold" style={{ color: '#fff', textAlign: 'center' }}>Or</Typography>
                        <TextField
                            fullWidth
                            variant="outlined"
                            // label="Selected Topic"
                            value={selectedKeyword}
                            onChange={(e) => setSelectedKeyword(e.target.value)}
                            // InputProps={{ readOnly: true }}
                            sx={{ mt: 3, bgcolor: '#35353C', borderRadius: '5px' }}
                            placeholder="Input your keyword here"
                        />
                        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={3}>
                            <Button
                                variant="contained"
                                onClick={() => handleTopicConfirmation(selectedTopic, 10, campaignId)}
                                sx={{ color: '#fff' }}
                            >
                                {isKeywordLoader ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Retry'}
                            </Button>
                            <Button
                                variant="contained"
                                // color="primary"
                                disabled={!selectedKeyword}
                                sx={{ color: '#fff' }}
                                onClick={() => handleGetPageforCampaign(user_email, campaignId, selectedTopic, selectedKeyword)}
                            >
                                Confirm
                            </Button>
                        </Stack>

                    </Stack>
                </Box>
            </Modal>


            <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
                <DialogTitle>Delete content?</DialogTitle>

                <DialogContent>
                    <Typography>
                        Are you sure you want to delete this content? This action cannot be undone.
                    </Typography>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setConfirmOpen(false)}>
                        Cancel
                    </Button>

                    <Button
                        color="error"
                        variant="contained"
                        onClick={() => {
                            if (deleteArgs) {
                                handleDeleteContent(deleteArgs.contentType, deleteArgs.index);
                            }
                            setConfirmOpen(false);
                            setDeleteArgs(null);
                        }}
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

            {/* <Dialog
                open={autoPublishDialogOpen}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    sx: {
                        background:
                            "radial-gradient(circle at top, #183B6B 0%, #081A42 40%, #05122E 100%)",
                        border: "1px solid rgba(59,130,246,0.35)",
                        borderRadius: "24px",
                        color: "#fff",
                        overflow: "hidden",
                        boxShadow:
                            "0 20px 60px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.05)",
                        p: 1,
                    },
                }}
            >
                <DialogTitle sx={{ textAlign: "center", pb: 0 }}>
                    <Box
                        sx={{
                            width: 80,
                            height: 80,
                            mx: "auto",
                            mb: 2,
                            borderRadius: "50%",
                            background:
                                "linear-gradient(180deg, rgba(59,130,246,0.18), rgba(59,130,246,0.08))",
                            border: "1px solid rgba(59,130,246,0.25)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        🚀
                    </Box>

                    <Chip
                        label="AUTO PUBLISH"
                        sx={{
                            bgcolor: "rgba(37,99,235,0.15)",
                            color: "#4BA5EB",
                            border: "1px solid rgba(75,165,235,0.3)",
                            fontWeight: 600,
                            letterSpacing: "0.5px",
                            mb: 2,
                        }}
                    />

                    <Typography
                        sx={{
                            fontSize: "32px",
                            fontWeight: 700,
                            color: "#F8FAFC",
                        }}
                    >
                        Auto Publish Content
                    </Typography>
                </DialogTitle>

                <DialogContent sx={{ textAlign: "center", pt: 1 }}>
                    <Typography
                        sx={{
                            color: "rgba(255,255,255,0.7)",
                            fontSize: "16px",
                            lineHeight: 1.8,
                        }}
                    >
                        Do you want to automatically publish generated
                        <br />
                        videos, images, clips and podcasts after processing?
                    </Typography>
                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        pb: 3,
                        pt: 2,
                        justifyContent: "center",
                        gap: 2,
                    }}
                >
                    <Button
                        onClick={() => handleAutoPublishChoice(0)}
                        sx={{
                            minWidth: 120,
                            height: 48,
                            borderRadius: "14px",
                            border: "1px solid rgba(255,255,255,0.15)",
                            color: "#D1D5DB",
                            textTransform: "none",
                            fontWeight: 600,
                        }}
                    >
                        No
                    </Button>

                    <Button
                        onClick={() => handleAutoPublishChoice(1)}
                        sx={{
                            minWidth: 120,
                            height: 48,
                            borderRadius: "14px",
                            background:
                                "linear-gradient(90deg, #1976D2 0%, #4BA5EB 100%)",
                            color: "#fff",
                            fontWeight: 700,
                            textTransform: "none",
                            "&:hover": {
                                background:
                                    "linear-gradient(90deg, #1565C0 0%, #3F95DB 100%)",
                            },
                        }}
                    >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog> */}

            <Dialog
                open={autoPublishDialogOpen}
                // onClose={onClose}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: "20px",
                        background: "#0f172a",
                        color: "#fff",
                        textAlign: "center",
                        p: { xs: 2, sm: 3 },
                        overflow: "hidden",
                        border: "0.5px solid rgba(75,165,235,0.25)",
                        "&::before": {
                            content: '""',
                            position: "absolute",
                            top: "-60px",
                            left: "50%",
                            transform: "translateX(-50%)",
                            width: "180px",
                            height: "180px",
                            background:
                                "radial-gradient(circle, rgba(75,165,235,0.15) 0%, transparent 70%)",
                            pointerEvents: "none",
                        },
                    },
                }}
            >
                {/* Close button */}
                {/* <IconButton
                    onClick={onClose}
                    size="small"
                    aria-label="Close"
                    sx={{
                        position: "absolute",
                        top: 12,
                        right: 12,
                        width: 30,
                        height: 30,
                        border: "0.5px solid rgba(255,255,255,0.12)",
                        background: "rgba(255,255,255,0.06)",
                        color: "rgba(255,255,255,0.45)",
                        "&:hover": {
                            background: "rgba(255,255,255,0.12)",
                            color: "rgba(255,255,255,0.8)",
                        },
                    }}
                >
                    <CloseIcon sx={{ fontSize: 16 }} />
                </IconButton> */}

                <DialogContent sx={{ px: { xs: 1, sm: 2 }, pt: 2 }}>
                    {/* Rocket icon */}
                    <Box
                        sx={{
                            width: 72,
                            height: 72,
                            borderRadius: "50%",
                            background: "rgba(75,165,235,0.12)",
                            border: "1px solid rgba(75,165,235,0.25)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            mx: "auto",
                            mb: 2,
                            "@keyframes float": {
                                "0%, 100%": { transform: "translateY(0px)" },
                                "50%": { transform: "translateY(-6px)" },
                            },
                            animation: "float 3s ease-in-out infinite",
                        }}
                    >
                        <RocketLaunchIcon sx={{ fontSize: 32, color: "#4BA5EB" }} />
                    </Box>

                    {/* Badge */}
                    <Box
                        component="span"
                        sx={{
                            display: "inline-block",
                            fontSize: "11px",
                            fontWeight: 500,
                            letterSpacing: "0.08em",
                            textTransform: "uppercase",
                            color: "#4BA5EB",
                            background: "rgba(75,165,235,0.1)",
                            border: "0.5px solid rgba(75,165,235,0.3)",
                            borderRadius: "100px",
                            px: 1.5,
                            py: 0.5,
                            mb: 1.5,
                        }}
                    >
                        Auto Publish
                    </Box>

                    {/* Title */}
                    <Typography
                        sx={{
                            fontSize: { xs: "20px", sm: "24px" },
                            fontWeight: 600,
                            mb: 1.25,
                            color: "#f8fafc",
                            lineHeight: 1.3,
                            textAlign: "center",
                        }}
                    >
                        Publish to Your Profile Page?
                    </Typography>

                    {/* Description */}
                    <Typography
                        sx={{
                            fontSize: "14px",
                            color: "rgba(255,255,255,0.55)",
                            lineHeight: 1.7,
                            mb: 1.5,
                            px: 0.5,
                        }}
                    >
                        We'll automatically generate clips and images from your
                        video and publish them to your Profile Page.
                        <br />
                        <br />
                        This boosts your visibility with AI search engines like
                        ChatGPT, Google, and more.
                    </Typography>

                    {/* Settings note */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 0.75,
                            mb: 2.5,
                        }}
                    >
                        <VerifiedUserOutlinedIcon
                            sx={{ fontSize: 16, color: "#4BA5EB" }}
                        />
                        <Typography
                            sx={{
                                fontSize: "13px",
                                color: "rgba(255,255,255,0.5)",
                            }}
                        >
                            You can change this anytime in{" "}
                            <Box
                                component="span"
                                sx={{ color: "#4BA5EB", fontWeight: 500, cursor: "pointer" }}
                                onClick={() => {
                                    localStorage.setItem("activeItem", "settings");
                                    navigate(0);
                                }}
                            >
                                Settings
                            </Box>
                            .
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 2 }}>
                        {/* Button */}
                        <Button
                            fullWidth
                            onClick={() => handleAutoPublishChoice(0)}
                            // startIcon={<CheckIcon />}
                            sx={{
                                // background: "linear-gradient(135deg, #0168B5 0%, #4BA5EB 100%)",
                                color: "#fff",
                                borderRadius: "12px",
                                py: 1.4,
                                textTransform: "none",
                                fontWeight: 500,
                                fontSize: "15px",
                                letterSpacing: "0.01em",
                                transition: "opacity 0.2s, transform 0.15s",
                                "&:hover": {
                                    // background: "linear-gradient(135deg, #0168B5 0%, #4BA5EB 100%)",
                                    opacity: 0.88,
                                },
                                "&:active": {
                                    transform: "scale(0.98)",
                                },
                                border: '1px solid #4BA5EB'
                            }}
                        >
                            No, not now
                        </Button>
                        <Button
                            fullWidth
                            onClick={() => handleAutoPublishChoice(1)}
                            // startIcon={<CheckIcon />}
                            sx={{
                                background: "linear-gradient(135deg, #0168B5 0%, #4BA5EB 100%)",
                                color: "#fff",
                                borderRadius: "12px",
                                py: 1.4,
                                textTransform: "none",
                                fontWeight: 500,
                                fontSize: "15px",
                                letterSpacing: "0.01em",
                                transition: "opacity 0.2s, transform 0.15s",
                                "&:hover": {
                                    background: "linear-gradient(135deg, #0168B5 0%, #4BA5EB 100%)",
                                    opacity: 0.88,
                                },
                                "&:active": {
                                    transform: "scale(0.98)",
                                },
                            }}
                        >
                            Yes, publish automatically
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>

        </>
    )
}



export default DigitalTwinScreen;